/* tslint:disable */
/* eslint-disable */
// this is an auto generated file. This will be overwritten

import * as APITypes from "../API";
type GeneratedMutation<InputType, OutputType> = string & {
  __generatedMutationInput: InputType;
  __generatedMutationOutput: OutputType;
};

export const deleteLLMProject = /* GraphQL */ `mutation DeleteLLMProject(
  $input: DeleteLLMProjectInput!
  $condition: ModelLLMProjectConditionInput
) {
  deleteLLMProject(input: $input, condition: $condition) {
    id
    name
    status
    description
    users {
      items {
        id
        email
        status
        displayName
        acceptedTermsOfService
        acceptedGDPRTerms
        projectId
        project {
          id
          name
          status
          description
          stripeCustomerId
          newCustomerTokenCount
          cacheResponsesForSeconds
          loadSheddingTier
          newCustomerLoadSheddingTier
          maintenanceMode
          maintenanceModeMessage
          loadBalancingMode
          piiRedactionScope
          systemInstructions
          piiScope
          piiGroupId
          piiMessage
          promptBlacklist
          blacklistGroupId
          blacklistMessage
          safety
          safetyGroupId
          safetyMessage
          strongModelGroupId
          routeModel
          trialTokensRemaining
          logfileRetentionPeriod
          callRetentionPeriod
          logInterval
          lastLogGeneratedAt
          logGenerationCursor
          enterpriseAllowChat
          enterpriseAcceptableUsePolicy
          enterpriseAccessRequestEmail
          enterpriseSupportEmail
          enterpriseDomainWhitelist
          enterpriseTokenBudget
          enterpriseTokenBudgetPeriod
          enterpriseImageUrl
          randomGroup
          apiCreditRemaining
          createdAt
          summaryEmailPeriod
          summaryEmailAddresses
          lastSummaryEmailSentAt
          mcpServerWhitelist
          automaticModelManagement
          supersmallGroupModels
          standardGroupModels
          premiumGroupModels
          reasoningGroupModels
          superpremiumGroupModels
          openrouterStandardGroupModels
          openrouterPremiumGroupModels
          azureOpenaiBaseUrl
          azureOpenaiApiVersion
          awsBedrockRegion
          newCustomerUsageTierId
          usageTapUsageApiKey
          lowApiCreditNotificationEmails
          lowApiCreditNotificationMinimumCredit
          lastLowApiCreditNotificationSentAt
          integrationApiKey1Hash
          integrationApiKey1Status
          integrationApiKey1Prefix
          integrationApiKey1LastRotatedAt
          integrationApiKey1Scopes
          integrationApiKey2Hash
          integrationApiKey2Status
          integrationApiKey2Prefix
          integrationApiKey2LastRotatedAt
          integrationApiKey2Scopes
          updatedAt
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
    services {
      items {
        id
        name
        status
        vendor
        region
        endpoint
        body
        header
        projectId
        loadProportion
        inputTokenPricePerMillion
        outputTokenPricePerMillion
        groupId
        group {
          id
          status
          name
          description
          projectId
          systemInstructions
          systemInstructionsAction
          order
          createdAt
          updatedAt
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
    stripeCustomerId
    subscription {
      id
      projectId
      quantity
      subscriptionId
      subscriptionStartDate
      subscriptionEndDate
      subscriptionStatus
      subscriptionProduct
      subscriptionInterval
      subscriptionEndedAt
      subscriptionCancelAtPeriodEnd
      usageSubscriptionId
      createdAt
      updatedAt
      __typename
    }
    newCustomerTokenCount
    cacheResponsesForSeconds
    loadSheddingTier
    newCustomerLoadSheddingTier
    maintenanceMode
    maintenanceModeMessage
    loadBalancingMode
    piiRedactionScope
    systemInstructions
    piiScope
    piiGroupId
    piiMessage
    promptBlacklist
    blacklistGroupId
    blacklistMessage
    safety
    safetyGroupId
    safetyMessage
    strongModelGroupId
    routeModel
    trialTokensRemaining
    logfileRetentionPeriod
    callRetentionPeriod
    logInterval
    lastLogGeneratedAt
    logGenerationCursor
    enterpriseAllowChat
    enterpriseAcceptableUsePolicy
    enterpriseAccessRequestEmail
    enterpriseSupportEmail
    enterpriseDomainWhitelist
    enterpriseTokenBudget
    enterpriseTokenBudgetPeriod
    enterpriseImageUrl
    randomGroup
    apiCreditRemaining
    createdAt
    summaryEmailPeriod
    summaryEmailAddresses
    lastSummaryEmailSentAt
    mcpServerWhitelist
    automaticModelManagement
    supersmallGroupModels
    standardGroupModels
    premiumGroupModels
    reasoningGroupModels
    superpremiumGroupModels
    openrouterStandardGroupModels
    openrouterPremiumGroupModels
    azureOpenaiBaseUrl
    azureOpenaiApiVersion
    awsBedrockRegion
    newCustomerUsageTierId
    newCustomerUsageTier {
      id
      projectId
      status
      name
      description
      version
      activeAt
      inactiveAt
      priorUsageTierId
      priorUsageTier {
        id
        projectId
        status
        name
        description
        version
        activeAt
        inactiveAt
        priorUsageTierId
        priorUsageTier {
          id
          projectId
          status
          name
          description
          version
          activeAt
          inactiveAt
          priorUsageTierId
          baseUsageTierId
          replenishmentPeriod
          replenishmentMethod
          usageLimitAction
          standardTokenReplenishmentAmount
          premiumTokenReplenishmentAmount
          superPremiumTokenReplenishmentAmount
          reasoningTokenReplenishmentAmount
          standardCallReplenishmentAmount
          premiumCallReplenishmentAmount
          superPremiumCallReplenishmentAmount
          reasoningCallReplenishmentAmount
          standardTokenUnlimited
          premiumTokenUnlimited
          superPremiumTokenUnlimited
          reasoningTokenUnlimited
          standardCallUnlimited
          premiumCallUnlimited
          superPremiumCallUnlimited
          reasoningCallUnlimited
          createdAt
          updatedAt
          __typename
        }
        baseUsageTierId
        baseUsageTier {
          id
          projectId
          status
          name
          description
          version
          activeAt
          inactiveAt
          priorUsageTierId
          baseUsageTierId
          replenishmentPeriod
          replenishmentMethod
          usageLimitAction
          standardTokenReplenishmentAmount
          premiumTokenReplenishmentAmount
          superPremiumTokenReplenishmentAmount
          reasoningTokenReplenishmentAmount
          standardCallReplenishmentAmount
          premiumCallReplenishmentAmount
          superPremiumCallReplenishmentAmount
          reasoningCallReplenishmentAmount
          standardTokenUnlimited
          premiumTokenUnlimited
          superPremiumTokenUnlimited
          reasoningTokenUnlimited
          standardCallUnlimited
          premiumCallUnlimited
          superPremiumCallUnlimited
          reasoningCallUnlimited
          createdAt
          updatedAt
          __typename
        }
        replenishmentPeriod
        replenishmentMethod
        usageLimitAction
        standardTokenReplenishmentAmount
        premiumTokenReplenishmentAmount
        superPremiumTokenReplenishmentAmount
        reasoningTokenReplenishmentAmount
        standardCallReplenishmentAmount
        premiumCallReplenishmentAmount
        superPremiumCallReplenishmentAmount
        reasoningCallReplenishmentAmount
        standardTokenUnlimited
        premiumTokenUnlimited
        superPremiumTokenUnlimited
        reasoningTokenUnlimited
        standardCallUnlimited
        premiumCallUnlimited
        superPremiumCallUnlimited
        reasoningCallUnlimited
        createdAt
        updatedAt
        __typename
      }
      baseUsageTierId
      baseUsageTier {
        id
        projectId
        status
        name
        description
        version
        activeAt
        inactiveAt
        priorUsageTierId
        priorUsageTier {
          id
          projectId
          status
          name
          description
          version
          activeAt
          inactiveAt
          priorUsageTierId
          baseUsageTierId
          replenishmentPeriod
          replenishmentMethod
          usageLimitAction
          standardTokenReplenishmentAmount
          premiumTokenReplenishmentAmount
          superPremiumTokenReplenishmentAmount
          reasoningTokenReplenishmentAmount
          standardCallReplenishmentAmount
          premiumCallReplenishmentAmount
          superPremiumCallReplenishmentAmount
          reasoningCallReplenishmentAmount
          standardTokenUnlimited
          premiumTokenUnlimited
          superPremiumTokenUnlimited
          reasoningTokenUnlimited
          standardCallUnlimited
          premiumCallUnlimited
          superPremiumCallUnlimited
          reasoningCallUnlimited
          createdAt
          updatedAt
          __typename
        }
        baseUsageTierId
        baseUsageTier {
          id
          projectId
          status
          name
          description
          version
          activeAt
          inactiveAt
          priorUsageTierId
          baseUsageTierId
          replenishmentPeriod
          replenishmentMethod
          usageLimitAction
          standardTokenReplenishmentAmount
          premiumTokenReplenishmentAmount
          superPremiumTokenReplenishmentAmount
          reasoningTokenReplenishmentAmount
          standardCallReplenishmentAmount
          premiumCallReplenishmentAmount
          superPremiumCallReplenishmentAmount
          reasoningCallReplenishmentAmount
          standardTokenUnlimited
          premiumTokenUnlimited
          superPremiumTokenUnlimited
          reasoningTokenUnlimited
          standardCallUnlimited
          premiumCallUnlimited
          superPremiumCallUnlimited
          reasoningCallUnlimited
          createdAt
          updatedAt
          __typename
        }
        replenishmentPeriod
        replenishmentMethod
        usageLimitAction
        standardTokenReplenishmentAmount
        premiumTokenReplenishmentAmount
        superPremiumTokenReplenishmentAmount
        reasoningTokenReplenishmentAmount
        standardCallReplenishmentAmount
        premiumCallReplenishmentAmount
        superPremiumCallReplenishmentAmount
        reasoningCallReplenishmentAmount
        standardTokenUnlimited
        premiumTokenUnlimited
        superPremiumTokenUnlimited
        reasoningTokenUnlimited
        standardCallUnlimited
        premiumCallUnlimited
        superPremiumCallUnlimited
        reasoningCallUnlimited
        createdAt
        updatedAt
        __typename
      }
      replenishmentPeriod
      replenishmentMethod
      usageLimitAction
      standardTokenReplenishmentAmount
      premiumTokenReplenishmentAmount
      superPremiumTokenReplenishmentAmount
      reasoningTokenReplenishmentAmount
      standardCallReplenishmentAmount
      premiumCallReplenishmentAmount
      superPremiumCallReplenishmentAmount
      reasoningCallReplenishmentAmount
      standardTokenUnlimited
      premiumTokenUnlimited
      superPremiumTokenUnlimited
      reasoningTokenUnlimited
      standardCallUnlimited
      premiumCallUnlimited
      superPremiumCallUnlimited
      reasoningCallUnlimited
      createdAt
      updatedAt
      __typename
    }
    usageTapUsageApiKey
    lowApiCreditNotificationEmails
    lowApiCreditNotificationMinimumCredit
    lastLowApiCreditNotificationSentAt
    integrationApiKey1Hash
    integrationApiKey1Status
    integrationApiKey1Prefix
    integrationApiKey1LastRotatedAt
    integrationApiKey1Scopes
    integrationApiKey2Hash
    integrationApiKey2Status
    integrationApiKey2Prefix
    integrationApiKey2LastRotatedAt
    integrationApiKey2Scopes
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteLLMProjectMutationVariables,
  APITypes.DeleteLLMProjectMutation
>;
export const deleteLLMBatch = /* GraphQL */ `mutation DeleteLLMBatch(
  $input: DeleteLLMBatchInput!
  $condition: ModelLLMBatchConditionInput
) {
  deleteLLMBatch(input: $input, condition: $condition) {
    id
    projectId
    status
    vendor
    vendorBatchId
    vendorInputFileId
    vendorOutputFileId
    vendorErrorFileId
    requestCount
    completedCount
    failedCount
    nextPollAt
    callbackUrl
    callbackSecret
    callbackStatus
    callbackAttempts
    callbackLastError
    idempotencyKeyHash
    requestHash
    error
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteLLMBatchMutationVariables,
  APITypes.DeleteLLMBatchMutation
>;
export const createLLMProject = /* GraphQL */ `mutation CreateLLMProject(
  $input: CreateLLMProjectInput!
  $condition: ModelLLMProjectConditionInput
) {
  createLLMProject(input: $input, condition: $condition) {
    id
    name
    status
    description
    users {
      items {
        id
        email
        status
        displayName
        acceptedTermsOfService
        acceptedGDPRTerms
        projectId
        project {
          id
          name
          status
          description
          stripeCustomerId
          newCustomerTokenCount
          cacheResponsesForSeconds
          loadSheddingTier
          newCustomerLoadSheddingTier
          maintenanceMode
          maintenanceModeMessage
          loadBalancingMode
          piiRedactionScope
          systemInstructions
          piiScope
          piiGroupId
          piiMessage
          promptBlacklist
          blacklistGroupId
          blacklistMessage
          safety
          safetyGroupId
          safetyMessage
          strongModelGroupId
          routeModel
          trialTokensRemaining
          logfileRetentionPeriod
          callRetentionPeriod
          logInterval
          lastLogGeneratedAt
          logGenerationCursor
          enterpriseAllowChat
          enterpriseAcceptableUsePolicy
          enterpriseAccessRequestEmail
          enterpriseSupportEmail
          enterpriseDomainWhitelist
          enterpriseTokenBudget
          enterpriseTokenBudgetPeriod
          enterpriseImageUrl
          randomGroup
          apiCreditRemaining
          createdAt
          summaryEmailPeriod
          summaryEmailAddresses
          lastSummaryEmailSentAt
          mcpServerWhitelist
          automaticModelManagement
          supersmallGroupModels
          standardGroupModels
          premiumGroupModels
          reasoningGroupModels
          superpremiumGroupModels
          openrouterStandardGroupModels
          openrouterPremiumGroupModels
          azureOpenaiBaseUrl
          azureOpenaiApiVersion
          awsBedrockRegion
          newCustomerUsageTierId
          usageTapUsageApiKey
          lowApiCreditNotificationEmails
          lowApiCreditNotificationMinimumCredit
          lastLowApiCreditNotificationSentAt
          integrationApiKey1Hash
          integrationApiKey1Status
          integrationApiKey1Prefix
          integrationApiKey1LastRotatedAt
          integrationApiKey1Scopes
          integrationApiKey2Hash
          integrationApiKey2Status
          integrationApiKey2Prefix
          integrationApiKey2LastRotatedAt
          integrationApiKey2Scopes
          updatedAt
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
    services {
      items {
        id
        name
        status
        vendor
        region
        endpoint
        body
        header
        projectId
        loadProportion
        inputTokenPricePerMillion
        outputTokenPricePerMillion
        groupId
        group {
          id
          status
          name
          description
          projectId
          systemInstructions
          systemInstructionsAction
          order
          createdAt
          updatedAt
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
    stripeCustomerId
    subscription {
      id
      projectId
      quantity
      subscriptionId
      subscriptionStartDate
      subscriptionEndDate
      subscriptionStatus
      subscriptionProduct
      subscriptionInterval
      subscriptionEndedAt
      subscriptionCancelAtPeriodEnd
      usageSubscriptionId
      createdAt
      updatedAt
      __typename
    }
    newCustomerTokenCount
    cacheResponsesForSeconds
    loadSheddingTier
    newCustomerLoadSheddingTier
    maintenanceMode
    maintenanceModeMessage
    loadBalancingMode
    piiRedactionScope
    systemInstructions
    piiScope
    piiGroupId
    piiMessage
    promptBlacklist
    blacklistGroupId
    blacklistMessage
    safety
    safetyGroupId
    safetyMessage
    strongModelGroupId
    routeModel
    trialTokensRemaining
    logfileRetentionPeriod
    callRetentionPeriod
    logInterval
    lastLogGeneratedAt
    logGenerationCursor
    enterpriseAllowChat
    enterpriseAcceptableUsePolicy
    enterpriseAccessRequestEmail
    enterpriseSupportEmail
    enterpriseDomainWhitelist
    enterpriseTokenBudget
    enterpriseTokenBudgetPeriod
    enterpriseImageUrl
    randomGroup
    apiCreditRemaining
    createdAt
    summaryEmailPeriod
    summaryEmailAddresses
    lastSummaryEmailSentAt
    mcpServerWhitelist
    automaticModelManagement
    supersmallGroupModels
    standardGroupModels
    premiumGroupModels
    reasoningGroupModels
    superpremiumGroupModels
    openrouterStandardGroupModels
    openrouterPremiumGroupModels
    azureOpenaiBaseUrl
    azureOpenaiApiVersion
    awsBedrockRegion
    newCustomerUsageTierId
    newCustomerUsageTier {
      id
      projectId
      status
      name
      description
      version
      activeAt
      inactiveAt
      priorUsageTierId
      priorUsageTier {
        id
        projectId
        status
        name
        description
        version
        activeAt
        inactiveAt
        priorUsageTierId
        priorUsageTier {
          id
          projectId
          status
          name
          description
          version
          activeAt
          inactiveAt
          priorUsageTierId
          baseUsageTierId
          replenishmentPeriod
          replenishmentMethod
          usageLimitAction
          standardTokenReplenishmentAmount
          premiumTokenReplenishmentAmount
          superPremiumTokenReplenishmentAmount
          reasoningTokenReplenishmentAmount
          standardCallReplenishmentAmount
          premiumCallReplenishmentAmount
          superPremiumCallReplenishmentAmount
          reasoningCallReplenishmentAmount
          standardTokenUnlimited
          premiumTokenUnlimited
          superPremiumTokenUnlimited
          reasoningTokenUnlimited
          standardCallUnlimited
          premiumCallUnlimited
          superPremiumCallUnlimited
          reasoningCallUnlimited
          createdAt
          updatedAt
          __typename
        }
        baseUsageTierId
        baseUsageTier {
          id
          projectId
          status
          name
          description
          version
          activeAt
          inactiveAt
          priorUsageTierId
          baseUsageTierId
          replenishmentPeriod
          replenishmentMethod
          usageLimitAction
          standardTokenReplenishmentAmount
          premiumTokenReplenishmentAmount
          superPremiumTokenReplenishmentAmount
          reasoningTokenReplenishmentAmount
          standardCallReplenishmentAmount
          premiumCallReplenishmentAmount
          superPremiumCallReplenishmentAmount
          reasoningCallReplenishmentAmount
          standardTokenUnlimited
          premiumTokenUnlimited
          superPremiumTokenUnlimited
          reasoningTokenUnlimited
          standardCallUnlimited
          premiumCallUnlimited
          superPremiumCallUnlimited
          reasoningCallUnlimited
          createdAt
          updatedAt
          __typename
        }
        replenishmentPeriod
        replenishmentMethod
        usageLimitAction
        standardTokenReplenishmentAmount
        premiumTokenReplenishmentAmount
        superPremiumTokenReplenishmentAmount
        reasoningTokenReplenishmentAmount
        standardCallReplenishmentAmount
        premiumCallReplenishmentAmount
        superPremiumCallReplenishmentAmount
        reasoningCallReplenishmentAmount
        standardTokenUnlimited
        premiumTokenUnlimited
        superPremiumTokenUnlimited
        reasoningTokenUnlimited
        standardCallUnlimited
        premiumCallUnlimited
        superPremiumCallUnlimited
        reasoningCallUnlimited
        createdAt
        updatedAt
        __typename
      }
      baseUsageTierId
      baseUsageTier {
        id
        projectId
        status
        name
        description
        version
        activeAt
        inactiveAt
        priorUsageTierId
        priorUsageTier {
          id
          projectId
          status
          name
          description
          version
          activeAt
          inactiveAt
          priorUsageTierId
          baseUsageTierId
          replenishmentPeriod
          replenishmentMethod
          usageLimitAction
          standardTokenReplenishmentAmount
          premiumTokenReplenishmentAmount
          superPremiumTokenReplenishmentAmount
          reasoningTokenReplenishmentAmount
          standardCallReplenishmentAmount
          premiumCallReplenishmentAmount
          superPremiumCallReplenishmentAmount
          reasoningCallReplenishmentAmount
          standardTokenUnlimited
          premiumTokenUnlimited
          superPremiumTokenUnlimited
          reasoningTokenUnlimited
          standardCallUnlimited
          premiumCallUnlimited
          superPremiumCallUnlimited
          reasoningCallUnlimited
          createdAt
          updatedAt
          __typename
        }
        baseUsageTierId
        baseUsageTier {
          id
          projectId
          status
          name
          description
          version
          activeAt
          inactiveAt
          priorUsageTierId
          baseUsageTierId
          replenishmentPeriod
          replenishmentMethod
          usageLimitAction
          standardTokenReplenishmentAmount
          premiumTokenReplenishmentAmount
          superPremiumTokenReplenishmentAmount
          reasoningTokenReplenishmentAmount
          standardCallReplenishmentAmount
          premiumCallReplenishmentAmount
          superPremiumCallReplenishmentAmount
          reasoningCallReplenishmentAmount
          standardTokenUnlimited
          premiumTokenUnlimited
          superPremiumTokenUnlimited
          reasoningTokenUnlimited
          standardCallUnlimited
          premiumCallUnlimited
          superPremiumCallUnlimited
          reasoningCallUnlimited
          createdAt
          updatedAt
          __typename
        }
        replenishmentPeriod
        replenishmentMethod
        usageLimitAction
        standardTokenReplenishmentAmount
        premiumTokenReplenishmentAmount
        superPremiumTokenReplenishmentAmount
        reasoningTokenReplenishmentAmount
        standardCallReplenishmentAmount
        premiumCallReplenishmentAmount
        superPremiumCallReplenishmentAmount
        reasoningCallReplenishmentAmount
        standardTokenUnlimited
        premiumTokenUnlimited
        superPremiumTokenUnlimited
        reasoningTokenUnlimited
        standardCallUnlimited
        premiumCallUnlimited
        superPremiumCallUnlimited
        reasoningCallUnlimited
        createdAt
        updatedAt
        __typename
      }
      replenishmentPeriod
      replenishmentMethod
      usageLimitAction
      standardTokenReplenishmentAmount
      premiumTokenReplenishmentAmount
      superPremiumTokenReplenishmentAmount
      reasoningTokenReplenishmentAmount
      standardCallReplenishmentAmount
      premiumCallReplenishmentAmount
      superPremiumCallReplenishmentAmount
      reasoningCallReplenishmentAmount
      standardTokenUnlimited
      premiumTokenUnlimited
      superPremiumTokenUnlimited
      reasoningTokenUnlimited
      standardCallUnlimited
      premiumCallUnlimited
      superPremiumCallUnlimited
      reasoningCallUnlimited
      createdAt
      updatedAt
      __typename
    }
    usageTapUsageApiKey
    lowApiCreditNotificationEmails
    lowApiCreditNotificationMinimumCredit
    lastLowApiCreditNotificationSentAt
    integrationApiKey1Hash
    integrationApiKey1Status
    integrationApiKey1Prefix
    integrationApiKey1LastRotatedAt
    integrationApiKey1Scopes
    integrationApiKey2Hash
    integrationApiKey2Status
    integrationApiKey2Prefix
    integrationApiKey2LastRotatedAt
    integrationApiKey2Scopes
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateLLMProjectMutationVariables,
  APITypes.CreateLLMProjectMutation
>;
export const updateLLMProject = /* GraphQL */ `mutation UpdateLLMProject(
  $input: UpdateLLMProjectInput!
  $condition: ModelLLMProjectConditionInput
) {
  updateLLMProject(input: $input, condition: $condition) {
    id
    name
    status
    description
    users {
      items {
        id
        email
        status
        displayName
        acceptedTermsOfService
        acceptedGDPRTerms
        projectId
        project {
          id
          name
          status
          description
          stripeCustomerId
          newCustomerTokenCount
          cacheResponsesForSeconds
          loadSheddingTier
          newCustomerLoadSheddingTier
          maintenanceMode
          maintenanceModeMessage
          loadBalancingMode
          piiRedactionScope
          systemInstructions
          piiScope
          piiGroupId
          piiMessage
          promptBlacklist
          blacklistGroupId
          blacklistMessage
          safety
          safetyGroupId
          safetyMessage
          strongModelGroupId
          routeModel
          trialTokensRemaining
          logfileRetentionPeriod
          callRetentionPeriod
          logInterval
          lastLogGeneratedAt
          logGenerationCursor
          enterpriseAllowChat
          enterpriseAcceptableUsePolicy
          enterpriseAccessRequestEmail
          enterpriseSupportEmail
          enterpriseDomainWhitelist
          enterpriseTokenBudget
          enterpriseTokenBudgetPeriod
          enterpriseImageUrl
          randomGroup
          apiCreditRemaining
          createdAt
          summaryEmailPeriod
          summaryEmailAddresses
          lastSummaryEmailSentAt
          mcpServerWhitelist
          automaticModelManagement
          supersmallGroupModels
          standardGroupModels
          premiumGroupModels
          reasoningGroupModels
          superpremiumGroupModels
          openrouterStandardGroupModels
          openrouterPremiumGroupModels
          azureOpenaiBaseUrl
          azureOpenaiApiVersion
          awsBedrockRegion
          newCustomerUsageTierId
          usageTapUsageApiKey
          lowApiCreditNotificationEmails
          lowApiCreditNotificationMinimumCredit
          lastLowApiCreditNotificationSentAt
          integrationApiKey1Hash
          integrationApiKey1Status
          integrationApiKey1Prefix
          integrationApiKey1LastRotatedAt
          integrationApiKey1Scopes
          integrationApiKey2Hash
          integrationApiKey2Status
          integrationApiKey2Prefix
          integrationApiKey2LastRotatedAt
          integrationApiKey2Scopes
          updatedAt
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
    services {
      items {
        id
        name
        status
        vendor
        region
        endpoint
        body
        header
        projectId
        loadProportion
        inputTokenPricePerMillion
        outputTokenPricePerMillion
        groupId
        group {
          id
          status
          name
          description
          projectId
          systemInstructions
          systemInstructionsAction
          order
          createdAt
          updatedAt
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
    stripeCustomerId
    subscription {
      id
      projectId
      quantity
      subscriptionId
      subscriptionStartDate
      subscriptionEndDate
      subscriptionStatus
      subscriptionProduct
      subscriptionInterval
      subscriptionEndedAt
      subscriptionCancelAtPeriodEnd
      usageSubscriptionId
      createdAt
      updatedAt
      __typename
    }
    newCustomerTokenCount
    cacheResponsesForSeconds
    loadSheddingTier
    newCustomerLoadSheddingTier
    maintenanceMode
    maintenanceModeMessage
    loadBalancingMode
    piiRedactionScope
    systemInstructions
    piiScope
    piiGroupId
    piiMessage
    promptBlacklist
    blacklistGroupId
    blacklistMessage
    safety
    safetyGroupId
    safetyMessage
    strongModelGroupId
    routeModel
    trialTokensRemaining
    logfileRetentionPeriod
    callRetentionPeriod
    logInterval
    lastLogGeneratedAt
    logGenerationCursor
    enterpriseAllowChat
    enterpriseAcceptableUsePolicy
    enterpriseAccessRequestEmail
    enterpriseSupportEmail
    enterpriseDomainWhitelist
    enterpriseTokenBudget
    enterpriseTokenBudgetPeriod
    enterpriseImageUrl
    randomGroup
    apiCreditRemaining
    createdAt
    summaryEmailPeriod
    summaryEmailAddresses
    lastSummaryEmailSentAt
    mcpServerWhitelist
    automaticModelManagement
    supersmallGroupModels
    standardGroupModels
    premiumGroupModels
    reasoningGroupModels
    superpremiumGroupModels
    openrouterStandardGroupModels
    openrouterPremiumGroupModels
    azureOpenaiBaseUrl
    azureOpenaiApiVersion
    awsBedrockRegion
    newCustomerUsageTierId
    newCustomerUsageTier {
      id
      projectId
      status
      name
      description
      version
      activeAt
      inactiveAt
      priorUsageTierId
      priorUsageTier {
        id
        projectId
        status
        name
        description
        version
        activeAt
        inactiveAt
        priorUsageTierId
        priorUsageTier {
          id
          projectId
          status
          name
          description
          version
          activeAt
          inactiveAt
          priorUsageTierId
          baseUsageTierId
          replenishmentPeriod
          replenishmentMethod
          usageLimitAction
          standardTokenReplenishmentAmount
          premiumTokenReplenishmentAmount
          superPremiumTokenReplenishmentAmount
          reasoningTokenReplenishmentAmount
          standardCallReplenishmentAmount
          premiumCallReplenishmentAmount
          superPremiumCallReplenishmentAmount
          reasoningCallReplenishmentAmount
          standardTokenUnlimited
          premiumTokenUnlimited
          superPremiumTokenUnlimited
          reasoningTokenUnlimited
          standardCallUnlimited
          premiumCallUnlimited
          superPremiumCallUnlimited
          reasoningCallUnlimited
          createdAt
          updatedAt
          __typename
        }
        baseUsageTierId
        baseUsageTier {
          id
          projectId
          status
          name
          description
          version
          activeAt
          inactiveAt
          priorUsageTierId
          baseUsageTierId
          replenishmentPeriod
          replenishmentMethod
          usageLimitAction
          standardTokenReplenishmentAmount
          premiumTokenReplenishmentAmount
          superPremiumTokenReplenishmentAmount
          reasoningTokenReplenishmentAmount
          standardCallReplenishmentAmount
          premiumCallReplenishmentAmount
          superPremiumCallReplenishmentAmount
          reasoningCallReplenishmentAmount
          standardTokenUnlimited
          premiumTokenUnlimited
          superPremiumTokenUnlimited
          reasoningTokenUnlimited
          standardCallUnlimited
          premiumCallUnlimited
          superPremiumCallUnlimited
          reasoningCallUnlimited
          createdAt
          updatedAt
          __typename
        }
        replenishmentPeriod
        replenishmentMethod
        usageLimitAction
        standardTokenReplenishmentAmount
        premiumTokenReplenishmentAmount
        superPremiumTokenReplenishmentAmount
        reasoningTokenReplenishmentAmount
        standardCallReplenishmentAmount
        premiumCallReplenishmentAmount
        superPremiumCallReplenishmentAmount
        reasoningCallReplenishmentAmount
        standardTokenUnlimited
        premiumTokenUnlimited
        superPremiumTokenUnlimited
        reasoningTokenUnlimited
        standardCallUnlimited
        premiumCallUnlimited
        superPremiumCallUnlimited
        reasoningCallUnlimited
        createdAt
        updatedAt
        __typename
      }
      baseUsageTierId
      baseUsageTier {
        id
        projectId
        status
        name
        description
        version
        activeAt
        inactiveAt
        priorUsageTierId
        priorUsageTier {
          id
          projectId
          status
          name
          description
          version
          activeAt
          inactiveAt
          priorUsageTierId
          baseUsageTierId
          replenishmentPeriod
          replenishmentMethod
          usageLimitAction
          standardTokenReplenishmentAmount
          premiumTokenReplenishmentAmount
          superPremiumTokenReplenishmentAmount
          reasoningTokenReplenishmentAmount
          standardCallReplenishmentAmount
          premiumCallReplenishmentAmount
          superPremiumCallReplenishmentAmount
          reasoningCallReplenishmentAmount
          standardTokenUnlimited
          premiumTokenUnlimited
          superPremiumTokenUnlimited
          reasoningTokenUnlimited
          standardCallUnlimited
          premiumCallUnlimited
          superPremiumCallUnlimited
          reasoningCallUnlimited
          createdAt
          updatedAt
          __typename
        }
        baseUsageTierId
        baseUsageTier {
          id
          projectId
          status
          name
          description
          version
          activeAt
          inactiveAt
          priorUsageTierId
          baseUsageTierId
          replenishmentPeriod
          replenishmentMethod
          usageLimitAction
          standardTokenReplenishmentAmount
          premiumTokenReplenishmentAmount
          superPremiumTokenReplenishmentAmount
          reasoningTokenReplenishmentAmount
          standardCallReplenishmentAmount
          premiumCallReplenishmentAmount
          superPremiumCallReplenishmentAmount
          reasoningCallReplenishmentAmount
          standardTokenUnlimited
          premiumTokenUnlimited
          superPremiumTokenUnlimited
          reasoningTokenUnlimited
          standardCallUnlimited
          premiumCallUnlimited
          superPremiumCallUnlimited
          reasoningCallUnlimited
          createdAt
          updatedAt
          __typename
        }
        replenishmentPeriod
        replenishmentMethod
        usageLimitAction
        standardTokenReplenishmentAmount
        premiumTokenReplenishmentAmount
        superPremiumTokenReplenishmentAmount
        reasoningTokenReplenishmentAmount
        standardCallReplenishmentAmount
        premiumCallReplenishmentAmount
        superPremiumCallReplenishmentAmount
        reasoningCallReplenishmentAmount
        standardTokenUnlimited
        premiumTokenUnlimited
        superPremiumTokenUnlimited
        reasoningTokenUnlimited
        standardCallUnlimited
        premiumCallUnlimited
        superPremiumCallUnlimited
        reasoningCallUnlimited
        createdAt
        updatedAt
        __typename
      }
      replenishmentPeriod
      replenishmentMethod
      usageLimitAction
      standardTokenReplenishmentAmount
      premiumTokenReplenishmentAmount
      superPremiumTokenReplenishmentAmount
      reasoningTokenReplenishmentAmount
      standardCallReplenishmentAmount
      premiumCallReplenishmentAmount
      superPremiumCallReplenishmentAmount
      reasoningCallReplenishmentAmount
      standardTokenUnlimited
      premiumTokenUnlimited
      superPremiumTokenUnlimited
      reasoningTokenUnlimited
      standardCallUnlimited
      premiumCallUnlimited
      superPremiumCallUnlimited
      reasoningCallUnlimited
      createdAt
      updatedAt
      __typename
    }
    usageTapUsageApiKey
    lowApiCreditNotificationEmails
    lowApiCreditNotificationMinimumCredit
    lastLowApiCreditNotificationSentAt
    integrationApiKey1Hash
    integrationApiKey1Status
    integrationApiKey1Prefix
    integrationApiKey1LastRotatedAt
    integrationApiKey1Scopes
    integrationApiKey2Hash
    integrationApiKey2Status
    integrationApiKey2Prefix
    integrationApiKey2LastRotatedAt
    integrationApiKey2Scopes
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateLLMProjectMutationVariables,
  APITypes.UpdateLLMProjectMutation
>;
export const createLLMUsageTier = /* GraphQL */ `mutation CreateLLMUsageTier(
  $input: CreateLLMUsageTierInput!
  $condition: ModelLLMUsageTierConditionInput
) {
  createLLMUsageTier(input: $input, condition: $condition) {
    id
    projectId
    status
    name
    description
    version
    activeAt
    inactiveAt
    priorUsageTierId
    priorUsageTier {
      id
      projectId
      status
      name
      description
      version
      activeAt
      inactiveAt
      priorUsageTierId
      priorUsageTier {
        id
        projectId
        status
        name
        description
        version
        activeAt
        inactiveAt
        priorUsageTierId
        priorUsageTier {
          id
          projectId
          status
          name
          description
          version
          activeAt
          inactiveAt
          priorUsageTierId
          baseUsageTierId
          replenishmentPeriod
          replenishmentMethod
          usageLimitAction
          standardTokenReplenishmentAmount
          premiumTokenReplenishmentAmount
          superPremiumTokenReplenishmentAmount
          reasoningTokenReplenishmentAmount
          standardCallReplenishmentAmount
          premiumCallReplenishmentAmount
          superPremiumCallReplenishmentAmount
          reasoningCallReplenishmentAmount
          standardTokenUnlimited
          premiumTokenUnlimited
          superPremiumTokenUnlimited
          reasoningTokenUnlimited
          standardCallUnlimited
          premiumCallUnlimited
          superPremiumCallUnlimited
          reasoningCallUnlimited
          createdAt
          updatedAt
          __typename
        }
        baseUsageTierId
        baseUsageTier {
          id
          projectId
          status
          name
          description
          version
          activeAt
          inactiveAt
          priorUsageTierId
          baseUsageTierId
          replenishmentPeriod
          replenishmentMethod
          usageLimitAction
          standardTokenReplenishmentAmount
          premiumTokenReplenishmentAmount
          superPremiumTokenReplenishmentAmount
          reasoningTokenReplenishmentAmount
          standardCallReplenishmentAmount
          premiumCallReplenishmentAmount
          superPremiumCallReplenishmentAmount
          reasoningCallReplenishmentAmount
          standardTokenUnlimited
          premiumTokenUnlimited
          superPremiumTokenUnlimited
          reasoningTokenUnlimited
          standardCallUnlimited
          premiumCallUnlimited
          superPremiumCallUnlimited
          reasoningCallUnlimited
          createdAt
          updatedAt
          __typename
        }
        replenishmentPeriod
        replenishmentMethod
        usageLimitAction
        standardTokenReplenishmentAmount
        premiumTokenReplenishmentAmount
        superPremiumTokenReplenishmentAmount
        reasoningTokenReplenishmentAmount
        standardCallReplenishmentAmount
        premiumCallReplenishmentAmount
        superPremiumCallReplenishmentAmount
        reasoningCallReplenishmentAmount
        standardTokenUnlimited
        premiumTokenUnlimited
        superPremiumTokenUnlimited
        reasoningTokenUnlimited
        standardCallUnlimited
        premiumCallUnlimited
        superPremiumCallUnlimited
        reasoningCallUnlimited
        createdAt
        updatedAt
        __typename
      }
      baseUsageTierId
      baseUsageTier {
        id
        projectId
        status
        name
        description
        version
        activeAt
        inactiveAt
        priorUsageTierId
        priorUsageTier {
          id
          projectId
          status
          name
          description
          version
          activeAt
          inactiveAt
          priorUsageTierId
          baseUsageTierId
          replenishmentPeriod
          replenishmentMethod
          usageLimitAction
          standardTokenReplenishmentAmount
          premiumTokenReplenishmentAmount
          superPremiumTokenReplenishmentAmount
          reasoningTokenReplenishmentAmount
          standardCallReplenishmentAmount
          premiumCallReplenishmentAmount
          superPremiumCallReplenishmentAmount
          reasoningCallReplenishmentAmount
          standardTokenUnlimited
          premiumTokenUnlimited
          superPremiumTokenUnlimited
          reasoningTokenUnlimited
          standardCallUnlimited
          premiumCallUnlimited
          superPremiumCallUnlimited
          reasoningCallUnlimited
          createdAt
          updatedAt
          __typename
        }
        baseUsageTierId
        baseUsageTier {
          id
          projectId
          status
          name
          description
          version
          activeAt
          inactiveAt
          priorUsageTierId
          baseUsageTierId
          replenishmentPeriod
          replenishmentMethod
          usageLimitAction
          standardTokenReplenishmentAmount
          premiumTokenReplenishmentAmount
          superPremiumTokenReplenishmentAmount
          reasoningTokenReplenishmentAmount
          standardCallReplenishmentAmount
          premiumCallReplenishmentAmount
          superPremiumCallReplenishmentAmount
          reasoningCallReplenishmentAmount
          standardTokenUnlimited
          premiumTokenUnlimited
          superPremiumTokenUnlimited
          reasoningTokenUnlimited
          standardCallUnlimited
          premiumCallUnlimited
          superPremiumCallUnlimited
          reasoningCallUnlimited
          createdAt
          updatedAt
          __typename
        }
        replenishmentPeriod
        replenishmentMethod
        usageLimitAction
        standardTokenReplenishmentAmount
        premiumTokenReplenishmentAmount
        superPremiumTokenReplenishmentAmount
        reasoningTokenReplenishmentAmount
        standardCallReplenishmentAmount
        premiumCallReplenishmentAmount
        superPremiumCallReplenishmentAmount
        reasoningCallReplenishmentAmount
        standardTokenUnlimited
        premiumTokenUnlimited
        superPremiumTokenUnlimited
        reasoningTokenUnlimited
        standardCallUnlimited
        premiumCallUnlimited
        superPremiumCallUnlimited
        reasoningCallUnlimited
        createdAt
        updatedAt
        __typename
      }
      replenishmentPeriod
      replenishmentMethod
      usageLimitAction
      standardTokenReplenishmentAmount
      premiumTokenReplenishmentAmount
      superPremiumTokenReplenishmentAmount
      reasoningTokenReplenishmentAmount
      standardCallReplenishmentAmount
      premiumCallReplenishmentAmount
      superPremiumCallReplenishmentAmount
      reasoningCallReplenishmentAmount
      standardTokenUnlimited
      premiumTokenUnlimited
      superPremiumTokenUnlimited
      reasoningTokenUnlimited
      standardCallUnlimited
      premiumCallUnlimited
      superPremiumCallUnlimited
      reasoningCallUnlimited
      createdAt
      updatedAt
      __typename
    }
    baseUsageTierId
    baseUsageTier {
      id
      projectId
      status
      name
      description
      version
      activeAt
      inactiveAt
      priorUsageTierId
      priorUsageTier {
        id
        projectId
        status
        name
        description
        version
        activeAt
        inactiveAt
        priorUsageTierId
        priorUsageTier {
          id
          projectId
          status
          name
          description
          version
          activeAt
          inactiveAt
          priorUsageTierId
          baseUsageTierId
          replenishmentPeriod
          replenishmentMethod
          usageLimitAction
          standardTokenReplenishmentAmount
          premiumTokenReplenishmentAmount
          superPremiumTokenReplenishmentAmount
          reasoningTokenReplenishmentAmount
          standardCallReplenishmentAmount
          premiumCallReplenishmentAmount
          superPremiumCallReplenishmentAmount
          reasoningCallReplenishmentAmount
          standardTokenUnlimited
          premiumTokenUnlimited
          superPremiumTokenUnlimited
          reasoningTokenUnlimited
          standardCallUnlimited
          premiumCallUnlimited
          superPremiumCallUnlimited
          reasoningCallUnlimited
          createdAt
          updatedAt
          __typename
        }
        baseUsageTierId
        baseUsageTier {
          id
          projectId
          status
          name
          description
          version
          activeAt
          inactiveAt
          priorUsageTierId
          baseUsageTierId
          replenishmentPeriod
          replenishmentMethod
          usageLimitAction
          standardTokenReplenishmentAmount
          premiumTokenReplenishmentAmount
          superPremiumTokenReplenishmentAmount
          reasoningTokenReplenishmentAmount
          standardCallReplenishmentAmount
          premiumCallReplenishmentAmount
          superPremiumCallReplenishmentAmount
          reasoningCallReplenishmentAmount
          standardTokenUnlimited
          premiumTokenUnlimited
          superPremiumTokenUnlimited
          reasoningTokenUnlimited
          standardCallUnlimited
          premiumCallUnlimited
          superPremiumCallUnlimited
          reasoningCallUnlimited
          createdAt
          updatedAt
          __typename
        }
        replenishmentPeriod
        replenishmentMethod
        usageLimitAction
        standardTokenReplenishmentAmount
        premiumTokenReplenishmentAmount
        superPremiumTokenReplenishmentAmount
        reasoningTokenReplenishmentAmount
        standardCallReplenishmentAmount
        premiumCallReplenishmentAmount
        superPremiumCallReplenishmentAmount
        reasoningCallReplenishmentAmount
        standardTokenUnlimited
        premiumTokenUnlimited
        superPremiumTokenUnlimited
        reasoningTokenUnlimited
        standardCallUnlimited
        premiumCallUnlimited
        superPremiumCallUnlimited
        reasoningCallUnlimited
        createdAt
        updatedAt
        __typename
      }
      baseUsageTierId
      baseUsageTier {
        id
        projectId
        status
        name
        description
        version
        activeAt
        inactiveAt
        priorUsageTierId
        priorUsageTier {
          id
          projectId
          status
          name
          description
          version
          activeAt
          inactiveAt
          priorUsageTierId
          baseUsageTierId
          replenishmentPeriod
          replenishmentMethod
          usageLimitAction
          standardTokenReplenishmentAmount
          premiumTokenReplenishmentAmount
          superPremiumTokenReplenishmentAmount
          reasoningTokenReplenishmentAmount
          standardCallReplenishmentAmount
          premiumCallReplenishmentAmount
          superPremiumCallReplenishmentAmount
          reasoningCallReplenishmentAmount
          standardTokenUnlimited
          premiumTokenUnlimited
          superPremiumTokenUnlimited
          reasoningTokenUnlimited
          standardCallUnlimited
          premiumCallUnlimited
          superPremiumCallUnlimited
          reasoningCallUnlimited
          createdAt
          updatedAt
          __typename
        }
        baseUsageTierId
        baseUsageTier {
          id
          projectId
          status
          name
          description
          version
          activeAt
          inactiveAt
          priorUsageTierId
          baseUsageTierId
          replenishmentPeriod
          replenishmentMethod
          usageLimitAction
          standardTokenReplenishmentAmount
          premiumTokenReplenishmentAmount
          superPremiumTokenReplenishmentAmount
          reasoningTokenReplenishmentAmount
          standardCallReplenishmentAmount
          premiumCallReplenishmentAmount
          superPremiumCallReplenishmentAmount
          reasoningCallReplenishmentAmount
          standardTokenUnlimited
          premiumTokenUnlimited
          superPremiumTokenUnlimited
          reasoningTokenUnlimited
          standardCallUnlimited
          premiumCallUnlimited
          superPremiumCallUnlimited
          reasoningCallUnlimited
          createdAt
          updatedAt
          __typename
        }
        replenishmentPeriod
        replenishmentMethod
        usageLimitAction
        standardTokenReplenishmentAmount
        premiumTokenReplenishmentAmount
        superPremiumTokenReplenishmentAmount
        reasoningTokenReplenishmentAmount
        standardCallReplenishmentAmount
        premiumCallReplenishmentAmount
        superPremiumCallReplenishmentAmount
        reasoningCallReplenishmentAmount
        standardTokenUnlimited
        premiumTokenUnlimited
        superPremiumTokenUnlimited
        reasoningTokenUnlimited
        standardCallUnlimited
        premiumCallUnlimited
        superPremiumCallUnlimited
        reasoningCallUnlimited
        createdAt
        updatedAt
        __typename
      }
      replenishmentPeriod
      replenishmentMethod
      usageLimitAction
      standardTokenReplenishmentAmount
      premiumTokenReplenishmentAmount
      superPremiumTokenReplenishmentAmount
      reasoningTokenReplenishmentAmount
      standardCallReplenishmentAmount
      premiumCallReplenishmentAmount
      superPremiumCallReplenishmentAmount
      reasoningCallReplenishmentAmount
      standardTokenUnlimited
      premiumTokenUnlimited
      superPremiumTokenUnlimited
      reasoningTokenUnlimited
      standardCallUnlimited
      premiumCallUnlimited
      superPremiumCallUnlimited
      reasoningCallUnlimited
      createdAt
      updatedAt
      __typename
    }
    replenishmentPeriod
    replenishmentMethod
    usageLimitAction
    standardTokenReplenishmentAmount
    premiumTokenReplenishmentAmount
    superPremiumTokenReplenishmentAmount
    reasoningTokenReplenishmentAmount
    standardCallReplenishmentAmount
    premiumCallReplenishmentAmount
    superPremiumCallReplenishmentAmount
    reasoningCallReplenishmentAmount
    standardTokenUnlimited
    premiumTokenUnlimited
    superPremiumTokenUnlimited
    reasoningTokenUnlimited
    standardCallUnlimited
    premiumCallUnlimited
    superPremiumCallUnlimited
    reasoningCallUnlimited
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateLLMUsageTierMutationVariables,
  APITypes.CreateLLMUsageTierMutation
>;
export const updateLLMUsageTier = /* GraphQL */ `mutation UpdateLLMUsageTier(
  $input: UpdateLLMUsageTierInput!
  $condition: ModelLLMUsageTierConditionInput
) {
  updateLLMUsageTier(input: $input, condition: $condition) {
    id
    projectId
    status
    name
    description
    version
    activeAt
    inactiveAt
    priorUsageTierId
    priorUsageTier {
      id
      projectId
      status
      name
      description
      version
      activeAt
      inactiveAt
      priorUsageTierId
      priorUsageTier {
        id
        projectId
        status
        name
        description
        version
        activeAt
        inactiveAt
        priorUsageTierId
        priorUsageTier {
          id
          projectId
          status
          name
          description
          version
          activeAt
          inactiveAt
          priorUsageTierId
          baseUsageTierId
          replenishmentPeriod
          replenishmentMethod
          usageLimitAction
          standardTokenReplenishmentAmount
          premiumTokenReplenishmentAmount
          superPremiumTokenReplenishmentAmount
          reasoningTokenReplenishmentAmount
          standardCallReplenishmentAmount
          premiumCallReplenishmentAmount
          superPremiumCallReplenishmentAmount
          reasoningCallReplenishmentAmount
          standardTokenUnlimited
          premiumTokenUnlimited
          superPremiumTokenUnlimited
          reasoningTokenUnlimited
          standardCallUnlimited
          premiumCallUnlimited
          superPremiumCallUnlimited
          reasoningCallUnlimited
          createdAt
          updatedAt
          __typename
        }
        baseUsageTierId
        baseUsageTier {
          id
          projectId
          status
          name
          description
          version
          activeAt
          inactiveAt
          priorUsageTierId
          baseUsageTierId
          replenishmentPeriod
          replenishmentMethod
          usageLimitAction
          standardTokenReplenishmentAmount
          premiumTokenReplenishmentAmount
          superPremiumTokenReplenishmentAmount
          reasoningTokenReplenishmentAmount
          standardCallReplenishmentAmount
          premiumCallReplenishmentAmount
          superPremiumCallReplenishmentAmount
          reasoningCallReplenishmentAmount
          standardTokenUnlimited
          premiumTokenUnlimited
          superPremiumTokenUnlimited
          reasoningTokenUnlimited
          standardCallUnlimited
          premiumCallUnlimited
          superPremiumCallUnlimited
          reasoningCallUnlimited
          createdAt
          updatedAt
          __typename
        }
        replenishmentPeriod
        replenishmentMethod
        usageLimitAction
        standardTokenReplenishmentAmount
        premiumTokenReplenishmentAmount
        superPremiumTokenReplenishmentAmount
        reasoningTokenReplenishmentAmount
        standardCallReplenishmentAmount
        premiumCallReplenishmentAmount
        superPremiumCallReplenishmentAmount
        reasoningCallReplenishmentAmount
        standardTokenUnlimited
        premiumTokenUnlimited
        superPremiumTokenUnlimited
        reasoningTokenUnlimited
        standardCallUnlimited
        premiumCallUnlimited
        superPremiumCallUnlimited
        reasoningCallUnlimited
        createdAt
        updatedAt
        __typename
      }
      baseUsageTierId
      baseUsageTier {
        id
        projectId
        status
        name
        description
        version
        activeAt
        inactiveAt
        priorUsageTierId
        priorUsageTier {
          id
          projectId
          status
          name
          description
          version
          activeAt
          inactiveAt
          priorUsageTierId
          baseUsageTierId
          replenishmentPeriod
          replenishmentMethod
          usageLimitAction
          standardTokenReplenishmentAmount
          premiumTokenReplenishmentAmount
          superPremiumTokenReplenishmentAmount
          reasoningTokenReplenishmentAmount
          standardCallReplenishmentAmount
          premiumCallReplenishmentAmount
          superPremiumCallReplenishmentAmount
          reasoningCallReplenishmentAmount
          standardTokenUnlimited
          premiumTokenUnlimited
          superPremiumTokenUnlimited
          reasoningTokenUnlimited
          standardCallUnlimited
          premiumCallUnlimited
          superPremiumCallUnlimited
          reasoningCallUnlimited
          createdAt
          updatedAt
          __typename
        }
        baseUsageTierId
        baseUsageTier {
          id
          projectId
          status
          name
          description
          version
          activeAt
          inactiveAt
          priorUsageTierId
          baseUsageTierId
          replenishmentPeriod
          replenishmentMethod
          usageLimitAction
          standardTokenReplenishmentAmount
          premiumTokenReplenishmentAmount
          superPremiumTokenReplenishmentAmount
          reasoningTokenReplenishmentAmount
          standardCallReplenishmentAmount
          premiumCallReplenishmentAmount
          superPremiumCallReplenishmentAmount
          reasoningCallReplenishmentAmount
          standardTokenUnlimited
          premiumTokenUnlimited
          superPremiumTokenUnlimited
          reasoningTokenUnlimited
          standardCallUnlimited
          premiumCallUnlimited
          superPremiumCallUnlimited
          reasoningCallUnlimited
          createdAt
          updatedAt
          __typename
        }
        replenishmentPeriod
        replenishmentMethod
        usageLimitAction
        standardTokenReplenishmentAmount
        premiumTokenReplenishmentAmount
        superPremiumTokenReplenishmentAmount
        reasoningTokenReplenishmentAmount
        standardCallReplenishmentAmount
        premiumCallReplenishmentAmount
        superPremiumCallReplenishmentAmount
        reasoningCallReplenishmentAmount
        standardTokenUnlimited
        premiumTokenUnlimited
        superPremiumTokenUnlimited
        reasoningTokenUnlimited
        standardCallUnlimited
        premiumCallUnlimited
        superPremiumCallUnlimited
        reasoningCallUnlimited
        createdAt
        updatedAt
        __typename
      }
      replenishmentPeriod
      replenishmentMethod
      usageLimitAction
      standardTokenReplenishmentAmount
      premiumTokenReplenishmentAmount
      superPremiumTokenReplenishmentAmount
      reasoningTokenReplenishmentAmount
      standardCallReplenishmentAmount
      premiumCallReplenishmentAmount
      superPremiumCallReplenishmentAmount
      reasoningCallReplenishmentAmount
      standardTokenUnlimited
      premiumTokenUnlimited
      superPremiumTokenUnlimited
      reasoningTokenUnlimited
      standardCallUnlimited
      premiumCallUnlimited
      superPremiumCallUnlimited
      reasoningCallUnlimited
      createdAt
      updatedAt
      __typename
    }
    baseUsageTierId
    baseUsageTier {
      id
      projectId
      status
      name
      description
      version
      activeAt
      inactiveAt
      priorUsageTierId
      priorUsageTier {
        id
        projectId
        status
        name
        description
        version
        activeAt
        inactiveAt
        priorUsageTierId
        priorUsageTier {
          id
          projectId
          status
          name
          description
          version
          activeAt
          inactiveAt
          priorUsageTierId
          baseUsageTierId
          replenishmentPeriod
          replenishmentMethod
          usageLimitAction
          standardTokenReplenishmentAmount
          premiumTokenReplenishmentAmount
          superPremiumTokenReplenishmentAmount
          reasoningTokenReplenishmentAmount
          standardCallReplenishmentAmount
          premiumCallReplenishmentAmount
          superPremiumCallReplenishmentAmount
          reasoningCallReplenishmentAmount
          standardTokenUnlimited
          premiumTokenUnlimited
          superPremiumTokenUnlimited
          reasoningTokenUnlimited
          standardCallUnlimited
          premiumCallUnlimited
          superPremiumCallUnlimited
          reasoningCallUnlimited
          createdAt
          updatedAt
          __typename
        }
        baseUsageTierId
        baseUsageTier {
          id
          projectId
          status
          name
          description
          version
          activeAt
          inactiveAt
          priorUsageTierId
          baseUsageTierId
          replenishmentPeriod
          replenishmentMethod
          usageLimitAction
          standardTokenReplenishmentAmount
          premiumTokenReplenishmentAmount
          superPremiumTokenReplenishmentAmount
          reasoningTokenReplenishmentAmount
          standardCallReplenishmentAmount
          premiumCallReplenishmentAmount
          superPremiumCallReplenishmentAmount
          reasoningCallReplenishmentAmount
          standardTokenUnlimited
          premiumTokenUnlimited
          superPremiumTokenUnlimited
          reasoningTokenUnlimited
          standardCallUnlimited
          premiumCallUnlimited
          superPremiumCallUnlimited
          reasoningCallUnlimited
          createdAt
          updatedAt
          __typename
        }
        replenishmentPeriod
        replenishmentMethod
        usageLimitAction
        standardTokenReplenishmentAmount
        premiumTokenReplenishmentAmount
        superPremiumTokenReplenishmentAmount
        reasoningTokenReplenishmentAmount
        standardCallReplenishmentAmount
        premiumCallReplenishmentAmount
        superPremiumCallReplenishmentAmount
        reasoningCallReplenishmentAmount
        standardTokenUnlimited
        premiumTokenUnlimited
        superPremiumTokenUnlimited
        reasoningTokenUnlimited
        standardCallUnlimited
        premiumCallUnlimited
        superPremiumCallUnlimited
        reasoningCallUnlimited
        createdAt
        updatedAt
        __typename
      }
      baseUsageTierId
      baseUsageTier {
        id
        projectId
        status
        name
        description
        version
        activeAt
        inactiveAt
        priorUsageTierId
        priorUsageTier {
          id
          projectId
          status
          name
          description
          version
          activeAt
          inactiveAt
          priorUsageTierId
          baseUsageTierId
          replenishmentPeriod
          replenishmentMethod
          usageLimitAction
          standardTokenReplenishmentAmount
          premiumTokenReplenishmentAmount
          superPremiumTokenReplenishmentAmount
          reasoningTokenReplenishmentAmount
          standardCallReplenishmentAmount
          premiumCallReplenishmentAmount
          superPremiumCallReplenishmentAmount
          reasoningCallReplenishmentAmount
          standardTokenUnlimited
          premiumTokenUnlimited
          superPremiumTokenUnlimited
          reasoningTokenUnlimited
          standardCallUnlimited
          premiumCallUnlimited
          superPremiumCallUnlimited
          reasoningCallUnlimited
          createdAt
          updatedAt
          __typename
        }
        baseUsageTierId
        baseUsageTier {
          id
          projectId
          status
          name
          description
          version
          activeAt
          inactiveAt
          priorUsageTierId
          baseUsageTierId
          replenishmentPeriod
          replenishmentMethod
          usageLimitAction
          standardTokenReplenishmentAmount
          premiumTokenReplenishmentAmount
          superPremiumTokenReplenishmentAmount
          reasoningTokenReplenishmentAmount
          standardCallReplenishmentAmount
          premiumCallReplenishmentAmount
          superPremiumCallReplenishmentAmount
          reasoningCallReplenishmentAmount
          standardTokenUnlimited
          premiumTokenUnlimited
          superPremiumTokenUnlimited
          reasoningTokenUnlimited
          standardCallUnlimited
          premiumCallUnlimited
          superPremiumCallUnlimited
          reasoningCallUnlimited
          createdAt
          updatedAt
          __typename
        }
        replenishmentPeriod
        replenishmentMethod
        usageLimitAction
        standardTokenReplenishmentAmount
        premiumTokenReplenishmentAmount
        superPremiumTokenReplenishmentAmount
        reasoningTokenReplenishmentAmount
        standardCallReplenishmentAmount
        premiumCallReplenishmentAmount
        superPremiumCallReplenishmentAmount
        reasoningCallReplenishmentAmount
        standardTokenUnlimited
        premiumTokenUnlimited
        superPremiumTokenUnlimited
        reasoningTokenUnlimited
        standardCallUnlimited
        premiumCallUnlimited
        superPremiumCallUnlimited
        reasoningCallUnlimited
        createdAt
        updatedAt
        __typename
      }
      replenishmentPeriod
      replenishmentMethod
      usageLimitAction
      standardTokenReplenishmentAmount
      premiumTokenReplenishmentAmount
      superPremiumTokenReplenishmentAmount
      reasoningTokenReplenishmentAmount
      standardCallReplenishmentAmount
      premiumCallReplenishmentAmount
      superPremiumCallReplenishmentAmount
      reasoningCallReplenishmentAmount
      standardTokenUnlimited
      premiumTokenUnlimited
      superPremiumTokenUnlimited
      reasoningTokenUnlimited
      standardCallUnlimited
      premiumCallUnlimited
      superPremiumCallUnlimited
      reasoningCallUnlimited
      createdAt
      updatedAt
      __typename
    }
    replenishmentPeriod
    replenishmentMethod
    usageLimitAction
    standardTokenReplenishmentAmount
    premiumTokenReplenishmentAmount
    superPremiumTokenReplenishmentAmount
    reasoningTokenReplenishmentAmount
    standardCallReplenishmentAmount
    premiumCallReplenishmentAmount
    superPremiumCallReplenishmentAmount
    reasoningCallReplenishmentAmount
    standardTokenUnlimited
    premiumTokenUnlimited
    superPremiumTokenUnlimited
    reasoningTokenUnlimited
    standardCallUnlimited
    premiumCallUnlimited
    superPremiumCallUnlimited
    reasoningCallUnlimited
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateLLMUsageTierMutationVariables,
  APITypes.UpdateLLMUsageTierMutation
>;
export const deleteLLMUsageTier = /* GraphQL */ `mutation DeleteLLMUsageTier(
  $input: DeleteLLMUsageTierInput!
  $condition: ModelLLMUsageTierConditionInput
) {
  deleteLLMUsageTier(input: $input, condition: $condition) {
    id
    projectId
    status
    name
    description
    version
    activeAt
    inactiveAt
    priorUsageTierId
    priorUsageTier {
      id
      projectId
      status
      name
      description
      version
      activeAt
      inactiveAt
      priorUsageTierId
      priorUsageTier {
        id
        projectId
        status
        name
        description
        version
        activeAt
        inactiveAt
        priorUsageTierId
        priorUsageTier {
          id
          projectId
          status
          name
          description
          version
          activeAt
          inactiveAt
          priorUsageTierId
          baseUsageTierId
          replenishmentPeriod
          replenishmentMethod
          usageLimitAction
          standardTokenReplenishmentAmount
          premiumTokenReplenishmentAmount
          superPremiumTokenReplenishmentAmount
          reasoningTokenReplenishmentAmount
          standardCallReplenishmentAmount
          premiumCallReplenishmentAmount
          superPremiumCallReplenishmentAmount
          reasoningCallReplenishmentAmount
          standardTokenUnlimited
          premiumTokenUnlimited
          superPremiumTokenUnlimited
          reasoningTokenUnlimited
          standardCallUnlimited
          premiumCallUnlimited
          superPremiumCallUnlimited
          reasoningCallUnlimited
          createdAt
          updatedAt
          __typename
        }
        baseUsageTierId
        baseUsageTier {
          id
          projectId
          status
          name
          description
          version
          activeAt
          inactiveAt
          priorUsageTierId
          baseUsageTierId
          replenishmentPeriod
          replenishmentMethod
          usageLimitAction
          standardTokenReplenishmentAmount
          premiumTokenReplenishmentAmount
          superPremiumTokenReplenishmentAmount
          reasoningTokenReplenishmentAmount
          standardCallReplenishmentAmount
          premiumCallReplenishmentAmount
          superPremiumCallReplenishmentAmount
          reasoningCallReplenishmentAmount
          standardTokenUnlimited
          premiumTokenUnlimited
          superPremiumTokenUnlimited
          reasoningTokenUnlimited
          standardCallUnlimited
          premiumCallUnlimited
          superPremiumCallUnlimited
          reasoningCallUnlimited
          createdAt
          updatedAt
          __typename
        }
        replenishmentPeriod
        replenishmentMethod
        usageLimitAction
        standardTokenReplenishmentAmount
        premiumTokenReplenishmentAmount
        superPremiumTokenReplenishmentAmount
        reasoningTokenReplenishmentAmount
        standardCallReplenishmentAmount
        premiumCallReplenishmentAmount
        superPremiumCallReplenishmentAmount
        reasoningCallReplenishmentAmount
        standardTokenUnlimited
        premiumTokenUnlimited
        superPremiumTokenUnlimited
        reasoningTokenUnlimited
        standardCallUnlimited
        premiumCallUnlimited
        superPremiumCallUnlimited
        reasoningCallUnlimited
        createdAt
        updatedAt
        __typename
      }
      baseUsageTierId
      baseUsageTier {
        id
        projectId
        status
        name
        description
        version
        activeAt
        inactiveAt
        priorUsageTierId
        priorUsageTier {
          id
          projectId
          status
          name
          description
          version
          activeAt
          inactiveAt
          priorUsageTierId
          baseUsageTierId
          replenishmentPeriod
          replenishmentMethod
          usageLimitAction
          standardTokenReplenishmentAmount
          premiumTokenReplenishmentAmount
          superPremiumTokenReplenishmentAmount
          reasoningTokenReplenishmentAmount
          standardCallReplenishmentAmount
          premiumCallReplenishmentAmount
          superPremiumCallReplenishmentAmount
          reasoningCallReplenishmentAmount
          standardTokenUnlimited
          premiumTokenUnlimited
          superPremiumTokenUnlimited
          reasoningTokenUnlimited
          standardCallUnlimited
          premiumCallUnlimited
          superPremiumCallUnlimited
          reasoningCallUnlimited
          createdAt
          updatedAt
          __typename
        }
        baseUsageTierId
        baseUsageTier {
          id
          projectId
          status
          name
          description
          version
          activeAt
          inactiveAt
          priorUsageTierId
          baseUsageTierId
          replenishmentPeriod
          replenishmentMethod
          usageLimitAction
          standardTokenReplenishmentAmount
          premiumTokenReplenishmentAmount
          superPremiumTokenReplenishmentAmount
          reasoningTokenReplenishmentAmount
          standardCallReplenishmentAmount
          premiumCallReplenishmentAmount
          superPremiumCallReplenishmentAmount
          reasoningCallReplenishmentAmount
          standardTokenUnlimited
          premiumTokenUnlimited
          superPremiumTokenUnlimited
          reasoningTokenUnlimited
          standardCallUnlimited
          premiumCallUnlimited
          superPremiumCallUnlimited
          reasoningCallUnlimited
          createdAt
          updatedAt
          __typename
        }
        replenishmentPeriod
        replenishmentMethod
        usageLimitAction
        standardTokenReplenishmentAmount
        premiumTokenReplenishmentAmount
        superPremiumTokenReplenishmentAmount
        reasoningTokenReplenishmentAmount
        standardCallReplenishmentAmount
        premiumCallReplenishmentAmount
        superPremiumCallReplenishmentAmount
        reasoningCallReplenishmentAmount
        standardTokenUnlimited
        premiumTokenUnlimited
        superPremiumTokenUnlimited
        reasoningTokenUnlimited
        standardCallUnlimited
        premiumCallUnlimited
        superPremiumCallUnlimited
        reasoningCallUnlimited
        createdAt
        updatedAt
        __typename
      }
      replenishmentPeriod
      replenishmentMethod
      usageLimitAction
      standardTokenReplenishmentAmount
      premiumTokenReplenishmentAmount
      superPremiumTokenReplenishmentAmount
      reasoningTokenReplenishmentAmount
      standardCallReplenishmentAmount
      premiumCallReplenishmentAmount
      superPremiumCallReplenishmentAmount
      reasoningCallReplenishmentAmount
      standardTokenUnlimited
      premiumTokenUnlimited
      superPremiumTokenUnlimited
      reasoningTokenUnlimited
      standardCallUnlimited
      premiumCallUnlimited
      superPremiumCallUnlimited
      reasoningCallUnlimited
      createdAt
      updatedAt
      __typename
    }
    baseUsageTierId
    baseUsageTier {
      id
      projectId
      status
      name
      description
      version
      activeAt
      inactiveAt
      priorUsageTierId
      priorUsageTier {
        id
        projectId
        status
        name
        description
        version
        activeAt
        inactiveAt
        priorUsageTierId
        priorUsageTier {
          id
          projectId
          status
          name
          description
          version
          activeAt
          inactiveAt
          priorUsageTierId
          baseUsageTierId
          replenishmentPeriod
          replenishmentMethod
          usageLimitAction
          standardTokenReplenishmentAmount
          premiumTokenReplenishmentAmount
          superPremiumTokenReplenishmentAmount
          reasoningTokenReplenishmentAmount
          standardCallReplenishmentAmount
          premiumCallReplenishmentAmount
          superPremiumCallReplenishmentAmount
          reasoningCallReplenishmentAmount
          standardTokenUnlimited
          premiumTokenUnlimited
          superPremiumTokenUnlimited
          reasoningTokenUnlimited
          standardCallUnlimited
          premiumCallUnlimited
          superPremiumCallUnlimited
          reasoningCallUnlimited
          createdAt
          updatedAt
          __typename
        }
        baseUsageTierId
        baseUsageTier {
          id
          projectId
          status
          name
          description
          version
          activeAt
          inactiveAt
          priorUsageTierId
          baseUsageTierId
          replenishmentPeriod
          replenishmentMethod
          usageLimitAction
          standardTokenReplenishmentAmount
          premiumTokenReplenishmentAmount
          superPremiumTokenReplenishmentAmount
          reasoningTokenReplenishmentAmount
          standardCallReplenishmentAmount
          premiumCallReplenishmentAmount
          superPremiumCallReplenishmentAmount
          reasoningCallReplenishmentAmount
          standardTokenUnlimited
          premiumTokenUnlimited
          superPremiumTokenUnlimited
          reasoningTokenUnlimited
          standardCallUnlimited
          premiumCallUnlimited
          superPremiumCallUnlimited
          reasoningCallUnlimited
          createdAt
          updatedAt
          __typename
        }
        replenishmentPeriod
        replenishmentMethod
        usageLimitAction
        standardTokenReplenishmentAmount
        premiumTokenReplenishmentAmount
        superPremiumTokenReplenishmentAmount
        reasoningTokenReplenishmentAmount
        standardCallReplenishmentAmount
        premiumCallReplenishmentAmount
        superPremiumCallReplenishmentAmount
        reasoningCallReplenishmentAmount
        standardTokenUnlimited
        premiumTokenUnlimited
        superPremiumTokenUnlimited
        reasoningTokenUnlimited
        standardCallUnlimited
        premiumCallUnlimited
        superPremiumCallUnlimited
        reasoningCallUnlimited
        createdAt
        updatedAt
        __typename
      }
      baseUsageTierId
      baseUsageTier {
        id
        projectId
        status
        name
        description
        version
        activeAt
        inactiveAt
        priorUsageTierId
        priorUsageTier {
          id
          projectId
          status
          name
          description
          version
          activeAt
          inactiveAt
          priorUsageTierId
          baseUsageTierId
          replenishmentPeriod
          replenishmentMethod
          usageLimitAction
          standardTokenReplenishmentAmount
          premiumTokenReplenishmentAmount
          superPremiumTokenReplenishmentAmount
          reasoningTokenReplenishmentAmount
          standardCallReplenishmentAmount
          premiumCallReplenishmentAmount
          superPremiumCallReplenishmentAmount
          reasoningCallReplenishmentAmount
          standardTokenUnlimited
          premiumTokenUnlimited
          superPremiumTokenUnlimited
          reasoningTokenUnlimited
          standardCallUnlimited
          premiumCallUnlimited
          superPremiumCallUnlimited
          reasoningCallUnlimited
          createdAt
          updatedAt
          __typename
        }
        baseUsageTierId
        baseUsageTier {
          id
          projectId
          status
          name
          description
          version
          activeAt
          inactiveAt
          priorUsageTierId
          baseUsageTierId
          replenishmentPeriod
          replenishmentMethod
          usageLimitAction
          standardTokenReplenishmentAmount
          premiumTokenReplenishmentAmount
          superPremiumTokenReplenishmentAmount
          reasoningTokenReplenishmentAmount
          standardCallReplenishmentAmount
          premiumCallReplenishmentAmount
          superPremiumCallReplenishmentAmount
          reasoningCallReplenishmentAmount
          standardTokenUnlimited
          premiumTokenUnlimited
          superPremiumTokenUnlimited
          reasoningTokenUnlimited
          standardCallUnlimited
          premiumCallUnlimited
          superPremiumCallUnlimited
          reasoningCallUnlimited
          createdAt
          updatedAt
          __typename
        }
        replenishmentPeriod
        replenishmentMethod
        usageLimitAction
        standardTokenReplenishmentAmount
        premiumTokenReplenishmentAmount
        superPremiumTokenReplenishmentAmount
        reasoningTokenReplenishmentAmount
        standardCallReplenishmentAmount
        premiumCallReplenishmentAmount
        superPremiumCallReplenishmentAmount
        reasoningCallReplenishmentAmount
        standardTokenUnlimited
        premiumTokenUnlimited
        superPremiumTokenUnlimited
        reasoningTokenUnlimited
        standardCallUnlimited
        premiumCallUnlimited
        superPremiumCallUnlimited
        reasoningCallUnlimited
        createdAt
        updatedAt
        __typename
      }
      replenishmentPeriod
      replenishmentMethod
      usageLimitAction
      standardTokenReplenishmentAmount
      premiumTokenReplenishmentAmount
      superPremiumTokenReplenishmentAmount
      reasoningTokenReplenishmentAmount
      standardCallReplenishmentAmount
      premiumCallReplenishmentAmount
      superPremiumCallReplenishmentAmount
      reasoningCallReplenishmentAmount
      standardTokenUnlimited
      premiumTokenUnlimited
      superPremiumTokenUnlimited
      reasoningTokenUnlimited
      standardCallUnlimited
      premiumCallUnlimited
      superPremiumCallUnlimited
      reasoningCallUnlimited
      createdAt
      updatedAt
      __typename
    }
    replenishmentPeriod
    replenishmentMethod
    usageLimitAction
    standardTokenReplenishmentAmount
    premiumTokenReplenishmentAmount
    superPremiumTokenReplenishmentAmount
    reasoningTokenReplenishmentAmount
    standardCallReplenishmentAmount
    premiumCallReplenishmentAmount
    superPremiumCallReplenishmentAmount
    reasoningCallReplenishmentAmount
    standardTokenUnlimited
    premiumTokenUnlimited
    superPremiumTokenUnlimited
    reasoningTokenUnlimited
    standardCallUnlimited
    premiumCallUnlimited
    superPremiumCallUnlimited
    reasoningCallUnlimited
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteLLMUsageTierMutationVariables,
  APITypes.DeleteLLMUsageTierMutation
>;
export const createLLMProjectSubscription = /* GraphQL */ `mutation CreateLLMProjectSubscription(
  $input: CreateLLMProjectSubscriptionInput!
  $condition: ModelLLMProjectSubscriptionConditionInput
) {
  createLLMProjectSubscription(input: $input, condition: $condition) {
    id
    projectId
    quantity
    subscriptionId
    subscriptionStartDate
    subscriptionEndDate
    subscriptionStatus
    subscriptionProduct
    subscriptionInterval
    subscriptionEndedAt
    subscriptionCancelAtPeriodEnd
    usageSubscriptionId
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateLLMProjectSubscriptionMutationVariables,
  APITypes.CreateLLMProjectSubscriptionMutation
>;
export const updateLLMProjectSubscription = /* GraphQL */ `mutation UpdateLLMProjectSubscription(
  $input: UpdateLLMProjectSubscriptionInput!
  $condition: ModelLLMProjectSubscriptionConditionInput
) {
  updateLLMProjectSubscription(input: $input, condition: $condition) {
    id
    projectId
    quantity
    subscriptionId
    subscriptionStartDate
    subscriptionEndDate
    subscriptionStatus
    subscriptionProduct
    subscriptionInterval
    subscriptionEndedAt
    subscriptionCancelAtPeriodEnd
    usageSubscriptionId
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateLLMProjectSubscriptionMutationVariables,
  APITypes.UpdateLLMProjectSubscriptionMutation
>;
export const deleteLLMProjectSubscription = /* GraphQL */ `mutation DeleteLLMProjectSubscription(
  $input: DeleteLLMProjectSubscriptionInput!
  $condition: ModelLLMProjectSubscriptionConditionInput
) {
  deleteLLMProjectSubscription(input: $input, condition: $condition) {
    id
    projectId
    quantity
    subscriptionId
    subscriptionStartDate
    subscriptionEndDate
    subscriptionStatus
    subscriptionProduct
    subscriptionInterval
    subscriptionEndedAt
    subscriptionCancelAtPeriodEnd
    usageSubscriptionId
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteLLMProjectSubscriptionMutationVariables,
  APITypes.DeleteLLMProjectSubscriptionMutation
>;
export const createLLMUser = /* GraphQL */ `mutation CreateLLMUser(
  $input: CreateLLMUserInput!
  $condition: ModelLLMUserConditionInput
) {
  createLLMUser(input: $input, condition: $condition) {
    id
    email
    status
    displayName
    acceptedTermsOfService
    acceptedGDPRTerms
    projectId
    project {
      id
      name
      status
      description
      users {
        items {
          id
          email
          status
          displayName
          acceptedTermsOfService
          acceptedGDPRTerms
          projectId
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      services {
        items {
          id
          name
          status
          vendor
          region
          endpoint
          body
          header
          projectId
          loadProportion
          inputTokenPricePerMillion
          outputTokenPricePerMillion
          groupId
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      stripeCustomerId
      subscription {
        id
        projectId
        quantity
        subscriptionId
        subscriptionStartDate
        subscriptionEndDate
        subscriptionStatus
        subscriptionProduct
        subscriptionInterval
        subscriptionEndedAt
        subscriptionCancelAtPeriodEnd
        usageSubscriptionId
        createdAt
        updatedAt
        __typename
      }
      newCustomerTokenCount
      cacheResponsesForSeconds
      loadSheddingTier
      newCustomerLoadSheddingTier
      maintenanceMode
      maintenanceModeMessage
      loadBalancingMode
      piiRedactionScope
      systemInstructions
      piiScope
      piiGroupId
      piiMessage
      promptBlacklist
      blacklistGroupId
      blacklistMessage
      safety
      safetyGroupId
      safetyMessage
      strongModelGroupId
      routeModel
      trialTokensRemaining
      logfileRetentionPeriod
      callRetentionPeriod
      logInterval
      lastLogGeneratedAt
      logGenerationCursor
      enterpriseAllowChat
      enterpriseAcceptableUsePolicy
      enterpriseAccessRequestEmail
      enterpriseSupportEmail
      enterpriseDomainWhitelist
      enterpriseTokenBudget
      enterpriseTokenBudgetPeriod
      enterpriseImageUrl
      randomGroup
      apiCreditRemaining
      createdAt
      summaryEmailPeriod
      summaryEmailAddresses
      lastSummaryEmailSentAt
      mcpServerWhitelist
      automaticModelManagement
      supersmallGroupModels
      standardGroupModels
      premiumGroupModels
      reasoningGroupModels
      superpremiumGroupModels
      openrouterStandardGroupModels
      openrouterPremiumGroupModels
      azureOpenaiBaseUrl
      azureOpenaiApiVersion
      awsBedrockRegion
      newCustomerUsageTierId
      newCustomerUsageTier {
        id
        projectId
        status
        name
        description
        version
        activeAt
        inactiveAt
        priorUsageTierId
        priorUsageTier {
          id
          projectId
          status
          name
          description
          version
          activeAt
          inactiveAt
          priorUsageTierId
          baseUsageTierId
          replenishmentPeriod
          replenishmentMethod
          usageLimitAction
          standardTokenReplenishmentAmount
          premiumTokenReplenishmentAmount
          superPremiumTokenReplenishmentAmount
          reasoningTokenReplenishmentAmount
          standardCallReplenishmentAmount
          premiumCallReplenishmentAmount
          superPremiumCallReplenishmentAmount
          reasoningCallReplenishmentAmount
          standardTokenUnlimited
          premiumTokenUnlimited
          superPremiumTokenUnlimited
          reasoningTokenUnlimited
          standardCallUnlimited
          premiumCallUnlimited
          superPremiumCallUnlimited
          reasoningCallUnlimited
          createdAt
          updatedAt
          __typename
        }
        baseUsageTierId
        baseUsageTier {
          id
          projectId
          status
          name
          description
          version
          activeAt
          inactiveAt
          priorUsageTierId
          baseUsageTierId
          replenishmentPeriod
          replenishmentMethod
          usageLimitAction
          standardTokenReplenishmentAmount
          premiumTokenReplenishmentAmount
          superPremiumTokenReplenishmentAmount
          reasoningTokenReplenishmentAmount
          standardCallReplenishmentAmount
          premiumCallReplenishmentAmount
          superPremiumCallReplenishmentAmount
          reasoningCallReplenishmentAmount
          standardTokenUnlimited
          premiumTokenUnlimited
          superPremiumTokenUnlimited
          reasoningTokenUnlimited
          standardCallUnlimited
          premiumCallUnlimited
          superPremiumCallUnlimited
          reasoningCallUnlimited
          createdAt
          updatedAt
          __typename
        }
        replenishmentPeriod
        replenishmentMethod
        usageLimitAction
        standardTokenReplenishmentAmount
        premiumTokenReplenishmentAmount
        superPremiumTokenReplenishmentAmount
        reasoningTokenReplenishmentAmount
        standardCallReplenishmentAmount
        premiumCallReplenishmentAmount
        superPremiumCallReplenishmentAmount
        reasoningCallReplenishmentAmount
        standardTokenUnlimited
        premiumTokenUnlimited
        superPremiumTokenUnlimited
        reasoningTokenUnlimited
        standardCallUnlimited
        premiumCallUnlimited
        superPremiumCallUnlimited
        reasoningCallUnlimited
        createdAt
        updatedAt
        __typename
      }
      usageTapUsageApiKey
      lowApiCreditNotificationEmails
      lowApiCreditNotificationMinimumCredit
      lastLowApiCreditNotificationSentAt
      integrationApiKey1Hash
      integrationApiKey1Status
      integrationApiKey1Prefix
      integrationApiKey1LastRotatedAt
      integrationApiKey1Scopes
      integrationApiKey2Hash
      integrationApiKey2Status
      integrationApiKey2Prefix
      integrationApiKey2LastRotatedAt
      integrationApiKey2Scopes
      updatedAt
      __typename
    }
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateLLMUserMutationVariables,
  APITypes.CreateLLMUserMutation
>;
export const updateLLMUser = /* GraphQL */ `mutation UpdateLLMUser(
  $input: UpdateLLMUserInput!
  $condition: ModelLLMUserConditionInput
) {
  updateLLMUser(input: $input, condition: $condition) {
    id
    email
    status
    displayName
    acceptedTermsOfService
    acceptedGDPRTerms
    projectId
    project {
      id
      name
      status
      description
      users {
        items {
          id
          email
          status
          displayName
          acceptedTermsOfService
          acceptedGDPRTerms
          projectId
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      services {
        items {
          id
          name
          status
          vendor
          region
          endpoint
          body
          header
          projectId
          loadProportion
          inputTokenPricePerMillion
          outputTokenPricePerMillion
          groupId
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      stripeCustomerId
      subscription {
        id
        projectId
        quantity
        subscriptionId
        subscriptionStartDate
        subscriptionEndDate
        subscriptionStatus
        subscriptionProduct
        subscriptionInterval
        subscriptionEndedAt
        subscriptionCancelAtPeriodEnd
        usageSubscriptionId
        createdAt
        updatedAt
        __typename
      }
      newCustomerTokenCount
      cacheResponsesForSeconds
      loadSheddingTier
      newCustomerLoadSheddingTier
      maintenanceMode
      maintenanceModeMessage
      loadBalancingMode
      piiRedactionScope
      systemInstructions
      piiScope
      piiGroupId
      piiMessage
      promptBlacklist
      blacklistGroupId
      blacklistMessage
      safety
      safetyGroupId
      safetyMessage
      strongModelGroupId
      routeModel
      trialTokensRemaining
      logfileRetentionPeriod
      callRetentionPeriod
      logInterval
      lastLogGeneratedAt
      logGenerationCursor
      enterpriseAllowChat
      enterpriseAcceptableUsePolicy
      enterpriseAccessRequestEmail
      enterpriseSupportEmail
      enterpriseDomainWhitelist
      enterpriseTokenBudget
      enterpriseTokenBudgetPeriod
      enterpriseImageUrl
      randomGroup
      apiCreditRemaining
      createdAt
      summaryEmailPeriod
      summaryEmailAddresses
      lastSummaryEmailSentAt
      mcpServerWhitelist
      automaticModelManagement
      supersmallGroupModels
      standardGroupModels
      premiumGroupModels
      reasoningGroupModels
      superpremiumGroupModels
      openrouterStandardGroupModels
      openrouterPremiumGroupModels
      azureOpenaiBaseUrl
      azureOpenaiApiVersion
      awsBedrockRegion
      newCustomerUsageTierId
      newCustomerUsageTier {
        id
        projectId
        status
        name
        description
        version
        activeAt
        inactiveAt
        priorUsageTierId
        priorUsageTier {
          id
          projectId
          status
          name
          description
          version
          activeAt
          inactiveAt
          priorUsageTierId
          baseUsageTierId
          replenishmentPeriod
          replenishmentMethod
          usageLimitAction
          standardTokenReplenishmentAmount
          premiumTokenReplenishmentAmount
          superPremiumTokenReplenishmentAmount
          reasoningTokenReplenishmentAmount
          standardCallReplenishmentAmount
          premiumCallReplenishmentAmount
          superPremiumCallReplenishmentAmount
          reasoningCallReplenishmentAmount
          standardTokenUnlimited
          premiumTokenUnlimited
          superPremiumTokenUnlimited
          reasoningTokenUnlimited
          standardCallUnlimited
          premiumCallUnlimited
          superPremiumCallUnlimited
          reasoningCallUnlimited
          createdAt
          updatedAt
          __typename
        }
        baseUsageTierId
        baseUsageTier {
          id
          projectId
          status
          name
          description
          version
          activeAt
          inactiveAt
          priorUsageTierId
          baseUsageTierId
          replenishmentPeriod
          replenishmentMethod
          usageLimitAction
          standardTokenReplenishmentAmount
          premiumTokenReplenishmentAmount
          superPremiumTokenReplenishmentAmount
          reasoningTokenReplenishmentAmount
          standardCallReplenishmentAmount
          premiumCallReplenishmentAmount
          superPremiumCallReplenishmentAmount
          reasoningCallReplenishmentAmount
          standardTokenUnlimited
          premiumTokenUnlimited
          superPremiumTokenUnlimited
          reasoningTokenUnlimited
          standardCallUnlimited
          premiumCallUnlimited
          superPremiumCallUnlimited
          reasoningCallUnlimited
          createdAt
          updatedAt
          __typename
        }
        replenishmentPeriod
        replenishmentMethod
        usageLimitAction
        standardTokenReplenishmentAmount
        premiumTokenReplenishmentAmount
        superPremiumTokenReplenishmentAmount
        reasoningTokenReplenishmentAmount
        standardCallReplenishmentAmount
        premiumCallReplenishmentAmount
        superPremiumCallReplenishmentAmount
        reasoningCallReplenishmentAmount
        standardTokenUnlimited
        premiumTokenUnlimited
        superPremiumTokenUnlimited
        reasoningTokenUnlimited
        standardCallUnlimited
        premiumCallUnlimited
        superPremiumCallUnlimited
        reasoningCallUnlimited
        createdAt
        updatedAt
        __typename
      }
      usageTapUsageApiKey
      lowApiCreditNotificationEmails
      lowApiCreditNotificationMinimumCredit
      lastLowApiCreditNotificationSentAt
      integrationApiKey1Hash
      integrationApiKey1Status
      integrationApiKey1Prefix
      integrationApiKey1LastRotatedAt
      integrationApiKey1Scopes
      integrationApiKey2Hash
      integrationApiKey2Status
      integrationApiKey2Prefix
      integrationApiKey2LastRotatedAt
      integrationApiKey2Scopes
      updatedAt
      __typename
    }
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateLLMUserMutationVariables,
  APITypes.UpdateLLMUserMutation
>;
export const deleteLLMUser = /* GraphQL */ `mutation DeleteLLMUser(
  $input: DeleteLLMUserInput!
  $condition: ModelLLMUserConditionInput
) {
  deleteLLMUser(input: $input, condition: $condition) {
    id
    email
    status
    displayName
    acceptedTermsOfService
    acceptedGDPRTerms
    projectId
    project {
      id
      name
      status
      description
      users {
        items {
          id
          email
          status
          displayName
          acceptedTermsOfService
          acceptedGDPRTerms
          projectId
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      services {
        items {
          id
          name
          status
          vendor
          region
          endpoint
          body
          header
          projectId
          loadProportion
          inputTokenPricePerMillion
          outputTokenPricePerMillion
          groupId
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      stripeCustomerId
      subscription {
        id
        projectId
        quantity
        subscriptionId
        subscriptionStartDate
        subscriptionEndDate
        subscriptionStatus
        subscriptionProduct
        subscriptionInterval
        subscriptionEndedAt
        subscriptionCancelAtPeriodEnd
        usageSubscriptionId
        createdAt
        updatedAt
        __typename
      }
      newCustomerTokenCount
      cacheResponsesForSeconds
      loadSheddingTier
      newCustomerLoadSheddingTier
      maintenanceMode
      maintenanceModeMessage
      loadBalancingMode
      piiRedactionScope
      systemInstructions
      piiScope
      piiGroupId
      piiMessage
      promptBlacklist
      blacklistGroupId
      blacklistMessage
      safety
      safetyGroupId
      safetyMessage
      strongModelGroupId
      routeModel
      trialTokensRemaining
      logfileRetentionPeriod
      callRetentionPeriod
      logInterval
      lastLogGeneratedAt
      logGenerationCursor
      enterpriseAllowChat
      enterpriseAcceptableUsePolicy
      enterpriseAccessRequestEmail
      enterpriseSupportEmail
      enterpriseDomainWhitelist
      enterpriseTokenBudget
      enterpriseTokenBudgetPeriod
      enterpriseImageUrl
      randomGroup
      apiCreditRemaining
      createdAt
      summaryEmailPeriod
      summaryEmailAddresses
      lastSummaryEmailSentAt
      mcpServerWhitelist
      automaticModelManagement
      supersmallGroupModels
      standardGroupModels
      premiumGroupModels
      reasoningGroupModels
      superpremiumGroupModels
      openrouterStandardGroupModels
      openrouterPremiumGroupModels
      azureOpenaiBaseUrl
      azureOpenaiApiVersion
      awsBedrockRegion
      newCustomerUsageTierId
      newCustomerUsageTier {
        id
        projectId
        status
        name
        description
        version
        activeAt
        inactiveAt
        priorUsageTierId
        priorUsageTier {
          id
          projectId
          status
          name
          description
          version
          activeAt
          inactiveAt
          priorUsageTierId
          baseUsageTierId
          replenishmentPeriod
          replenishmentMethod
          usageLimitAction
          standardTokenReplenishmentAmount
          premiumTokenReplenishmentAmount
          superPremiumTokenReplenishmentAmount
          reasoningTokenReplenishmentAmount
          standardCallReplenishmentAmount
          premiumCallReplenishmentAmount
          superPremiumCallReplenishmentAmount
          reasoningCallReplenishmentAmount
          standardTokenUnlimited
          premiumTokenUnlimited
          superPremiumTokenUnlimited
          reasoningTokenUnlimited
          standardCallUnlimited
          premiumCallUnlimited
          superPremiumCallUnlimited
          reasoningCallUnlimited
          createdAt
          updatedAt
          __typename
        }
        baseUsageTierId
        baseUsageTier {
          id
          projectId
          status
          name
          description
          version
          activeAt
          inactiveAt
          priorUsageTierId
          baseUsageTierId
          replenishmentPeriod
          replenishmentMethod
          usageLimitAction
          standardTokenReplenishmentAmount
          premiumTokenReplenishmentAmount
          superPremiumTokenReplenishmentAmount
          reasoningTokenReplenishmentAmount
          standardCallReplenishmentAmount
          premiumCallReplenishmentAmount
          superPremiumCallReplenishmentAmount
          reasoningCallReplenishmentAmount
          standardTokenUnlimited
          premiumTokenUnlimited
          superPremiumTokenUnlimited
          reasoningTokenUnlimited
          standardCallUnlimited
          premiumCallUnlimited
          superPremiumCallUnlimited
          reasoningCallUnlimited
          createdAt
          updatedAt
          __typename
        }
        replenishmentPeriod
        replenishmentMethod
        usageLimitAction
        standardTokenReplenishmentAmount
        premiumTokenReplenishmentAmount
        superPremiumTokenReplenishmentAmount
        reasoningTokenReplenishmentAmount
        standardCallReplenishmentAmount
        premiumCallReplenishmentAmount
        superPremiumCallReplenishmentAmount
        reasoningCallReplenishmentAmount
        standardTokenUnlimited
        premiumTokenUnlimited
        superPremiumTokenUnlimited
        reasoningTokenUnlimited
        standardCallUnlimited
        premiumCallUnlimited
        superPremiumCallUnlimited
        reasoningCallUnlimited
        createdAt
        updatedAt
        __typename
      }
      usageTapUsageApiKey
      lowApiCreditNotificationEmails
      lowApiCreditNotificationMinimumCredit
      lastLowApiCreditNotificationSentAt
      integrationApiKey1Hash
      integrationApiKey1Status
      integrationApiKey1Prefix
      integrationApiKey1LastRotatedAt
      integrationApiKey1Scopes
      integrationApiKey2Hash
      integrationApiKey2Status
      integrationApiKey2Prefix
      integrationApiKey2LastRotatedAt
      integrationApiKey2Scopes
      updatedAt
      __typename
    }
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteLLMUserMutationVariables,
  APITypes.DeleteLLMUserMutation
>;
export const createLLMService = /* GraphQL */ `mutation CreateLLMService(
  $input: CreateLLMServiceInput!
  $condition: ModelLLMServiceConditionInput
) {
  createLLMService(input: $input, condition: $condition) {
    id
    name
    status
    vendor
    region
    endpoint
    body
    header
    projectId
    loadProportion
    inputTokenPricePerMillion
    outputTokenPricePerMillion
    groupId
    group {
      id
      status
      name
      description
      projectId
      systemInstructions
      systemInstructionsAction
      order
      createdAt
      updatedAt
      __typename
    }
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateLLMServiceMutationVariables,
  APITypes.CreateLLMServiceMutation
>;
export const updateLLMService = /* GraphQL */ `mutation UpdateLLMService(
  $input: UpdateLLMServiceInput!
  $condition: ModelLLMServiceConditionInput
) {
  updateLLMService(input: $input, condition: $condition) {
    id
    name
    status
    vendor
    region
    endpoint
    body
    header
    projectId
    loadProportion
    inputTokenPricePerMillion
    outputTokenPricePerMillion
    groupId
    group {
      id
      status
      name
      description
      projectId
      systemInstructions
      systemInstructionsAction
      order
      createdAt
      updatedAt
      __typename
    }
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateLLMServiceMutationVariables,
  APITypes.UpdateLLMServiceMutation
>;
export const deleteLLMService = /* GraphQL */ `mutation DeleteLLMService(
  $input: DeleteLLMServiceInput!
  $condition: ModelLLMServiceConditionInput
) {
  deleteLLMService(input: $input, condition: $condition) {
    id
    name
    status
    vendor
    region
    endpoint
    body
    header
    projectId
    loadProportion
    inputTokenPricePerMillion
    outputTokenPricePerMillion
    groupId
    group {
      id
      status
      name
      description
      projectId
      systemInstructions
      systemInstructionsAction
      order
      createdAt
      updatedAt
      __typename
    }
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteLLMServiceMutationVariables,
  APITypes.DeleteLLMServiceMutation
>;
export const createLLMGroup = /* GraphQL */ `mutation CreateLLMGroup(
  $input: CreateLLMGroupInput!
  $condition: ModelLLMGroupConditionInput
) {
  createLLMGroup(input: $input, condition: $condition) {
    id
    status
    name
    description
    projectId
    systemInstructions
    systemInstructionsAction
    order
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateLLMGroupMutationVariables,
  APITypes.CreateLLMGroupMutation
>;
export const updateLLMGroup = /* GraphQL */ `mutation UpdateLLMGroup(
  $input: UpdateLLMGroupInput!
  $condition: ModelLLMGroupConditionInput
) {
  updateLLMGroup(input: $input, condition: $condition) {
    id
    status
    name
    description
    projectId
    systemInstructions
    systemInstructionsAction
    order
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateLLMGroupMutationVariables,
  APITypes.UpdateLLMGroupMutation
>;
export const deleteLLMGroup = /* GraphQL */ `mutation DeleteLLMGroup(
  $input: DeleteLLMGroupInput!
  $condition: ModelLLMGroupConditionInput
) {
  deleteLLMGroup(input: $input, condition: $condition) {
    id
    status
    name
    description
    projectId
    systemInstructions
    systemInstructionsAction
    order
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteLLMGroupMutationVariables,
  APITypes.DeleteLLMGroupMutation
>;
export const createLLMCustomer = /* GraphQL */ `mutation CreateLLMCustomer(
  $input: CreateLLMCustomerInput!
  $condition: ModelLLMCustomerConditionInput
) {
  createLLMCustomer(input: $input, condition: $condition) {
    id
    name
    status
    tokensRemaining
    lastCallMadeAt
    numberOfCallsMade
    projectId
    loadSheddingTier
    dataResidency
    createdAt
    enterpriseUser
    tokenReplenishmentAmount
    tokenReplenishmentPeriod
    lastReplenishedAt
    nextReplenishAt
    usageTierId
    usageTier {
      id
      projectId
      status
      name
      description
      version
      activeAt
      inactiveAt
      priorUsageTierId
      priorUsageTier {
        id
        projectId
        status
        name
        description
        version
        activeAt
        inactiveAt
        priorUsageTierId
        priorUsageTier {
          id
          projectId
          status
          name
          description
          version
          activeAt
          inactiveAt
          priorUsageTierId
          baseUsageTierId
          replenishmentPeriod
          replenishmentMethod
          usageLimitAction
          standardTokenReplenishmentAmount
          premiumTokenReplenishmentAmount
          superPremiumTokenReplenishmentAmount
          reasoningTokenReplenishmentAmount
          standardCallReplenishmentAmount
          premiumCallReplenishmentAmount
          superPremiumCallReplenishmentAmount
          reasoningCallReplenishmentAmount
          standardTokenUnlimited
          premiumTokenUnlimited
          superPremiumTokenUnlimited
          reasoningTokenUnlimited
          standardCallUnlimited
          premiumCallUnlimited
          superPremiumCallUnlimited
          reasoningCallUnlimited
          createdAt
          updatedAt
          __typename
        }
        baseUsageTierId
        baseUsageTier {
          id
          projectId
          status
          name
          description
          version
          activeAt
          inactiveAt
          priorUsageTierId
          baseUsageTierId
          replenishmentPeriod
          replenishmentMethod
          usageLimitAction
          standardTokenReplenishmentAmount
          premiumTokenReplenishmentAmount
          superPremiumTokenReplenishmentAmount
          reasoningTokenReplenishmentAmount
          standardCallReplenishmentAmount
          premiumCallReplenishmentAmount
          superPremiumCallReplenishmentAmount
          reasoningCallReplenishmentAmount
          standardTokenUnlimited
          premiumTokenUnlimited
          superPremiumTokenUnlimited
          reasoningTokenUnlimited
          standardCallUnlimited
          premiumCallUnlimited
          superPremiumCallUnlimited
          reasoningCallUnlimited
          createdAt
          updatedAt
          __typename
        }
        replenishmentPeriod
        replenishmentMethod
        usageLimitAction
        standardTokenReplenishmentAmount
        premiumTokenReplenishmentAmount
        superPremiumTokenReplenishmentAmount
        reasoningTokenReplenishmentAmount
        standardCallReplenishmentAmount
        premiumCallReplenishmentAmount
        superPremiumCallReplenishmentAmount
        reasoningCallReplenishmentAmount
        standardTokenUnlimited
        premiumTokenUnlimited
        superPremiumTokenUnlimited
        reasoningTokenUnlimited
        standardCallUnlimited
        premiumCallUnlimited
        superPremiumCallUnlimited
        reasoningCallUnlimited
        createdAt
        updatedAt
        __typename
      }
      baseUsageTierId
      baseUsageTier {
        id
        projectId
        status
        name
        description
        version
        activeAt
        inactiveAt
        priorUsageTierId
        priorUsageTier {
          id
          projectId
          status
          name
          description
          version
          activeAt
          inactiveAt
          priorUsageTierId
          baseUsageTierId
          replenishmentPeriod
          replenishmentMethod
          usageLimitAction
          standardTokenReplenishmentAmount
          premiumTokenReplenishmentAmount
          superPremiumTokenReplenishmentAmount
          reasoningTokenReplenishmentAmount
          standardCallReplenishmentAmount
          premiumCallReplenishmentAmount
          superPremiumCallReplenishmentAmount
          reasoningCallReplenishmentAmount
          standardTokenUnlimited
          premiumTokenUnlimited
          superPremiumTokenUnlimited
          reasoningTokenUnlimited
          standardCallUnlimited
          premiumCallUnlimited
          superPremiumCallUnlimited
          reasoningCallUnlimited
          createdAt
          updatedAt
          __typename
        }
        baseUsageTierId
        baseUsageTier {
          id
          projectId
          status
          name
          description
          version
          activeAt
          inactiveAt
          priorUsageTierId
          baseUsageTierId
          replenishmentPeriod
          replenishmentMethod
          usageLimitAction
          standardTokenReplenishmentAmount
          premiumTokenReplenishmentAmount
          superPremiumTokenReplenishmentAmount
          reasoningTokenReplenishmentAmount
          standardCallReplenishmentAmount
          premiumCallReplenishmentAmount
          superPremiumCallReplenishmentAmount
          reasoningCallReplenishmentAmount
          standardTokenUnlimited
          premiumTokenUnlimited
          superPremiumTokenUnlimited
          reasoningTokenUnlimited
          standardCallUnlimited
          premiumCallUnlimited
          superPremiumCallUnlimited
          reasoningCallUnlimited
          createdAt
          updatedAt
          __typename
        }
        replenishmentPeriod
        replenishmentMethod
        usageLimitAction
        standardTokenReplenishmentAmount
        premiumTokenReplenishmentAmount
        superPremiumTokenReplenishmentAmount
        reasoningTokenReplenishmentAmount
        standardCallReplenishmentAmount
        premiumCallReplenishmentAmount
        superPremiumCallReplenishmentAmount
        reasoningCallReplenishmentAmount
        standardTokenUnlimited
        premiumTokenUnlimited
        superPremiumTokenUnlimited
        reasoningTokenUnlimited
        standardCallUnlimited
        premiumCallUnlimited
        superPremiumCallUnlimited
        reasoningCallUnlimited
        createdAt
        updatedAt
        __typename
      }
      replenishmentPeriod
      replenishmentMethod
      usageLimitAction
      standardTokenReplenishmentAmount
      premiumTokenReplenishmentAmount
      superPremiumTokenReplenishmentAmount
      reasoningTokenReplenishmentAmount
      standardCallReplenishmentAmount
      premiumCallReplenishmentAmount
      superPremiumCallReplenishmentAmount
      reasoningCallReplenishmentAmount
      standardTokenUnlimited
      premiumTokenUnlimited
      superPremiumTokenUnlimited
      reasoningTokenUnlimited
      standardCallUnlimited
      premiumCallUnlimited
      superPremiumCallUnlimited
      reasoningCallUnlimited
      createdAt
      updatedAt
      __typename
    }
    nextUsageTierId
    nextUsageTier {
      id
      projectId
      status
      name
      description
      version
      activeAt
      inactiveAt
      priorUsageTierId
      priorUsageTier {
        id
        projectId
        status
        name
        description
        version
        activeAt
        inactiveAt
        priorUsageTierId
        priorUsageTier {
          id
          projectId
          status
          name
          description
          version
          activeAt
          inactiveAt
          priorUsageTierId
          baseUsageTierId
          replenishmentPeriod
          replenishmentMethod
          usageLimitAction
          standardTokenReplenishmentAmount
          premiumTokenReplenishmentAmount
          superPremiumTokenReplenishmentAmount
          reasoningTokenReplenishmentAmount
          standardCallReplenishmentAmount
          premiumCallReplenishmentAmount
          superPremiumCallReplenishmentAmount
          reasoningCallReplenishmentAmount
          standardTokenUnlimited
          premiumTokenUnlimited
          superPremiumTokenUnlimited
          reasoningTokenUnlimited
          standardCallUnlimited
          premiumCallUnlimited
          superPremiumCallUnlimited
          reasoningCallUnlimited
          createdAt
          updatedAt
          __typename
        }
        baseUsageTierId
        baseUsageTier {
          id
          projectId
          status
          name
          description
          version
          activeAt
          inactiveAt
          priorUsageTierId
          baseUsageTierId
          replenishmentPeriod
          replenishmentMethod
          usageLimitAction
          standardTokenReplenishmentAmount
          premiumTokenReplenishmentAmount
          superPremiumTokenReplenishmentAmount
          reasoningTokenReplenishmentAmount
          standardCallReplenishmentAmount
          premiumCallReplenishmentAmount
          superPremiumCallReplenishmentAmount
          reasoningCallReplenishmentAmount
          standardTokenUnlimited
          premiumTokenUnlimited
          superPremiumTokenUnlimited
          reasoningTokenUnlimited
          standardCallUnlimited
          premiumCallUnlimited
          superPremiumCallUnlimited
          reasoningCallUnlimited
          createdAt
          updatedAt
          __typename
        }
        replenishmentPeriod
        replenishmentMethod
        usageLimitAction
        standardTokenReplenishmentAmount
        premiumTokenReplenishmentAmount
        superPremiumTokenReplenishmentAmount
        reasoningTokenReplenishmentAmount
        standardCallReplenishmentAmount
        premiumCallReplenishmentAmount
        superPremiumCallReplenishmentAmount
        reasoningCallReplenishmentAmount
        standardTokenUnlimited
        premiumTokenUnlimited
        superPremiumTokenUnlimited
        reasoningTokenUnlimited
        standardCallUnlimited
        premiumCallUnlimited
        superPremiumCallUnlimited
        reasoningCallUnlimited
        createdAt
        updatedAt
        __typename
      }
      baseUsageTierId
      baseUsageTier {
        id
        projectId
        status
        name
        description
        version
        activeAt
        inactiveAt
        priorUsageTierId
        priorUsageTier {
          id
          projectId
          status
          name
          description
          version
          activeAt
          inactiveAt
          priorUsageTierId
          baseUsageTierId
          replenishmentPeriod
          replenishmentMethod
          usageLimitAction
          standardTokenReplenishmentAmount
          premiumTokenReplenishmentAmount
          superPremiumTokenReplenishmentAmount
          reasoningTokenReplenishmentAmount
          standardCallReplenishmentAmount
          premiumCallReplenishmentAmount
          superPremiumCallReplenishmentAmount
          reasoningCallReplenishmentAmount
          standardTokenUnlimited
          premiumTokenUnlimited
          superPremiumTokenUnlimited
          reasoningTokenUnlimited
          standardCallUnlimited
          premiumCallUnlimited
          superPremiumCallUnlimited
          reasoningCallUnlimited
          createdAt
          updatedAt
          __typename
        }
        baseUsageTierId
        baseUsageTier {
          id
          projectId
          status
          name
          description
          version
          activeAt
          inactiveAt
          priorUsageTierId
          baseUsageTierId
          replenishmentPeriod
          replenishmentMethod
          usageLimitAction
          standardTokenReplenishmentAmount
          premiumTokenReplenishmentAmount
          superPremiumTokenReplenishmentAmount
          reasoningTokenReplenishmentAmount
          standardCallReplenishmentAmount
          premiumCallReplenishmentAmount
          superPremiumCallReplenishmentAmount
          reasoningCallReplenishmentAmount
          standardTokenUnlimited
          premiumTokenUnlimited
          superPremiumTokenUnlimited
          reasoningTokenUnlimited
          standardCallUnlimited
          premiumCallUnlimited
          superPremiumCallUnlimited
          reasoningCallUnlimited
          createdAt
          updatedAt
          __typename
        }
        replenishmentPeriod
        replenishmentMethod
        usageLimitAction
        standardTokenReplenishmentAmount
        premiumTokenReplenishmentAmount
        superPremiumTokenReplenishmentAmount
        reasoningTokenReplenishmentAmount
        standardCallReplenishmentAmount
        premiumCallReplenishmentAmount
        superPremiumCallReplenishmentAmount
        reasoningCallReplenishmentAmount
        standardTokenUnlimited
        premiumTokenUnlimited
        superPremiumTokenUnlimited
        reasoningTokenUnlimited
        standardCallUnlimited
        premiumCallUnlimited
        superPremiumCallUnlimited
        reasoningCallUnlimited
        createdAt
        updatedAt
        __typename
      }
      replenishmentPeriod
      replenishmentMethod
      usageLimitAction
      standardTokenReplenishmentAmount
      premiumTokenReplenishmentAmount
      superPremiumTokenReplenishmentAmount
      reasoningTokenReplenishmentAmount
      standardCallReplenishmentAmount
      premiumCallReplenishmentAmount
      superPremiumCallReplenishmentAmount
      reasoningCallReplenishmentAmount
      standardTokenUnlimited
      premiumTokenUnlimited
      superPremiumTokenUnlimited
      reasoningTokenUnlimited
      standardCallUnlimited
      premiumCallUnlimited
      superPremiumCallUnlimited
      reasoningCallUnlimited
      createdAt
      updatedAt
      __typename
    }
    nextUsageTierAt
    usageLimitAction
    standardTokensRemaining
    premiumTokensRemaining
    superPremiumTokensRemaining
    reasoningTokensRemaining
    standardCallsRemaining
    premiumCallsRemaining
    superPremiumCallsRemaining
    reasoningCallsRemaining
    standardTokenUnlimited
    premiumTokenUnlimited
    superPremiumTokenUnlimited
    reasoningTokenUnlimited
    standardCallUnlimited
    premiumCallUnlimited
    superPremiumCallUnlimited
    reasoningCallUnlimited
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateLLMCustomerMutationVariables,
  APITypes.CreateLLMCustomerMutation
>;
export const updateLLMCustomer = /* GraphQL */ `mutation UpdateLLMCustomer(
  $input: UpdateLLMCustomerInput!
  $condition: ModelLLMCustomerConditionInput
) {
  updateLLMCustomer(input: $input, condition: $condition) {
    id
    name
    status
    tokensRemaining
    lastCallMadeAt
    numberOfCallsMade
    projectId
    loadSheddingTier
    dataResidency
    createdAt
    enterpriseUser
    tokenReplenishmentAmount
    tokenReplenishmentPeriod
    lastReplenishedAt
    nextReplenishAt
    usageTierId
    usageTier {
      id
      projectId
      status
      name
      description
      version
      activeAt
      inactiveAt
      priorUsageTierId
      priorUsageTier {
        id
        projectId
        status
        name
        description
        version
        activeAt
        inactiveAt
        priorUsageTierId
        priorUsageTier {
          id
          projectId
          status
          name
          description
          version
          activeAt
          inactiveAt
          priorUsageTierId
          baseUsageTierId
          replenishmentPeriod
          replenishmentMethod
          usageLimitAction
          standardTokenReplenishmentAmount
          premiumTokenReplenishmentAmount
          superPremiumTokenReplenishmentAmount
          reasoningTokenReplenishmentAmount
          standardCallReplenishmentAmount
          premiumCallReplenishmentAmount
          superPremiumCallReplenishmentAmount
          reasoningCallReplenishmentAmount
          standardTokenUnlimited
          premiumTokenUnlimited
          superPremiumTokenUnlimited
          reasoningTokenUnlimited
          standardCallUnlimited
          premiumCallUnlimited
          superPremiumCallUnlimited
          reasoningCallUnlimited
          createdAt
          updatedAt
          __typename
        }
        baseUsageTierId
        baseUsageTier {
          id
          projectId
          status
          name
          description
          version
          activeAt
          inactiveAt
          priorUsageTierId
          baseUsageTierId
          replenishmentPeriod
          replenishmentMethod
          usageLimitAction
          standardTokenReplenishmentAmount
          premiumTokenReplenishmentAmount
          superPremiumTokenReplenishmentAmount
          reasoningTokenReplenishmentAmount
          standardCallReplenishmentAmount
          premiumCallReplenishmentAmount
          superPremiumCallReplenishmentAmount
          reasoningCallReplenishmentAmount
          standardTokenUnlimited
          premiumTokenUnlimited
          superPremiumTokenUnlimited
          reasoningTokenUnlimited
          standardCallUnlimited
          premiumCallUnlimited
          superPremiumCallUnlimited
          reasoningCallUnlimited
          createdAt
          updatedAt
          __typename
        }
        replenishmentPeriod
        replenishmentMethod
        usageLimitAction
        standardTokenReplenishmentAmount
        premiumTokenReplenishmentAmount
        superPremiumTokenReplenishmentAmount
        reasoningTokenReplenishmentAmount
        standardCallReplenishmentAmount
        premiumCallReplenishmentAmount
        superPremiumCallReplenishmentAmount
        reasoningCallReplenishmentAmount
        standardTokenUnlimited
        premiumTokenUnlimited
        superPremiumTokenUnlimited
        reasoningTokenUnlimited
        standardCallUnlimited
        premiumCallUnlimited
        superPremiumCallUnlimited
        reasoningCallUnlimited
        createdAt
        updatedAt
        __typename
      }
      baseUsageTierId
      baseUsageTier {
        id
        projectId
        status
        name
        description
        version
        activeAt
        inactiveAt
        priorUsageTierId
        priorUsageTier {
          id
          projectId
          status
          name
          description
          version
          activeAt
          inactiveAt
          priorUsageTierId
          baseUsageTierId
          replenishmentPeriod
          replenishmentMethod
          usageLimitAction
          standardTokenReplenishmentAmount
          premiumTokenReplenishmentAmount
          superPremiumTokenReplenishmentAmount
          reasoningTokenReplenishmentAmount
          standardCallReplenishmentAmount
          premiumCallReplenishmentAmount
          superPremiumCallReplenishmentAmount
          reasoningCallReplenishmentAmount
          standardTokenUnlimited
          premiumTokenUnlimited
          superPremiumTokenUnlimited
          reasoningTokenUnlimited
          standardCallUnlimited
          premiumCallUnlimited
          superPremiumCallUnlimited
          reasoningCallUnlimited
          createdAt
          updatedAt
          __typename
        }
        baseUsageTierId
        baseUsageTier {
          id
          projectId
          status
          name
          description
          version
          activeAt
          inactiveAt
          priorUsageTierId
          baseUsageTierId
          replenishmentPeriod
          replenishmentMethod
          usageLimitAction
          standardTokenReplenishmentAmount
          premiumTokenReplenishmentAmount
          superPremiumTokenReplenishmentAmount
          reasoningTokenReplenishmentAmount
          standardCallReplenishmentAmount
          premiumCallReplenishmentAmount
          superPremiumCallReplenishmentAmount
          reasoningCallReplenishmentAmount
          standardTokenUnlimited
          premiumTokenUnlimited
          superPremiumTokenUnlimited
          reasoningTokenUnlimited
          standardCallUnlimited
          premiumCallUnlimited
          superPremiumCallUnlimited
          reasoningCallUnlimited
          createdAt
          updatedAt
          __typename
        }
        replenishmentPeriod
        replenishmentMethod
        usageLimitAction
        standardTokenReplenishmentAmount
        premiumTokenReplenishmentAmount
        superPremiumTokenReplenishmentAmount
        reasoningTokenReplenishmentAmount
        standardCallReplenishmentAmount
        premiumCallReplenishmentAmount
        superPremiumCallReplenishmentAmount
        reasoningCallReplenishmentAmount
        standardTokenUnlimited
        premiumTokenUnlimited
        superPremiumTokenUnlimited
        reasoningTokenUnlimited
        standardCallUnlimited
        premiumCallUnlimited
        superPremiumCallUnlimited
        reasoningCallUnlimited
        createdAt
        updatedAt
        __typename
      }
      replenishmentPeriod
      replenishmentMethod
      usageLimitAction
      standardTokenReplenishmentAmount
      premiumTokenReplenishmentAmount
      superPremiumTokenReplenishmentAmount
      reasoningTokenReplenishmentAmount
      standardCallReplenishmentAmount
      premiumCallReplenishmentAmount
      superPremiumCallReplenishmentAmount
      reasoningCallReplenishmentAmount
      standardTokenUnlimited
      premiumTokenUnlimited
      superPremiumTokenUnlimited
      reasoningTokenUnlimited
      standardCallUnlimited
      premiumCallUnlimited
      superPremiumCallUnlimited
      reasoningCallUnlimited
      createdAt
      updatedAt
      __typename
    }
    nextUsageTierId
    nextUsageTier {
      id
      projectId
      status
      name
      description
      version
      activeAt
      inactiveAt
      priorUsageTierId
      priorUsageTier {
        id
        projectId
        status
        name
        description
        version
        activeAt
        inactiveAt
        priorUsageTierId
        priorUsageTier {
          id
          projectId
          status
          name
          description
          version
          activeAt
          inactiveAt
          priorUsageTierId
          baseUsageTierId
          replenishmentPeriod
          replenishmentMethod
          usageLimitAction
          standardTokenReplenishmentAmount
          premiumTokenReplenishmentAmount
          superPremiumTokenReplenishmentAmount
          reasoningTokenReplenishmentAmount
          standardCallReplenishmentAmount
          premiumCallReplenishmentAmount
          superPremiumCallReplenishmentAmount
          reasoningCallReplenishmentAmount
          standardTokenUnlimited
          premiumTokenUnlimited
          superPremiumTokenUnlimited
          reasoningTokenUnlimited
          standardCallUnlimited
          premiumCallUnlimited
          superPremiumCallUnlimited
          reasoningCallUnlimited
          createdAt
          updatedAt
          __typename
        }
        baseUsageTierId
        baseUsageTier {
          id
          projectId
          status
          name
          description
          version
          activeAt
          inactiveAt
          priorUsageTierId
          baseUsageTierId
          replenishmentPeriod
          replenishmentMethod
          usageLimitAction
          standardTokenReplenishmentAmount
          premiumTokenReplenishmentAmount
          superPremiumTokenReplenishmentAmount
          reasoningTokenReplenishmentAmount
          standardCallReplenishmentAmount
          premiumCallReplenishmentAmount
          superPremiumCallReplenishmentAmount
          reasoningCallReplenishmentAmount
          standardTokenUnlimited
          premiumTokenUnlimited
          superPremiumTokenUnlimited
          reasoningTokenUnlimited
          standardCallUnlimited
          premiumCallUnlimited
          superPremiumCallUnlimited
          reasoningCallUnlimited
          createdAt
          updatedAt
          __typename
        }
        replenishmentPeriod
        replenishmentMethod
        usageLimitAction
        standardTokenReplenishmentAmount
        premiumTokenReplenishmentAmount
        superPremiumTokenReplenishmentAmount
        reasoningTokenReplenishmentAmount
        standardCallReplenishmentAmount
        premiumCallReplenishmentAmount
        superPremiumCallReplenishmentAmount
        reasoningCallReplenishmentAmount
        standardTokenUnlimited
        premiumTokenUnlimited
        superPremiumTokenUnlimited
        reasoningTokenUnlimited
        standardCallUnlimited
        premiumCallUnlimited
        superPremiumCallUnlimited
        reasoningCallUnlimited
        createdAt
        updatedAt
        __typename
      }
      baseUsageTierId
      baseUsageTier {
        id
        projectId
        status
        name
        description
        version
        activeAt
        inactiveAt
        priorUsageTierId
        priorUsageTier {
          id
          projectId
          status
          name
          description
          version
          activeAt
          inactiveAt
          priorUsageTierId
          baseUsageTierId
          replenishmentPeriod
          replenishmentMethod
          usageLimitAction
          standardTokenReplenishmentAmount
          premiumTokenReplenishmentAmount
          superPremiumTokenReplenishmentAmount
          reasoningTokenReplenishmentAmount
          standardCallReplenishmentAmount
          premiumCallReplenishmentAmount
          superPremiumCallReplenishmentAmount
          reasoningCallReplenishmentAmount
          standardTokenUnlimited
          premiumTokenUnlimited
          superPremiumTokenUnlimited
          reasoningTokenUnlimited
          standardCallUnlimited
          premiumCallUnlimited
          superPremiumCallUnlimited
          reasoningCallUnlimited
          createdAt
          updatedAt
          __typename
        }
        baseUsageTierId
        baseUsageTier {
          id
          projectId
          status
          name
          description
          version
          activeAt
          inactiveAt
          priorUsageTierId
          baseUsageTierId
          replenishmentPeriod
          replenishmentMethod
          usageLimitAction
          standardTokenReplenishmentAmount
          premiumTokenReplenishmentAmount
          superPremiumTokenReplenishmentAmount
          reasoningTokenReplenishmentAmount
          standardCallReplenishmentAmount
          premiumCallReplenishmentAmount
          superPremiumCallReplenishmentAmount
          reasoningCallReplenishmentAmount
          standardTokenUnlimited
          premiumTokenUnlimited
          superPremiumTokenUnlimited
          reasoningTokenUnlimited
          standardCallUnlimited
          premiumCallUnlimited
          superPremiumCallUnlimited
          reasoningCallUnlimited
          createdAt
          updatedAt
          __typename
        }
        replenishmentPeriod
        replenishmentMethod
        usageLimitAction
        standardTokenReplenishmentAmount
        premiumTokenReplenishmentAmount
        superPremiumTokenReplenishmentAmount
        reasoningTokenReplenishmentAmount
        standardCallReplenishmentAmount
        premiumCallReplenishmentAmount
        superPremiumCallReplenishmentAmount
        reasoningCallReplenishmentAmount
        standardTokenUnlimited
        premiumTokenUnlimited
        superPremiumTokenUnlimited
        reasoningTokenUnlimited
        standardCallUnlimited
        premiumCallUnlimited
        superPremiumCallUnlimited
        reasoningCallUnlimited
        createdAt
        updatedAt
        __typename
      }
      replenishmentPeriod
      replenishmentMethod
      usageLimitAction
      standardTokenReplenishmentAmount
      premiumTokenReplenishmentAmount
      superPremiumTokenReplenishmentAmount
      reasoningTokenReplenishmentAmount
      standardCallReplenishmentAmount
      premiumCallReplenishmentAmount
      superPremiumCallReplenishmentAmount
      reasoningCallReplenishmentAmount
      standardTokenUnlimited
      premiumTokenUnlimited
      superPremiumTokenUnlimited
      reasoningTokenUnlimited
      standardCallUnlimited
      premiumCallUnlimited
      superPremiumCallUnlimited
      reasoningCallUnlimited
      createdAt
      updatedAt
      __typename
    }
    nextUsageTierAt
    usageLimitAction
    standardTokensRemaining
    premiumTokensRemaining
    superPremiumTokensRemaining
    reasoningTokensRemaining
    standardCallsRemaining
    premiumCallsRemaining
    superPremiumCallsRemaining
    reasoningCallsRemaining
    standardTokenUnlimited
    premiumTokenUnlimited
    superPremiumTokenUnlimited
    reasoningTokenUnlimited
    standardCallUnlimited
    premiumCallUnlimited
    superPremiumCallUnlimited
    reasoningCallUnlimited
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateLLMCustomerMutationVariables,
  APITypes.UpdateLLMCustomerMutation
>;
export const deleteLLMCustomer = /* GraphQL */ `mutation DeleteLLMCustomer(
  $input: DeleteLLMCustomerInput!
  $condition: ModelLLMCustomerConditionInput
) {
  deleteLLMCustomer(input: $input, condition: $condition) {
    id
    name
    status
    tokensRemaining
    lastCallMadeAt
    numberOfCallsMade
    projectId
    loadSheddingTier
    dataResidency
    createdAt
    enterpriseUser
    tokenReplenishmentAmount
    tokenReplenishmentPeriod
    lastReplenishedAt
    nextReplenishAt
    usageTierId
    usageTier {
      id
      projectId
      status
      name
      description
      version
      activeAt
      inactiveAt
      priorUsageTierId
      priorUsageTier {
        id
        projectId
        status
        name
        description
        version
        activeAt
        inactiveAt
        priorUsageTierId
        priorUsageTier {
          id
          projectId
          status
          name
          description
          version
          activeAt
          inactiveAt
          priorUsageTierId
          baseUsageTierId
          replenishmentPeriod
          replenishmentMethod
          usageLimitAction
          standardTokenReplenishmentAmount
          premiumTokenReplenishmentAmount
          superPremiumTokenReplenishmentAmount
          reasoningTokenReplenishmentAmount
          standardCallReplenishmentAmount
          premiumCallReplenishmentAmount
          superPremiumCallReplenishmentAmount
          reasoningCallReplenishmentAmount
          standardTokenUnlimited
          premiumTokenUnlimited
          superPremiumTokenUnlimited
          reasoningTokenUnlimited
          standardCallUnlimited
          premiumCallUnlimited
          superPremiumCallUnlimited
          reasoningCallUnlimited
          createdAt
          updatedAt
          __typename
        }
        baseUsageTierId
        baseUsageTier {
          id
          projectId
          status
          name
          description
          version
          activeAt
          inactiveAt
          priorUsageTierId
          baseUsageTierId
          replenishmentPeriod
          replenishmentMethod
          usageLimitAction
          standardTokenReplenishmentAmount
          premiumTokenReplenishmentAmount
          superPremiumTokenReplenishmentAmount
          reasoningTokenReplenishmentAmount
          standardCallReplenishmentAmount
          premiumCallReplenishmentAmount
          superPremiumCallReplenishmentAmount
          reasoningCallReplenishmentAmount
          standardTokenUnlimited
          premiumTokenUnlimited
          superPremiumTokenUnlimited
          reasoningTokenUnlimited
          standardCallUnlimited
          premiumCallUnlimited
          superPremiumCallUnlimited
          reasoningCallUnlimited
          createdAt
          updatedAt
          __typename
        }
        replenishmentPeriod
        replenishmentMethod
        usageLimitAction
        standardTokenReplenishmentAmount
        premiumTokenReplenishmentAmount
        superPremiumTokenReplenishmentAmount
        reasoningTokenReplenishmentAmount
        standardCallReplenishmentAmount
        premiumCallReplenishmentAmount
        superPremiumCallReplenishmentAmount
        reasoningCallReplenishmentAmount
        standardTokenUnlimited
        premiumTokenUnlimited
        superPremiumTokenUnlimited
        reasoningTokenUnlimited
        standardCallUnlimited
        premiumCallUnlimited
        superPremiumCallUnlimited
        reasoningCallUnlimited
        createdAt
        updatedAt
        __typename
      }
      baseUsageTierId
      baseUsageTier {
        id
        projectId
        status
        name
        description
        version
        activeAt
        inactiveAt
        priorUsageTierId
        priorUsageTier {
          id
          projectId
          status
          name
          description
          version
          activeAt
          inactiveAt
          priorUsageTierId
          baseUsageTierId
          replenishmentPeriod
          replenishmentMethod
          usageLimitAction
          standardTokenReplenishmentAmount
          premiumTokenReplenishmentAmount
          superPremiumTokenReplenishmentAmount
          reasoningTokenReplenishmentAmount
          standardCallReplenishmentAmount
          premiumCallReplenishmentAmount
          superPremiumCallReplenishmentAmount
          reasoningCallReplenishmentAmount
          standardTokenUnlimited
          premiumTokenUnlimited
          superPremiumTokenUnlimited
          reasoningTokenUnlimited
          standardCallUnlimited
          premiumCallUnlimited
          superPremiumCallUnlimited
          reasoningCallUnlimited
          createdAt
          updatedAt
          __typename
        }
        baseUsageTierId
        baseUsageTier {
          id
          projectId
          status
          name
          description
          version
          activeAt
          inactiveAt
          priorUsageTierId
          baseUsageTierId
          replenishmentPeriod
          replenishmentMethod
          usageLimitAction
          standardTokenReplenishmentAmount
          premiumTokenReplenishmentAmount
          superPremiumTokenReplenishmentAmount
          reasoningTokenReplenishmentAmount
          standardCallReplenishmentAmount
          premiumCallReplenishmentAmount
          superPremiumCallReplenishmentAmount
          reasoningCallReplenishmentAmount
          standardTokenUnlimited
          premiumTokenUnlimited
          superPremiumTokenUnlimited
          reasoningTokenUnlimited
          standardCallUnlimited
          premiumCallUnlimited
          superPremiumCallUnlimited
          reasoningCallUnlimited
          createdAt
          updatedAt
          __typename
        }
        replenishmentPeriod
        replenishmentMethod
        usageLimitAction
        standardTokenReplenishmentAmount
        premiumTokenReplenishmentAmount
        superPremiumTokenReplenishmentAmount
        reasoningTokenReplenishmentAmount
        standardCallReplenishmentAmount
        premiumCallReplenishmentAmount
        superPremiumCallReplenishmentAmount
        reasoningCallReplenishmentAmount
        standardTokenUnlimited
        premiumTokenUnlimited
        superPremiumTokenUnlimited
        reasoningTokenUnlimited
        standardCallUnlimited
        premiumCallUnlimited
        superPremiumCallUnlimited
        reasoningCallUnlimited
        createdAt
        updatedAt
        __typename
      }
      replenishmentPeriod
      replenishmentMethod
      usageLimitAction
      standardTokenReplenishmentAmount
      premiumTokenReplenishmentAmount
      superPremiumTokenReplenishmentAmount
      reasoningTokenReplenishmentAmount
      standardCallReplenishmentAmount
      premiumCallReplenishmentAmount
      superPremiumCallReplenishmentAmount
      reasoningCallReplenishmentAmount
      standardTokenUnlimited
      premiumTokenUnlimited
      superPremiumTokenUnlimited
      reasoningTokenUnlimited
      standardCallUnlimited
      premiumCallUnlimited
      superPremiumCallUnlimited
      reasoningCallUnlimited
      createdAt
      updatedAt
      __typename
    }
    nextUsageTierId
    nextUsageTier {
      id
      projectId
      status
      name
      description
      version
      activeAt
      inactiveAt
      priorUsageTierId
      priorUsageTier {
        id
        projectId
        status
        name
        description
        version
        activeAt
        inactiveAt
        priorUsageTierId
        priorUsageTier {
          id
          projectId
          status
          name
          description
          version
          activeAt
          inactiveAt
          priorUsageTierId
          baseUsageTierId
          replenishmentPeriod
          replenishmentMethod
          usageLimitAction
          standardTokenReplenishmentAmount
          premiumTokenReplenishmentAmount
          superPremiumTokenReplenishmentAmount
          reasoningTokenReplenishmentAmount
          standardCallReplenishmentAmount
          premiumCallReplenishmentAmount
          superPremiumCallReplenishmentAmount
          reasoningCallReplenishmentAmount
          standardTokenUnlimited
          premiumTokenUnlimited
          superPremiumTokenUnlimited
          reasoningTokenUnlimited
          standardCallUnlimited
          premiumCallUnlimited
          superPremiumCallUnlimited
          reasoningCallUnlimited
          createdAt
          updatedAt
          __typename
        }
        baseUsageTierId
        baseUsageTier {
          id
          projectId
          status
          name
          description
          version
          activeAt
          inactiveAt
          priorUsageTierId
          baseUsageTierId
          replenishmentPeriod
          replenishmentMethod
          usageLimitAction
          standardTokenReplenishmentAmount
          premiumTokenReplenishmentAmount
          superPremiumTokenReplenishmentAmount
          reasoningTokenReplenishmentAmount
          standardCallReplenishmentAmount
          premiumCallReplenishmentAmount
          superPremiumCallReplenishmentAmount
          reasoningCallReplenishmentAmount
          standardTokenUnlimited
          premiumTokenUnlimited
          superPremiumTokenUnlimited
          reasoningTokenUnlimited
          standardCallUnlimited
          premiumCallUnlimited
          superPremiumCallUnlimited
          reasoningCallUnlimited
          createdAt
          updatedAt
          __typename
        }
        replenishmentPeriod
        replenishmentMethod
        usageLimitAction
        standardTokenReplenishmentAmount
        premiumTokenReplenishmentAmount
        superPremiumTokenReplenishmentAmount
        reasoningTokenReplenishmentAmount
        standardCallReplenishmentAmount
        premiumCallReplenishmentAmount
        superPremiumCallReplenishmentAmount
        reasoningCallReplenishmentAmount
        standardTokenUnlimited
        premiumTokenUnlimited
        superPremiumTokenUnlimited
        reasoningTokenUnlimited
        standardCallUnlimited
        premiumCallUnlimited
        superPremiumCallUnlimited
        reasoningCallUnlimited
        createdAt
        updatedAt
        __typename
      }
      baseUsageTierId
      baseUsageTier {
        id
        projectId
        status
        name
        description
        version
        activeAt
        inactiveAt
        priorUsageTierId
        priorUsageTier {
          id
          projectId
          status
          name
          description
          version
          activeAt
          inactiveAt
          priorUsageTierId
          baseUsageTierId
          replenishmentPeriod
          replenishmentMethod
          usageLimitAction
          standardTokenReplenishmentAmount
          premiumTokenReplenishmentAmount
          superPremiumTokenReplenishmentAmount
          reasoningTokenReplenishmentAmount
          standardCallReplenishmentAmount
          premiumCallReplenishmentAmount
          superPremiumCallReplenishmentAmount
          reasoningCallReplenishmentAmount
          standardTokenUnlimited
          premiumTokenUnlimited
          superPremiumTokenUnlimited
          reasoningTokenUnlimited
          standardCallUnlimited
          premiumCallUnlimited
          superPremiumCallUnlimited
          reasoningCallUnlimited
          createdAt
          updatedAt
          __typename
        }
        baseUsageTierId
        baseUsageTier {
          id
          projectId
          status
          name
          description
          version
          activeAt
          inactiveAt
          priorUsageTierId
          baseUsageTierId
          replenishmentPeriod
          replenishmentMethod
          usageLimitAction
          standardTokenReplenishmentAmount
          premiumTokenReplenishmentAmount
          superPremiumTokenReplenishmentAmount
          reasoningTokenReplenishmentAmount
          standardCallReplenishmentAmount
          premiumCallReplenishmentAmount
          superPremiumCallReplenishmentAmount
          reasoningCallReplenishmentAmount
          standardTokenUnlimited
          premiumTokenUnlimited
          superPremiumTokenUnlimited
          reasoningTokenUnlimited
          standardCallUnlimited
          premiumCallUnlimited
          superPremiumCallUnlimited
          reasoningCallUnlimited
          createdAt
          updatedAt
          __typename
        }
        replenishmentPeriod
        replenishmentMethod
        usageLimitAction
        standardTokenReplenishmentAmount
        premiumTokenReplenishmentAmount
        superPremiumTokenReplenishmentAmount
        reasoningTokenReplenishmentAmount
        standardCallReplenishmentAmount
        premiumCallReplenishmentAmount
        superPremiumCallReplenishmentAmount
        reasoningCallReplenishmentAmount
        standardTokenUnlimited
        premiumTokenUnlimited
        superPremiumTokenUnlimited
        reasoningTokenUnlimited
        standardCallUnlimited
        premiumCallUnlimited
        superPremiumCallUnlimited
        reasoningCallUnlimited
        createdAt
        updatedAt
        __typename
      }
      replenishmentPeriod
      replenishmentMethod
      usageLimitAction
      standardTokenReplenishmentAmount
      premiumTokenReplenishmentAmount
      superPremiumTokenReplenishmentAmount
      reasoningTokenReplenishmentAmount
      standardCallReplenishmentAmount
      premiumCallReplenishmentAmount
      superPremiumCallReplenishmentAmount
      reasoningCallReplenishmentAmount
      standardTokenUnlimited
      premiumTokenUnlimited
      superPremiumTokenUnlimited
      reasoningTokenUnlimited
      standardCallUnlimited
      premiumCallUnlimited
      superPremiumCallUnlimited
      reasoningCallUnlimited
      createdAt
      updatedAt
      __typename
    }
    nextUsageTierAt
    usageLimitAction
    standardTokensRemaining
    premiumTokensRemaining
    superPremiumTokensRemaining
    reasoningTokensRemaining
    standardCallsRemaining
    premiumCallsRemaining
    superPremiumCallsRemaining
    reasoningCallsRemaining
    standardTokenUnlimited
    premiumTokenUnlimited
    superPremiumTokenUnlimited
    reasoningTokenUnlimited
    standardCallUnlimited
    premiumCallUnlimited
    superPremiumCallUnlimited
    reasoningCallUnlimited
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteLLMCustomerMutationVariables,
  APITypes.DeleteLLMCustomerMutation
>;
export const createLLMCall = /* GraphQL */ `mutation CreateLLMCall(
  $input: CreateLLMCallInput!
  $condition: ModelLLMCallConditionInput
) {
  createLLMCall(input: $input, condition: $condition) {
    id
    projectId
    status
    customerId
    customer {
      id
      name
      status
      tokensRemaining
      lastCallMadeAt
      numberOfCallsMade
      projectId
      loadSheddingTier
      dataResidency
      createdAt
      enterpriseUser
      tokenReplenishmentAmount
      tokenReplenishmentPeriod
      lastReplenishedAt
      nextReplenishAt
      usageTierId
      usageTier {
        id
        projectId
        status
        name
        description
        version
        activeAt
        inactiveAt
        priorUsageTierId
        priorUsageTier {
          id
          projectId
          status
          name
          description
          version
          activeAt
          inactiveAt
          priorUsageTierId
          baseUsageTierId
          replenishmentPeriod
          replenishmentMethod
          usageLimitAction
          standardTokenReplenishmentAmount
          premiumTokenReplenishmentAmount
          superPremiumTokenReplenishmentAmount
          reasoningTokenReplenishmentAmount
          standardCallReplenishmentAmount
          premiumCallReplenishmentAmount
          superPremiumCallReplenishmentAmount
          reasoningCallReplenishmentAmount
          standardTokenUnlimited
          premiumTokenUnlimited
          superPremiumTokenUnlimited
          reasoningTokenUnlimited
          standardCallUnlimited
          premiumCallUnlimited
          superPremiumCallUnlimited
          reasoningCallUnlimited
          createdAt
          updatedAt
          __typename
        }
        baseUsageTierId
        baseUsageTier {
          id
          projectId
          status
          name
          description
          version
          activeAt
          inactiveAt
          priorUsageTierId
          baseUsageTierId
          replenishmentPeriod
          replenishmentMethod
          usageLimitAction
          standardTokenReplenishmentAmount
          premiumTokenReplenishmentAmount
          superPremiumTokenReplenishmentAmount
          reasoningTokenReplenishmentAmount
          standardCallReplenishmentAmount
          premiumCallReplenishmentAmount
          superPremiumCallReplenishmentAmount
          reasoningCallReplenishmentAmount
          standardTokenUnlimited
          premiumTokenUnlimited
          superPremiumTokenUnlimited
          reasoningTokenUnlimited
          standardCallUnlimited
          premiumCallUnlimited
          superPremiumCallUnlimited
          reasoningCallUnlimited
          createdAt
          updatedAt
          __typename
        }
        replenishmentPeriod
        replenishmentMethod
        usageLimitAction
        standardTokenReplenishmentAmount
        premiumTokenReplenishmentAmount
        superPremiumTokenReplenishmentAmount
        reasoningTokenReplenishmentAmount
        standardCallReplenishmentAmount
        premiumCallReplenishmentAmount
        superPremiumCallReplenishmentAmount
        reasoningCallReplenishmentAmount
        standardTokenUnlimited
        premiumTokenUnlimited
        superPremiumTokenUnlimited
        reasoningTokenUnlimited
        standardCallUnlimited
        premiumCallUnlimited
        superPremiumCallUnlimited
        reasoningCallUnlimited
        createdAt
        updatedAt
        __typename
      }
      nextUsageTierId
      nextUsageTier {
        id
        projectId
        status
        name
        description
        version
        activeAt
        inactiveAt
        priorUsageTierId
        priorUsageTier {
          id
          projectId
          status
          name
          description
          version
          activeAt
          inactiveAt
          priorUsageTierId
          baseUsageTierId
          replenishmentPeriod
          replenishmentMethod
          usageLimitAction
          standardTokenReplenishmentAmount
          premiumTokenReplenishmentAmount
          superPremiumTokenReplenishmentAmount
          reasoningTokenReplenishmentAmount
          standardCallReplenishmentAmount
          premiumCallReplenishmentAmount
          superPremiumCallReplenishmentAmount
          reasoningCallReplenishmentAmount
          standardTokenUnlimited
          premiumTokenUnlimited
          superPremiumTokenUnlimited
          reasoningTokenUnlimited
          standardCallUnlimited
          premiumCallUnlimited
          superPremiumCallUnlimited
          reasoningCallUnlimited
          createdAt
          updatedAt
          __typename
        }
        baseUsageTierId
        baseUsageTier {
          id
          projectId
          status
          name
          description
          version
          activeAt
          inactiveAt
          priorUsageTierId
          baseUsageTierId
          replenishmentPeriod
          replenishmentMethod
          usageLimitAction
          standardTokenReplenishmentAmount
          premiumTokenReplenishmentAmount
          superPremiumTokenReplenishmentAmount
          reasoningTokenReplenishmentAmount
          standardCallReplenishmentAmount
          premiumCallReplenishmentAmount
          superPremiumCallReplenishmentAmount
          reasoningCallReplenishmentAmount
          standardTokenUnlimited
          premiumTokenUnlimited
          superPremiumTokenUnlimited
          reasoningTokenUnlimited
          standardCallUnlimited
          premiumCallUnlimited
          superPremiumCallUnlimited
          reasoningCallUnlimited
          createdAt
          updatedAt
          __typename
        }
        replenishmentPeriod
        replenishmentMethod
        usageLimitAction
        standardTokenReplenishmentAmount
        premiumTokenReplenishmentAmount
        superPremiumTokenReplenishmentAmount
        reasoningTokenReplenishmentAmount
        standardCallReplenishmentAmount
        premiumCallReplenishmentAmount
        superPremiumCallReplenishmentAmount
        reasoningCallReplenishmentAmount
        standardTokenUnlimited
        premiumTokenUnlimited
        superPremiumTokenUnlimited
        reasoningTokenUnlimited
        standardCallUnlimited
        premiumCallUnlimited
        superPremiumCallUnlimited
        reasoningCallUnlimited
        createdAt
        updatedAt
        __typename
      }
      nextUsageTierAt
      usageLimitAction
      standardTokensRemaining
      premiumTokensRemaining
      superPremiumTokensRemaining
      reasoningTokensRemaining
      standardCallsRemaining
      premiumCallsRemaining
      superPremiumCallsRemaining
      reasoningCallsRemaining
      standardTokenUnlimited
      premiumTokenUnlimited
      superPremiumTokenUnlimited
      reasoningTokenUnlimited
      standardCallUnlimited
      premiumCallUnlimited
      superPremiumCallUnlimited
      reasoningCallUnlimited
      updatedAt
      __typename
    }
    serviceId
    service {
      id
      name
      status
      vendor
      region
      endpoint
      body
      header
      projectId
      loadProportion
      inputTokenPricePerMillion
      outputTokenPricePerMillion
      groupId
      group {
        id
        status
        name
        description
        projectId
        systemInstructions
        systemInstructionsAction
        order
        createdAt
        updatedAt
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
    modelId
    model {
      id
      status
      vendor
      host
      supported
      name
      description
      modelKey
      modelKeyLatest
      inputTokenPrice
      cachedTokenPrice
      outputTokenPrice
      inputTokenBatchPrice
      outputTokenBatchPrice
      searchCost
      supportsSearch
      textInputSupport
      imageInputSupport
      audioInputSupport
      textOutputSupport
      imageOutputSupport
      audioOutputSupport
      thinkingSupport
      contextWindowTokens
      maxResponseTokens
      knowledgeCutoffDate
      lastCheckedDate
      supportedLanguages
      warningDate
      warningMessage
      deprecationDate
      deprecationMessage
      defaultServiceGroup
      defaultEnabled
      displayOrder
      recommendedUseCase
      performanceRating
      createdAt
      updatedAt
      __typename
    }
    requestHash
    messages
    prompt
    response
    tokenCountPrompt
    tokenCountResponse
    createdAt
    hash
    country
    region
    city
    quality
    qualityComment
    apiKeyType
    toxicity
    randomGroup
    agentId
    conversationId
    timings
    customer_user_id
    customer_user_name
    customer_user_email
    batch
    callbackUrl
    batchId
    batchCustomId
    batchRequest
    executionMode
    pricingMode
    vendorBatchId
    vendorResponseId
    vendorStatus
    resolvedModelId
    usageTapCallId
    usageTapStripeCustomerId
    error
    cacheReadTokens
    cacheWriteTokens
    cacheStatus
    compactionTriggered
    compactionTokensSaved
    curatedTokensSaved
    curatedItems
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateLLMCallMutationVariables,
  APITypes.CreateLLMCallMutation
>;
export const updateLLMCall = /* GraphQL */ `mutation UpdateLLMCall(
  $input: UpdateLLMCallInput!
  $condition: ModelLLMCallConditionInput
) {
  updateLLMCall(input: $input, condition: $condition) {
    id
    projectId
    status
    customerId
    customer {
      id
      name
      status
      tokensRemaining
      lastCallMadeAt
      numberOfCallsMade
      projectId
      loadSheddingTier
      dataResidency
      createdAt
      enterpriseUser
      tokenReplenishmentAmount
      tokenReplenishmentPeriod
      lastReplenishedAt
      nextReplenishAt
      usageTierId
      usageTier {
        id
        projectId
        status
        name
        description
        version
        activeAt
        inactiveAt
        priorUsageTierId
        priorUsageTier {
          id
          projectId
          status
          name
          description
          version
          activeAt
          inactiveAt
          priorUsageTierId
          baseUsageTierId
          replenishmentPeriod
          replenishmentMethod
          usageLimitAction
          standardTokenReplenishmentAmount
          premiumTokenReplenishmentAmount
          superPremiumTokenReplenishmentAmount
          reasoningTokenReplenishmentAmount
          standardCallReplenishmentAmount
          premiumCallReplenishmentAmount
          superPremiumCallReplenishmentAmount
          reasoningCallReplenishmentAmount
          standardTokenUnlimited
          premiumTokenUnlimited
          superPremiumTokenUnlimited
          reasoningTokenUnlimited
          standardCallUnlimited
          premiumCallUnlimited
          superPremiumCallUnlimited
          reasoningCallUnlimited
          createdAt
          updatedAt
          __typename
        }
        baseUsageTierId
        baseUsageTier {
          id
          projectId
          status
          name
          description
          version
          activeAt
          inactiveAt
          priorUsageTierId
          baseUsageTierId
          replenishmentPeriod
          replenishmentMethod
          usageLimitAction
          standardTokenReplenishmentAmount
          premiumTokenReplenishmentAmount
          superPremiumTokenReplenishmentAmount
          reasoningTokenReplenishmentAmount
          standardCallReplenishmentAmount
          premiumCallReplenishmentAmount
          superPremiumCallReplenishmentAmount
          reasoningCallReplenishmentAmount
          standardTokenUnlimited
          premiumTokenUnlimited
          superPremiumTokenUnlimited
          reasoningTokenUnlimited
          standardCallUnlimited
          premiumCallUnlimited
          superPremiumCallUnlimited
          reasoningCallUnlimited
          createdAt
          updatedAt
          __typename
        }
        replenishmentPeriod
        replenishmentMethod
        usageLimitAction
        standardTokenReplenishmentAmount
        premiumTokenReplenishmentAmount
        superPremiumTokenReplenishmentAmount
        reasoningTokenReplenishmentAmount
        standardCallReplenishmentAmount
        premiumCallReplenishmentAmount
        superPremiumCallReplenishmentAmount
        reasoningCallReplenishmentAmount
        standardTokenUnlimited
        premiumTokenUnlimited
        superPremiumTokenUnlimited
        reasoningTokenUnlimited
        standardCallUnlimited
        premiumCallUnlimited
        superPremiumCallUnlimited
        reasoningCallUnlimited
        createdAt
        updatedAt
        __typename
      }
      nextUsageTierId
      nextUsageTier {
        id
        projectId
        status
        name
        description
        version
        activeAt
        inactiveAt
        priorUsageTierId
        priorUsageTier {
          id
          projectId
          status
          name
          description
          version
          activeAt
          inactiveAt
          priorUsageTierId
          baseUsageTierId
          replenishmentPeriod
          replenishmentMethod
          usageLimitAction
          standardTokenReplenishmentAmount
          premiumTokenReplenishmentAmount
          superPremiumTokenReplenishmentAmount
          reasoningTokenReplenishmentAmount
          standardCallReplenishmentAmount
          premiumCallReplenishmentAmount
          superPremiumCallReplenishmentAmount
          reasoningCallReplenishmentAmount
          standardTokenUnlimited
          premiumTokenUnlimited
          superPremiumTokenUnlimited
          reasoningTokenUnlimited
          standardCallUnlimited
          premiumCallUnlimited
          superPremiumCallUnlimited
          reasoningCallUnlimited
          createdAt
          updatedAt
          __typename
        }
        baseUsageTierId
        baseUsageTier {
          id
          projectId
          status
          name
          description
          version
          activeAt
          inactiveAt
          priorUsageTierId
          baseUsageTierId
          replenishmentPeriod
          replenishmentMethod
          usageLimitAction
          standardTokenReplenishmentAmount
          premiumTokenReplenishmentAmount
          superPremiumTokenReplenishmentAmount
          reasoningTokenReplenishmentAmount
          standardCallReplenishmentAmount
          premiumCallReplenishmentAmount
          superPremiumCallReplenishmentAmount
          reasoningCallReplenishmentAmount
          standardTokenUnlimited
          premiumTokenUnlimited
          superPremiumTokenUnlimited
          reasoningTokenUnlimited
          standardCallUnlimited
          premiumCallUnlimited
          superPremiumCallUnlimited
          reasoningCallUnlimited
          createdAt
          updatedAt
          __typename
        }
        replenishmentPeriod
        replenishmentMethod
        usageLimitAction
        standardTokenReplenishmentAmount
        premiumTokenReplenishmentAmount
        superPremiumTokenReplenishmentAmount
        reasoningTokenReplenishmentAmount
        standardCallReplenishmentAmount
        premiumCallReplenishmentAmount
        superPremiumCallReplenishmentAmount
        reasoningCallReplenishmentAmount
        standardTokenUnlimited
        premiumTokenUnlimited
        superPremiumTokenUnlimited
        reasoningTokenUnlimited
        standardCallUnlimited
        premiumCallUnlimited
        superPremiumCallUnlimited
        reasoningCallUnlimited
        createdAt
        updatedAt
        __typename
      }
      nextUsageTierAt
      usageLimitAction
      standardTokensRemaining
      premiumTokensRemaining
      superPremiumTokensRemaining
      reasoningTokensRemaining
      standardCallsRemaining
      premiumCallsRemaining
      superPremiumCallsRemaining
      reasoningCallsRemaining
      standardTokenUnlimited
      premiumTokenUnlimited
      superPremiumTokenUnlimited
      reasoningTokenUnlimited
      standardCallUnlimited
      premiumCallUnlimited
      superPremiumCallUnlimited
      reasoningCallUnlimited
      updatedAt
      __typename
    }
    serviceId
    service {
      id
      name
      status
      vendor
      region
      endpoint
      body
      header
      projectId
      loadProportion
      inputTokenPricePerMillion
      outputTokenPricePerMillion
      groupId
      group {
        id
        status
        name
        description
        projectId
        systemInstructions
        systemInstructionsAction
        order
        createdAt
        updatedAt
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
    modelId
    model {
      id
      status
      vendor
      host
      supported
      name
      description
      modelKey
      modelKeyLatest
      inputTokenPrice
      cachedTokenPrice
      outputTokenPrice
      inputTokenBatchPrice
      outputTokenBatchPrice
      searchCost
      supportsSearch
      textInputSupport
      imageInputSupport
      audioInputSupport
      textOutputSupport
      imageOutputSupport
      audioOutputSupport
      thinkingSupport
      contextWindowTokens
      maxResponseTokens
      knowledgeCutoffDate
      lastCheckedDate
      supportedLanguages
      warningDate
      warningMessage
      deprecationDate
      deprecationMessage
      defaultServiceGroup
      defaultEnabled
      displayOrder
      recommendedUseCase
      performanceRating
      createdAt
      updatedAt
      __typename
    }
    requestHash
    messages
    prompt
    response
    tokenCountPrompt
    tokenCountResponse
    createdAt
    hash
    country
    region
    city
    quality
    qualityComment
    apiKeyType
    toxicity
    randomGroup
    agentId
    conversationId
    timings
    customer_user_id
    customer_user_name
    customer_user_email
    batch
    callbackUrl
    batchId
    batchCustomId
    batchRequest
    executionMode
    pricingMode
    vendorBatchId
    vendorResponseId
    vendorStatus
    resolvedModelId
    usageTapCallId
    usageTapStripeCustomerId
    error
    cacheReadTokens
    cacheWriteTokens
    cacheStatus
    compactionTriggered
    compactionTokensSaved
    curatedTokensSaved
    curatedItems
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateLLMCallMutationVariables,
  APITypes.UpdateLLMCallMutation
>;
export const deleteLLMCall = /* GraphQL */ `mutation DeleteLLMCall(
  $input: DeleteLLMCallInput!
  $condition: ModelLLMCallConditionInput
) {
  deleteLLMCall(input: $input, condition: $condition) {
    id
    projectId
    status
    customerId
    customer {
      id
      name
      status
      tokensRemaining
      lastCallMadeAt
      numberOfCallsMade
      projectId
      loadSheddingTier
      dataResidency
      createdAt
      enterpriseUser
      tokenReplenishmentAmount
      tokenReplenishmentPeriod
      lastReplenishedAt
      nextReplenishAt
      usageTierId
      usageTier {
        id
        projectId
        status
        name
        description
        version
        activeAt
        inactiveAt
        priorUsageTierId
        priorUsageTier {
          id
          projectId
          status
          name
          description
          version
          activeAt
          inactiveAt
          priorUsageTierId
          baseUsageTierId
          replenishmentPeriod
          replenishmentMethod
          usageLimitAction
          standardTokenReplenishmentAmount
          premiumTokenReplenishmentAmount
          superPremiumTokenReplenishmentAmount
          reasoningTokenReplenishmentAmount
          standardCallReplenishmentAmount
          premiumCallReplenishmentAmount
          superPremiumCallReplenishmentAmount
          reasoningCallReplenishmentAmount
          standardTokenUnlimited
          premiumTokenUnlimited
          superPremiumTokenUnlimited
          reasoningTokenUnlimited
          standardCallUnlimited
          premiumCallUnlimited
          superPremiumCallUnlimited
          reasoningCallUnlimited
          createdAt
          updatedAt
          __typename
        }
        baseUsageTierId
        baseUsageTier {
          id
          projectId
          status
          name
          description
          version
          activeAt
          inactiveAt
          priorUsageTierId
          baseUsageTierId
          replenishmentPeriod
          replenishmentMethod
          usageLimitAction
          standardTokenReplenishmentAmount
          premiumTokenReplenishmentAmount
          superPremiumTokenReplenishmentAmount
          reasoningTokenReplenishmentAmount
          standardCallReplenishmentAmount
          premiumCallReplenishmentAmount
          superPremiumCallReplenishmentAmount
          reasoningCallReplenishmentAmount
          standardTokenUnlimited
          premiumTokenUnlimited
          superPremiumTokenUnlimited
          reasoningTokenUnlimited
          standardCallUnlimited
          premiumCallUnlimited
          superPremiumCallUnlimited
          reasoningCallUnlimited
          createdAt
          updatedAt
          __typename
        }
        replenishmentPeriod
        replenishmentMethod
        usageLimitAction
        standardTokenReplenishmentAmount
        premiumTokenReplenishmentAmount
        superPremiumTokenReplenishmentAmount
        reasoningTokenReplenishmentAmount
        standardCallReplenishmentAmount
        premiumCallReplenishmentAmount
        superPremiumCallReplenishmentAmount
        reasoningCallReplenishmentAmount
        standardTokenUnlimited
        premiumTokenUnlimited
        superPremiumTokenUnlimited
        reasoningTokenUnlimited
        standardCallUnlimited
        premiumCallUnlimited
        superPremiumCallUnlimited
        reasoningCallUnlimited
        createdAt
        updatedAt
        __typename
      }
      nextUsageTierId
      nextUsageTier {
        id
        projectId
        status
        name
        description
        version
        activeAt
        inactiveAt
        priorUsageTierId
        priorUsageTier {
          id
          projectId
          status
          name
          description
          version
          activeAt
          inactiveAt
          priorUsageTierId
          baseUsageTierId
          replenishmentPeriod
          replenishmentMethod
          usageLimitAction
          standardTokenReplenishmentAmount
          premiumTokenReplenishmentAmount
          superPremiumTokenReplenishmentAmount
          reasoningTokenReplenishmentAmount
          standardCallReplenishmentAmount
          premiumCallReplenishmentAmount
          superPremiumCallReplenishmentAmount
          reasoningCallReplenishmentAmount
          standardTokenUnlimited
          premiumTokenUnlimited
          superPremiumTokenUnlimited
          reasoningTokenUnlimited
          standardCallUnlimited
          premiumCallUnlimited
          superPremiumCallUnlimited
          reasoningCallUnlimited
          createdAt
          updatedAt
          __typename
        }
        baseUsageTierId
        baseUsageTier {
          id
          projectId
          status
          name
          description
          version
          activeAt
          inactiveAt
          priorUsageTierId
          baseUsageTierId
          replenishmentPeriod
          replenishmentMethod
          usageLimitAction
          standardTokenReplenishmentAmount
          premiumTokenReplenishmentAmount
          superPremiumTokenReplenishmentAmount
          reasoningTokenReplenishmentAmount
          standardCallReplenishmentAmount
          premiumCallReplenishmentAmount
          superPremiumCallReplenishmentAmount
          reasoningCallReplenishmentAmount
          standardTokenUnlimited
          premiumTokenUnlimited
          superPremiumTokenUnlimited
          reasoningTokenUnlimited
          standardCallUnlimited
          premiumCallUnlimited
          superPremiumCallUnlimited
          reasoningCallUnlimited
          createdAt
          updatedAt
          __typename
        }
        replenishmentPeriod
        replenishmentMethod
        usageLimitAction
        standardTokenReplenishmentAmount
        premiumTokenReplenishmentAmount
        superPremiumTokenReplenishmentAmount
        reasoningTokenReplenishmentAmount
        standardCallReplenishmentAmount
        premiumCallReplenishmentAmount
        superPremiumCallReplenishmentAmount
        reasoningCallReplenishmentAmount
        standardTokenUnlimited
        premiumTokenUnlimited
        superPremiumTokenUnlimited
        reasoningTokenUnlimited
        standardCallUnlimited
        premiumCallUnlimited
        superPremiumCallUnlimited
        reasoningCallUnlimited
        createdAt
        updatedAt
        __typename
      }
      nextUsageTierAt
      usageLimitAction
      standardTokensRemaining
      premiumTokensRemaining
      superPremiumTokensRemaining
      reasoningTokensRemaining
      standardCallsRemaining
      premiumCallsRemaining
      superPremiumCallsRemaining
      reasoningCallsRemaining
      standardTokenUnlimited
      premiumTokenUnlimited
      superPremiumTokenUnlimited
      reasoningTokenUnlimited
      standardCallUnlimited
      premiumCallUnlimited
      superPremiumCallUnlimited
      reasoningCallUnlimited
      updatedAt
      __typename
    }
    serviceId
    service {
      id
      name
      status
      vendor
      region
      endpoint
      body
      header
      projectId
      loadProportion
      inputTokenPricePerMillion
      outputTokenPricePerMillion
      groupId
      group {
        id
        status
        name
        description
        projectId
        systemInstructions
        systemInstructionsAction
        order
        createdAt
        updatedAt
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
    modelId
    model {
      id
      status
      vendor
      host
      supported
      name
      description
      modelKey
      modelKeyLatest
      inputTokenPrice
      cachedTokenPrice
      outputTokenPrice
      inputTokenBatchPrice
      outputTokenBatchPrice
      searchCost
      supportsSearch
      textInputSupport
      imageInputSupport
      audioInputSupport
      textOutputSupport
      imageOutputSupport
      audioOutputSupport
      thinkingSupport
      contextWindowTokens
      maxResponseTokens
      knowledgeCutoffDate
      lastCheckedDate
      supportedLanguages
      warningDate
      warningMessage
      deprecationDate
      deprecationMessage
      defaultServiceGroup
      defaultEnabled
      displayOrder
      recommendedUseCase
      performanceRating
      createdAt
      updatedAt
      __typename
    }
    requestHash
    messages
    prompt
    response
    tokenCountPrompt
    tokenCountResponse
    createdAt
    hash
    country
    region
    city
    quality
    qualityComment
    apiKeyType
    toxicity
    randomGroup
    agentId
    conversationId
    timings
    customer_user_id
    customer_user_name
    customer_user_email
    batch
    callbackUrl
    batchId
    batchCustomId
    batchRequest
    executionMode
    pricingMode
    vendorBatchId
    vendorResponseId
    vendorStatus
    resolvedModelId
    usageTapCallId
    usageTapStripeCustomerId
    error
    cacheReadTokens
    cacheWriteTokens
    cacheStatus
    compactionTriggered
    compactionTokensSaved
    curatedTokensSaved
    curatedItems
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteLLMCallMutationVariables,
  APITypes.DeleteLLMCallMutation
>;
export const createLLMBatch = /* GraphQL */ `mutation CreateLLMBatch(
  $input: CreateLLMBatchInput!
  $condition: ModelLLMBatchConditionInput
) {
  createLLMBatch(input: $input, condition: $condition) {
    id
    projectId
    status
    vendor
    vendorBatchId
    vendorInputFileId
    vendorOutputFileId
    vendorErrorFileId
    requestCount
    completedCount
    failedCount
    nextPollAt
    callbackUrl
    callbackSecret
    callbackStatus
    callbackAttempts
    callbackLastError
    idempotencyKeyHash
    requestHash
    error
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateLLMBatchMutationVariables,
  APITypes.CreateLLMBatchMutation
>;
export const updateLLMBatch = /* GraphQL */ `mutation UpdateLLMBatch(
  $input: UpdateLLMBatchInput!
  $condition: ModelLLMBatchConditionInput
) {
  updateLLMBatch(input: $input, condition: $condition) {
    id
    projectId
    status
    vendor
    vendorBatchId
    vendorInputFileId
    vendorOutputFileId
    vendorErrorFileId
    requestCount
    completedCount
    failedCount
    nextPollAt
    callbackUrl
    callbackSecret
    callbackStatus
    callbackAttempts
    callbackLastError
    idempotencyKeyHash
    requestHash
    error
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateLLMBatchMutationVariables,
  APITypes.UpdateLLMBatchMutation
>;
export const createLLMPrompt = /* GraphQL */ `mutation CreateLLMPrompt(
  $input: CreateLLMPromptInput!
  $condition: ModelLLMPromptConditionInput
) {
  createLLMPrompt(input: $input, condition: $condition) {
    id
    projectId
    status
    name
    description
    prompt
    key
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateLLMPromptMutationVariables,
  APITypes.CreateLLMPromptMutation
>;
export const updateLLMPrompt = /* GraphQL */ `mutation UpdateLLMPrompt(
  $input: UpdateLLMPromptInput!
  $condition: ModelLLMPromptConditionInput
) {
  updateLLMPrompt(input: $input, condition: $condition) {
    id
    projectId
    status
    name
    description
    prompt
    key
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateLLMPromptMutationVariables,
  APITypes.UpdateLLMPromptMutation
>;
export const deleteLLMPrompt = /* GraphQL */ `mutation DeleteLLMPrompt(
  $input: DeleteLLMPromptInput!
  $condition: ModelLLMPromptConditionInput
) {
  deleteLLMPrompt(input: $input, condition: $condition) {
    id
    projectId
    status
    name
    description
    prompt
    key
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteLLMPromptMutationVariables,
  APITypes.DeleteLLMPromptMutation
>;
export const createLLMCallLogFile = /* GraphQL */ `mutation CreateLLMCallLogFile(
  $input: CreateLLMCallLogFileInput!
  $condition: ModelLLMCallLogFileConditionInput
) {
  createLLMCallLogFile(input: $input, condition: $condition) {
    id
    projectId
    fromDate
    toDate
    chunk
    count
    status
    bucket
    key
    url
    urlExpiresAt
    deleteFileAfter
    createdAt
    randomGroup
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateLLMCallLogFileMutationVariables,
  APITypes.CreateLLMCallLogFileMutation
>;
export const updateLLMCallLogFile = /* GraphQL */ `mutation UpdateLLMCallLogFile(
  $input: UpdateLLMCallLogFileInput!
  $condition: ModelLLMCallLogFileConditionInput
) {
  updateLLMCallLogFile(input: $input, condition: $condition) {
    id
    projectId
    fromDate
    toDate
    chunk
    count
    status
    bucket
    key
    url
    urlExpiresAt
    deleteFileAfter
    createdAt
    randomGroup
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateLLMCallLogFileMutationVariables,
  APITypes.UpdateLLMCallLogFileMutation
>;
export const deleteLLMCallLogFile = /* GraphQL */ `mutation DeleteLLMCallLogFile(
  $input: DeleteLLMCallLogFileInput!
  $condition: ModelLLMCallLogFileConditionInput
) {
  deleteLLMCallLogFile(input: $input, condition: $condition) {
    id
    projectId
    fromDate
    toDate
    chunk
    count
    status
    bucket
    key
    url
    urlExpiresAt
    deleteFileAfter
    createdAt
    randomGroup
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteLLMCallLogFileMutationVariables,
  APITypes.DeleteLLMCallLogFileMutation
>;
export const createLLMAgent = /* GraphQL */ `mutation CreateLLMAgent(
  $input: CreateLLMAgentInput!
  $condition: ModelLLMAgentConditionInput
) {
  createLLMAgent(input: $input, condition: $condition) {
    id
    status
    name
    description
    projectId
    systemInstructions
    systemInstructionsAction
    displayTheme
    cssUrl
    displayTitle
    displayStartMessageOrPrompt
    displayInitialMessageOrPrompt
    displayPromptTemplate
    displayFollowOnPrompts
    displayActions
    displayWidth
    displayHeight
    displayPlaceholder
    displayHideInitialPrompt
    displayShowSaveButton
    displayShowEmailButton
    displayShowCallToAction
    displayCallToActionButtonText
    displayCallToActionEmailAddress
    displayCallToActionEmailSubject
    displayCallToActionMustSendEmail
    displayScrollToEnd
    groupId
    data
    calls {
      items {
        id
        projectId
        status
        customerId
        customer {
          id
          name
          status
          tokensRemaining
          lastCallMadeAt
          numberOfCallsMade
          projectId
          loadSheddingTier
          dataResidency
          createdAt
          enterpriseUser
          tokenReplenishmentAmount
          tokenReplenishmentPeriod
          lastReplenishedAt
          nextReplenishAt
          usageTierId
          nextUsageTierId
          nextUsageTierAt
          usageLimitAction
          standardTokensRemaining
          premiumTokensRemaining
          superPremiumTokensRemaining
          reasoningTokensRemaining
          standardCallsRemaining
          premiumCallsRemaining
          superPremiumCallsRemaining
          reasoningCallsRemaining
          standardTokenUnlimited
          premiumTokenUnlimited
          superPremiumTokenUnlimited
          reasoningTokenUnlimited
          standardCallUnlimited
          premiumCallUnlimited
          superPremiumCallUnlimited
          reasoningCallUnlimited
          updatedAt
          __typename
        }
        serviceId
        service {
          id
          name
          status
          vendor
          region
          endpoint
          body
          header
          projectId
          loadProportion
          inputTokenPricePerMillion
          outputTokenPricePerMillion
          groupId
          createdAt
          updatedAt
          __typename
        }
        modelId
        model {
          id
          status
          vendor
          host
          supported
          name
          description
          modelKey
          modelKeyLatest
          inputTokenPrice
          cachedTokenPrice
          outputTokenPrice
          inputTokenBatchPrice
          outputTokenBatchPrice
          searchCost
          supportsSearch
          textInputSupport
          imageInputSupport
          audioInputSupport
          textOutputSupport
          imageOutputSupport
          audioOutputSupport
          thinkingSupport
          contextWindowTokens
          maxResponseTokens
          knowledgeCutoffDate
          lastCheckedDate
          supportedLanguages
          warningDate
          warningMessage
          deprecationDate
          deprecationMessage
          defaultServiceGroup
          defaultEnabled
          displayOrder
          recommendedUseCase
          performanceRating
          createdAt
          updatedAt
          __typename
        }
        requestHash
        messages
        prompt
        response
        tokenCountPrompt
        tokenCountResponse
        createdAt
        hash
        country
        region
        city
        quality
        qualityComment
        apiKeyType
        toxicity
        randomGroup
        agentId
        conversationId
        timings
        customer_user_id
        customer_user_name
        customer_user_email
        batch
        callbackUrl
        batchId
        batchCustomId
        batchRequest
        executionMode
        pricingMode
        vendorBatchId
        vendorResponseId
        vendorStatus
        resolvedModelId
        usageTapCallId
        usageTapStripeCustomerId
        error
        cacheReadTokens
        cacheWriteTokens
        cacheStatus
        compactionTriggered
        compactionTokensSaved
        curatedTokensSaved
        curatedItems
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
    documents {
      items {
        id
        projectId
        agentId
        status
        fileName
        fileSize
        fileType
        uploadDate
        uploader
        lastModifiedDate
        ownershipAttestation
        location
        type
        ragSplitter
        ragChunkSize
        ragChunkOverlap
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
    mcpServers {
      items {
        id
        projectId
        agentId
        status
        approvalMode
        executionMode
        url
        accessToken
        headers
        stdioCommand
        stdioArgs
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
    ragQueryLimit
    ragRankLimit
    ragIncludeCitations
    ragDoRerank
    ragSkipChecksOnContext
    ragShadowRead
    visibility
    createConversationOnFirstChat
    customerEmailCaptureMode
    customerEmailCapturePlaceholder
    enableRAG
    enableMCP
    injectMemories
    injectKnowledgeGraph
    enableWebSearch
    linkedFileTypes
    thinkingDepth
    enablePromptCaching
    compactionPolicy
    compactionThreshold
    curateToolResults
    curateAfterTurns
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateLLMAgentMutationVariables,
  APITypes.CreateLLMAgentMutation
>;
export const updateLLMAgent = /* GraphQL */ `mutation UpdateLLMAgent(
  $input: UpdateLLMAgentInput!
  $condition: ModelLLMAgentConditionInput
) {
  updateLLMAgent(input: $input, condition: $condition) {
    id
    status
    name
    description
    projectId
    systemInstructions
    systemInstructionsAction
    displayTheme
    cssUrl
    displayTitle
    displayStartMessageOrPrompt
    displayInitialMessageOrPrompt
    displayPromptTemplate
    displayFollowOnPrompts
    displayActions
    displayWidth
    displayHeight
    displayPlaceholder
    displayHideInitialPrompt
    displayShowSaveButton
    displayShowEmailButton
    displayShowCallToAction
    displayCallToActionButtonText
    displayCallToActionEmailAddress
    displayCallToActionEmailSubject
    displayCallToActionMustSendEmail
    displayScrollToEnd
    groupId
    data
    calls {
      items {
        id
        projectId
        status
        customerId
        customer {
          id
          name
          status
          tokensRemaining
          lastCallMadeAt
          numberOfCallsMade
          projectId
          loadSheddingTier
          dataResidency
          createdAt
          enterpriseUser
          tokenReplenishmentAmount
          tokenReplenishmentPeriod
          lastReplenishedAt
          nextReplenishAt
          usageTierId
          nextUsageTierId
          nextUsageTierAt
          usageLimitAction
          standardTokensRemaining
          premiumTokensRemaining
          superPremiumTokensRemaining
          reasoningTokensRemaining
          standardCallsRemaining
          premiumCallsRemaining
          superPremiumCallsRemaining
          reasoningCallsRemaining
          standardTokenUnlimited
          premiumTokenUnlimited
          superPremiumTokenUnlimited
          reasoningTokenUnlimited
          standardCallUnlimited
          premiumCallUnlimited
          superPremiumCallUnlimited
          reasoningCallUnlimited
          updatedAt
          __typename
        }
        serviceId
        service {
          id
          name
          status
          vendor
          region
          endpoint
          body
          header
          projectId
          loadProportion
          inputTokenPricePerMillion
          outputTokenPricePerMillion
          groupId
          createdAt
          updatedAt
          __typename
        }
        modelId
        model {
          id
          status
          vendor
          host
          supported
          name
          description
          modelKey
          modelKeyLatest
          inputTokenPrice
          cachedTokenPrice
          outputTokenPrice
          inputTokenBatchPrice
          outputTokenBatchPrice
          searchCost
          supportsSearch
          textInputSupport
          imageInputSupport
          audioInputSupport
          textOutputSupport
          imageOutputSupport
          audioOutputSupport
          thinkingSupport
          contextWindowTokens
          maxResponseTokens
          knowledgeCutoffDate
          lastCheckedDate
          supportedLanguages
          warningDate
          warningMessage
          deprecationDate
          deprecationMessage
          defaultServiceGroup
          defaultEnabled
          displayOrder
          recommendedUseCase
          performanceRating
          createdAt
          updatedAt
          __typename
        }
        requestHash
        messages
        prompt
        response
        tokenCountPrompt
        tokenCountResponse
        createdAt
        hash
        country
        region
        city
        quality
        qualityComment
        apiKeyType
        toxicity
        randomGroup
        agentId
        conversationId
        timings
        customer_user_id
        customer_user_name
        customer_user_email
        batch
        callbackUrl
        batchId
        batchCustomId
        batchRequest
        executionMode
        pricingMode
        vendorBatchId
        vendorResponseId
        vendorStatus
        resolvedModelId
        usageTapCallId
        usageTapStripeCustomerId
        error
        cacheReadTokens
        cacheWriteTokens
        cacheStatus
        compactionTriggered
        compactionTokensSaved
        curatedTokensSaved
        curatedItems
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
    documents {
      items {
        id
        projectId
        agentId
        status
        fileName
        fileSize
        fileType
        uploadDate
        uploader
        lastModifiedDate
        ownershipAttestation
        location
        type
        ragSplitter
        ragChunkSize
        ragChunkOverlap
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
    mcpServers {
      items {
        id
        projectId
        agentId
        status
        approvalMode
        executionMode
        url
        accessToken
        headers
        stdioCommand
        stdioArgs
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
    ragQueryLimit
    ragRankLimit
    ragIncludeCitations
    ragDoRerank
    ragSkipChecksOnContext
    ragShadowRead
    visibility
    createConversationOnFirstChat
    customerEmailCaptureMode
    customerEmailCapturePlaceholder
    enableRAG
    enableMCP
    injectMemories
    injectKnowledgeGraph
    enableWebSearch
    linkedFileTypes
    thinkingDepth
    enablePromptCaching
    compactionPolicy
    compactionThreshold
    curateToolResults
    curateAfterTurns
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateLLMAgentMutationVariables,
  APITypes.UpdateLLMAgentMutation
>;
export const deleteLLMAgent = /* GraphQL */ `mutation DeleteLLMAgent(
  $input: DeleteLLMAgentInput!
  $condition: ModelLLMAgentConditionInput
) {
  deleteLLMAgent(input: $input, condition: $condition) {
    id
    status
    name
    description
    projectId
    systemInstructions
    systemInstructionsAction
    displayTheme
    cssUrl
    displayTitle
    displayStartMessageOrPrompt
    displayInitialMessageOrPrompt
    displayPromptTemplate
    displayFollowOnPrompts
    displayActions
    displayWidth
    displayHeight
    displayPlaceholder
    displayHideInitialPrompt
    displayShowSaveButton
    displayShowEmailButton
    displayShowCallToAction
    displayCallToActionButtonText
    displayCallToActionEmailAddress
    displayCallToActionEmailSubject
    displayCallToActionMustSendEmail
    displayScrollToEnd
    groupId
    data
    calls {
      items {
        id
        projectId
        status
        customerId
        customer {
          id
          name
          status
          tokensRemaining
          lastCallMadeAt
          numberOfCallsMade
          projectId
          loadSheddingTier
          dataResidency
          createdAt
          enterpriseUser
          tokenReplenishmentAmount
          tokenReplenishmentPeriod
          lastReplenishedAt
          nextReplenishAt
          usageTierId
          nextUsageTierId
          nextUsageTierAt
          usageLimitAction
          standardTokensRemaining
          premiumTokensRemaining
          superPremiumTokensRemaining
          reasoningTokensRemaining
          standardCallsRemaining
          premiumCallsRemaining
          superPremiumCallsRemaining
          reasoningCallsRemaining
          standardTokenUnlimited
          premiumTokenUnlimited
          superPremiumTokenUnlimited
          reasoningTokenUnlimited
          standardCallUnlimited
          premiumCallUnlimited
          superPremiumCallUnlimited
          reasoningCallUnlimited
          updatedAt
          __typename
        }
        serviceId
        service {
          id
          name
          status
          vendor
          region
          endpoint
          body
          header
          projectId
          loadProportion
          inputTokenPricePerMillion
          outputTokenPricePerMillion
          groupId
          createdAt
          updatedAt
          __typename
        }
        modelId
        model {
          id
          status
          vendor
          host
          supported
          name
          description
          modelKey
          modelKeyLatest
          inputTokenPrice
          cachedTokenPrice
          outputTokenPrice
          inputTokenBatchPrice
          outputTokenBatchPrice
          searchCost
          supportsSearch
          textInputSupport
          imageInputSupport
          audioInputSupport
          textOutputSupport
          imageOutputSupport
          audioOutputSupport
          thinkingSupport
          contextWindowTokens
          maxResponseTokens
          knowledgeCutoffDate
          lastCheckedDate
          supportedLanguages
          warningDate
          warningMessage
          deprecationDate
          deprecationMessage
          defaultServiceGroup
          defaultEnabled
          displayOrder
          recommendedUseCase
          performanceRating
          createdAt
          updatedAt
          __typename
        }
        requestHash
        messages
        prompt
        response
        tokenCountPrompt
        tokenCountResponse
        createdAt
        hash
        country
        region
        city
        quality
        qualityComment
        apiKeyType
        toxicity
        randomGroup
        agentId
        conversationId
        timings
        customer_user_id
        customer_user_name
        customer_user_email
        batch
        callbackUrl
        batchId
        batchCustomId
        batchRequest
        executionMode
        pricingMode
        vendorBatchId
        vendorResponseId
        vendorStatus
        resolvedModelId
        usageTapCallId
        usageTapStripeCustomerId
        error
        cacheReadTokens
        cacheWriteTokens
        cacheStatus
        compactionTriggered
        compactionTokensSaved
        curatedTokensSaved
        curatedItems
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
    documents {
      items {
        id
        projectId
        agentId
        status
        fileName
        fileSize
        fileType
        uploadDate
        uploader
        lastModifiedDate
        ownershipAttestation
        location
        type
        ragSplitter
        ragChunkSize
        ragChunkOverlap
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
    mcpServers {
      items {
        id
        projectId
        agentId
        status
        approvalMode
        executionMode
        url
        accessToken
        headers
        stdioCommand
        stdioArgs
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
    ragQueryLimit
    ragRankLimit
    ragIncludeCitations
    ragDoRerank
    ragSkipChecksOnContext
    ragShadowRead
    visibility
    createConversationOnFirstChat
    customerEmailCaptureMode
    customerEmailCapturePlaceholder
    enableRAG
    enableMCP
    injectMemories
    injectKnowledgeGraph
    enableWebSearch
    linkedFileTypes
    thinkingDepth
    enablePromptCaching
    compactionPolicy
    compactionThreshold
    curateToolResults
    curateAfterTurns
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteLLMAgentMutationVariables,
  APITypes.DeleteLLMAgentMutation
>;
export const createLLMAgentMCP = /* GraphQL */ `mutation CreateLLMAgentMCP(
  $input: CreateLLMAgentMCPInput!
  $condition: ModelLLMAgentMCPConditionInput
) {
  createLLMAgentMCP(input: $input, condition: $condition) {
    id
    projectId
    agentId
    status
    approvalMode
    executionMode
    url
    accessToken
    headers
    stdioCommand
    stdioArgs
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateLLMAgentMCPMutationVariables,
  APITypes.CreateLLMAgentMCPMutation
>;
export const updateLLMAgentMCP = /* GraphQL */ `mutation UpdateLLMAgentMCP(
  $input: UpdateLLMAgentMCPInput!
  $condition: ModelLLMAgentMCPConditionInput
) {
  updateLLMAgentMCP(input: $input, condition: $condition) {
    id
    projectId
    agentId
    status
    approvalMode
    executionMode
    url
    accessToken
    headers
    stdioCommand
    stdioArgs
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateLLMAgentMCPMutationVariables,
  APITypes.UpdateLLMAgentMCPMutation
>;
export const deleteLLMAgentMCP = /* GraphQL */ `mutation DeleteLLMAgentMCP(
  $input: DeleteLLMAgentMCPInput!
  $condition: ModelLLMAgentMCPConditionInput
) {
  deleteLLMAgentMCP(input: $input, condition: $condition) {
    id
    projectId
    agentId
    status
    approvalMode
    executionMode
    url
    accessToken
    headers
    stdioCommand
    stdioArgs
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteLLMAgentMCPMutationVariables,
  APITypes.DeleteLLMAgentMCPMutation
>;
export const createLLMAgentDocument = /* GraphQL */ `mutation CreateLLMAgentDocument(
  $input: CreateLLMAgentDocumentInput!
  $condition: ModelLLMAgentDocumentConditionInput
) {
  createLLMAgentDocument(input: $input, condition: $condition) {
    id
    projectId
    agentId
    status
    fileName
    fileSize
    fileType
    uploadDate
    uploader
    lastModifiedDate
    ownershipAttestation
    location
    type
    ragSplitter
    ragChunkSize
    ragChunkOverlap
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateLLMAgentDocumentMutationVariables,
  APITypes.CreateLLMAgentDocumentMutation
>;
export const updateLLMAgentDocument = /* GraphQL */ `mutation UpdateLLMAgentDocument(
  $input: UpdateLLMAgentDocumentInput!
  $condition: ModelLLMAgentDocumentConditionInput
) {
  updateLLMAgentDocument(input: $input, condition: $condition) {
    id
    projectId
    agentId
    status
    fileName
    fileSize
    fileType
    uploadDate
    uploader
    lastModifiedDate
    ownershipAttestation
    location
    type
    ragSplitter
    ragChunkSize
    ragChunkOverlap
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateLLMAgentDocumentMutationVariables,
  APITypes.UpdateLLMAgentDocumentMutation
>;
export const deleteLLMAgentDocument = /* GraphQL */ `mutation DeleteLLMAgentDocument(
  $input: DeleteLLMAgentDocumentInput!
  $condition: ModelLLMAgentDocumentConditionInput
) {
  deleteLLMAgentDocument(input: $input, condition: $condition) {
    id
    projectId
    agentId
    status
    fileName
    fileSize
    fileType
    uploadDate
    uploader
    lastModifiedDate
    ownershipAttestation
    location
    type
    ragSplitter
    ragChunkSize
    ragChunkOverlap
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteLLMAgentDocumentMutationVariables,
  APITypes.DeleteLLMAgentDocumentMutation
>;
export const createLLMOpenAIAgentDocument = /* GraphQL */ `mutation CreateLLMOpenAIAgentDocument(
  $input: CreateLLMOpenAIAgentDocumentInput!
  $condition: ModelLLMOpenAIAgentDocumentConditionInput
) {
  createLLMOpenAIAgentDocument(input: $input, condition: $condition) {
    id
    projectId
    projectBackend
    documentId
    agentId
    backend
    status
    vectorStoreId
    openaiFileIds
    sourceType
    sourceLocation
    fileName
    fileType
    ragSplitter
    ragChunkSize
    ragChunkOverlap
    chunkCount
    providerVersion
    lastError
    createdAt
    updatedAt
    readyAt
    deletedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateLLMOpenAIAgentDocumentMutationVariables,
  APITypes.CreateLLMOpenAIAgentDocumentMutation
>;
export const updateLLMOpenAIAgentDocument = /* GraphQL */ `mutation UpdateLLMOpenAIAgentDocument(
  $input: UpdateLLMOpenAIAgentDocumentInput!
  $condition: ModelLLMOpenAIAgentDocumentConditionInput
) {
  updateLLMOpenAIAgentDocument(input: $input, condition: $condition) {
    id
    projectId
    projectBackend
    documentId
    agentId
    backend
    status
    vectorStoreId
    openaiFileIds
    sourceType
    sourceLocation
    fileName
    fileType
    ragSplitter
    ragChunkSize
    ragChunkOverlap
    chunkCount
    providerVersion
    lastError
    createdAt
    updatedAt
    readyAt
    deletedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateLLMOpenAIAgentDocumentMutationVariables,
  APITypes.UpdateLLMOpenAIAgentDocumentMutation
>;
export const deleteLLMOpenAIAgentDocument = /* GraphQL */ `mutation DeleteLLMOpenAIAgentDocument(
  $input: DeleteLLMOpenAIAgentDocumentInput!
  $condition: ModelLLMOpenAIAgentDocumentConditionInput
) {
  deleteLLMOpenAIAgentDocument(input: $input, condition: $condition) {
    id
    projectId
    projectBackend
    documentId
    agentId
    backend
    status
    vectorStoreId
    openaiFileIds
    sourceType
    sourceLocation
    fileName
    fileType
    ragSplitter
    ragChunkSize
    ragChunkOverlap
    chunkCount
    providerVersion
    lastError
    createdAt
    updatedAt
    readyAt
    deletedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteLLMOpenAIAgentDocumentMutationVariables,
  APITypes.DeleteLLMOpenAIAgentDocumentMutation
>;
export const createLLMConversation = /* GraphQL */ `mutation CreateLLMConversation(
  $input: CreateLLMConversationInput!
  $condition: ModelLLMConversationConditionInput
) {
  createLLMConversation(input: $input, condition: $condition) {
    id
    projectId
    agentId
    agent {
      id
      status
      name
      description
      projectId
      systemInstructions
      systemInstructionsAction
      displayTheme
      cssUrl
      displayTitle
      displayStartMessageOrPrompt
      displayInitialMessageOrPrompt
      displayPromptTemplate
      displayFollowOnPrompts
      displayActions
      displayWidth
      displayHeight
      displayPlaceholder
      displayHideInitialPrompt
      displayShowSaveButton
      displayShowEmailButton
      displayShowCallToAction
      displayCallToActionButtonText
      displayCallToActionEmailAddress
      displayCallToActionEmailSubject
      displayCallToActionMustSendEmail
      displayScrollToEnd
      groupId
      data
      calls {
        items {
          id
          projectId
          status
          customerId
          serviceId
          modelId
          requestHash
          messages
          prompt
          response
          tokenCountPrompt
          tokenCountResponse
          createdAt
          hash
          country
          region
          city
          quality
          qualityComment
          apiKeyType
          toxicity
          randomGroup
          agentId
          conversationId
          timings
          customer_user_id
          customer_user_name
          customer_user_email
          batch
          callbackUrl
          batchId
          batchCustomId
          batchRequest
          executionMode
          pricingMode
          vendorBatchId
          vendorResponseId
          vendorStatus
          resolvedModelId
          usageTapCallId
          usageTapStripeCustomerId
          error
          cacheReadTokens
          cacheWriteTokens
          cacheStatus
          compactionTriggered
          compactionTokensSaved
          curatedTokensSaved
          curatedItems
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      documents {
        items {
          id
          projectId
          agentId
          status
          fileName
          fileSize
          fileType
          uploadDate
          uploader
          lastModifiedDate
          ownershipAttestation
          location
          type
          ragSplitter
          ragChunkSize
          ragChunkOverlap
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      mcpServers {
        items {
          id
          projectId
          agentId
          status
          approvalMode
          executionMode
          url
          accessToken
          headers
          stdioCommand
          stdioArgs
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      ragQueryLimit
      ragRankLimit
      ragIncludeCitations
      ragDoRerank
      ragSkipChecksOnContext
      ragShadowRead
      visibility
      createConversationOnFirstChat
      customerEmailCaptureMode
      customerEmailCapturePlaceholder
      enableRAG
      enableMCP
      injectMemories
      injectKnowledgeGraph
      enableWebSearch
      linkedFileTypes
      thinkingDepth
      enablePromptCaching
      compactionPolicy
      compactionThreshold
      curateToolResults
      curateAfterTurns
      createdAt
      updatedAt
      __typename
    }
    customerId
    customer {
      id
      name
      status
      tokensRemaining
      lastCallMadeAt
      numberOfCallsMade
      projectId
      loadSheddingTier
      dataResidency
      createdAt
      enterpriseUser
      tokenReplenishmentAmount
      tokenReplenishmentPeriod
      lastReplenishedAt
      nextReplenishAt
      usageTierId
      usageTier {
        id
        projectId
        status
        name
        description
        version
        activeAt
        inactiveAt
        priorUsageTierId
        priorUsageTier {
          id
          projectId
          status
          name
          description
          version
          activeAt
          inactiveAt
          priorUsageTierId
          baseUsageTierId
          replenishmentPeriod
          replenishmentMethod
          usageLimitAction
          standardTokenReplenishmentAmount
          premiumTokenReplenishmentAmount
          superPremiumTokenReplenishmentAmount
          reasoningTokenReplenishmentAmount
          standardCallReplenishmentAmount
          premiumCallReplenishmentAmount
          superPremiumCallReplenishmentAmount
          reasoningCallReplenishmentAmount
          standardTokenUnlimited
          premiumTokenUnlimited
          superPremiumTokenUnlimited
          reasoningTokenUnlimited
          standardCallUnlimited
          premiumCallUnlimited
          superPremiumCallUnlimited
          reasoningCallUnlimited
          createdAt
          updatedAt
          __typename
        }
        baseUsageTierId
        baseUsageTier {
          id
          projectId
          status
          name
          description
          version
          activeAt
          inactiveAt
          priorUsageTierId
          baseUsageTierId
          replenishmentPeriod
          replenishmentMethod
          usageLimitAction
          standardTokenReplenishmentAmount
          premiumTokenReplenishmentAmount
          superPremiumTokenReplenishmentAmount
          reasoningTokenReplenishmentAmount
          standardCallReplenishmentAmount
          premiumCallReplenishmentAmount
          superPremiumCallReplenishmentAmount
          reasoningCallReplenishmentAmount
          standardTokenUnlimited
          premiumTokenUnlimited
          superPremiumTokenUnlimited
          reasoningTokenUnlimited
          standardCallUnlimited
          premiumCallUnlimited
          superPremiumCallUnlimited
          reasoningCallUnlimited
          createdAt
          updatedAt
          __typename
        }
        replenishmentPeriod
        replenishmentMethod
        usageLimitAction
        standardTokenReplenishmentAmount
        premiumTokenReplenishmentAmount
        superPremiumTokenReplenishmentAmount
        reasoningTokenReplenishmentAmount
        standardCallReplenishmentAmount
        premiumCallReplenishmentAmount
        superPremiumCallReplenishmentAmount
        reasoningCallReplenishmentAmount
        standardTokenUnlimited
        premiumTokenUnlimited
        superPremiumTokenUnlimited
        reasoningTokenUnlimited
        standardCallUnlimited
        premiumCallUnlimited
        superPremiumCallUnlimited
        reasoningCallUnlimited
        createdAt
        updatedAt
        __typename
      }
      nextUsageTierId
      nextUsageTier {
        id
        projectId
        status
        name
        description
        version
        activeAt
        inactiveAt
        priorUsageTierId
        priorUsageTier {
          id
          projectId
          status
          name
          description
          version
          activeAt
          inactiveAt
          priorUsageTierId
          baseUsageTierId
          replenishmentPeriod
          replenishmentMethod
          usageLimitAction
          standardTokenReplenishmentAmount
          premiumTokenReplenishmentAmount
          superPremiumTokenReplenishmentAmount
          reasoningTokenReplenishmentAmount
          standardCallReplenishmentAmount
          premiumCallReplenishmentAmount
          superPremiumCallReplenishmentAmount
          reasoningCallReplenishmentAmount
          standardTokenUnlimited
          premiumTokenUnlimited
          superPremiumTokenUnlimited
          reasoningTokenUnlimited
          standardCallUnlimited
          premiumCallUnlimited
          superPremiumCallUnlimited
          reasoningCallUnlimited
          createdAt
          updatedAt
          __typename
        }
        baseUsageTierId
        baseUsageTier {
          id
          projectId
          status
          name
          description
          version
          activeAt
          inactiveAt
          priorUsageTierId
          baseUsageTierId
          replenishmentPeriod
          replenishmentMethod
          usageLimitAction
          standardTokenReplenishmentAmount
          premiumTokenReplenishmentAmount
          superPremiumTokenReplenishmentAmount
          reasoningTokenReplenishmentAmount
          standardCallReplenishmentAmount
          premiumCallReplenishmentAmount
          superPremiumCallReplenishmentAmount
          reasoningCallReplenishmentAmount
          standardTokenUnlimited
          premiumTokenUnlimited
          superPremiumTokenUnlimited
          reasoningTokenUnlimited
          standardCallUnlimited
          premiumCallUnlimited
          superPremiumCallUnlimited
          reasoningCallUnlimited
          createdAt
          updatedAt
          __typename
        }
        replenishmentPeriod
        replenishmentMethod
        usageLimitAction
        standardTokenReplenishmentAmount
        premiumTokenReplenishmentAmount
        superPremiumTokenReplenishmentAmount
        reasoningTokenReplenishmentAmount
        standardCallReplenishmentAmount
        premiumCallReplenishmentAmount
        superPremiumCallReplenishmentAmount
        reasoningCallReplenishmentAmount
        standardTokenUnlimited
        premiumTokenUnlimited
        superPremiumTokenUnlimited
        reasoningTokenUnlimited
        standardCallUnlimited
        premiumCallUnlimited
        superPremiumCallUnlimited
        reasoningCallUnlimited
        createdAt
        updatedAt
        __typename
      }
      nextUsageTierAt
      usageLimitAction
      standardTokensRemaining
      premiumTokensRemaining
      superPremiumTokensRemaining
      reasoningTokensRemaining
      standardCallsRemaining
      premiumCallsRemaining
      superPremiumCallsRemaining
      reasoningCallsRemaining
      standardTokenUnlimited
      premiumTokenUnlimited
      superPremiumTokenUnlimited
      reasoningTokenUnlimited
      standardCallUnlimited
      premiumCallUnlimited
      superPremiumCallUnlimited
      reasoningCallUnlimited
      updatedAt
      __typename
    }
    createdAt
    status
    title
    summary
    timezone
    language
    country
    region
    city
    calls {
      items {
        id
        projectId
        status
        customerId
        customer {
          id
          name
          status
          tokensRemaining
          lastCallMadeAt
          numberOfCallsMade
          projectId
          loadSheddingTier
          dataResidency
          createdAt
          enterpriseUser
          tokenReplenishmentAmount
          tokenReplenishmentPeriod
          lastReplenishedAt
          nextReplenishAt
          usageTierId
          nextUsageTierId
          nextUsageTierAt
          usageLimitAction
          standardTokensRemaining
          premiumTokensRemaining
          superPremiumTokensRemaining
          reasoningTokensRemaining
          standardCallsRemaining
          premiumCallsRemaining
          superPremiumCallsRemaining
          reasoningCallsRemaining
          standardTokenUnlimited
          premiumTokenUnlimited
          superPremiumTokenUnlimited
          reasoningTokenUnlimited
          standardCallUnlimited
          premiumCallUnlimited
          superPremiumCallUnlimited
          reasoningCallUnlimited
          updatedAt
          __typename
        }
        serviceId
        service {
          id
          name
          status
          vendor
          region
          endpoint
          body
          header
          projectId
          loadProportion
          inputTokenPricePerMillion
          outputTokenPricePerMillion
          groupId
          createdAt
          updatedAt
          __typename
        }
        modelId
        model {
          id
          status
          vendor
          host
          supported
          name
          description
          modelKey
          modelKeyLatest
          inputTokenPrice
          cachedTokenPrice
          outputTokenPrice
          inputTokenBatchPrice
          outputTokenBatchPrice
          searchCost
          supportsSearch
          textInputSupport
          imageInputSupport
          audioInputSupport
          textOutputSupport
          imageOutputSupport
          audioOutputSupport
          thinkingSupport
          contextWindowTokens
          maxResponseTokens
          knowledgeCutoffDate
          lastCheckedDate
          supportedLanguages
          warningDate
          warningMessage
          deprecationDate
          deprecationMessage
          defaultServiceGroup
          defaultEnabled
          displayOrder
          recommendedUseCase
          performanceRating
          createdAt
          updatedAt
          __typename
        }
        requestHash
        messages
        prompt
        response
        tokenCountPrompt
        tokenCountResponse
        createdAt
        hash
        country
        region
        city
        quality
        qualityComment
        apiKeyType
        toxicity
        randomGroup
        agentId
        conversationId
        timings
        customer_user_id
        customer_user_name
        customer_user_email
        batch
        callbackUrl
        batchId
        batchCustomId
        batchRequest
        executionMode
        pricingMode
        vendorBatchId
        vendorResponseId
        vendorStatus
        resolvedModelId
        usageTapCallId
        usageTapStripeCustomerId
        error
        cacheReadTokens
        cacheWriteTokens
        cacheStatus
        compactionTriggered
        compactionTokensSaved
        curatedTokensSaved
        curatedItems
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
    emailAddress
    thumbsupClicked
    thumbsdownClicked
    copyClicked
    emailClicked
    saveClicked
    ctaClicked
    suggestionClicked
    actionClicked
    intelligence
    endedAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateLLMConversationMutationVariables,
  APITypes.CreateLLMConversationMutation
>;
export const updateLLMConversation = /* GraphQL */ `mutation UpdateLLMConversation(
  $input: UpdateLLMConversationInput!
  $condition: ModelLLMConversationConditionInput
) {
  updateLLMConversation(input: $input, condition: $condition) {
    id
    projectId
    agentId
    agent {
      id
      status
      name
      description
      projectId
      systemInstructions
      systemInstructionsAction
      displayTheme
      cssUrl
      displayTitle
      displayStartMessageOrPrompt
      displayInitialMessageOrPrompt
      displayPromptTemplate
      displayFollowOnPrompts
      displayActions
      displayWidth
      displayHeight
      displayPlaceholder
      displayHideInitialPrompt
      displayShowSaveButton
      displayShowEmailButton
      displayShowCallToAction
      displayCallToActionButtonText
      displayCallToActionEmailAddress
      displayCallToActionEmailSubject
      displayCallToActionMustSendEmail
      displayScrollToEnd
      groupId
      data
      calls {
        items {
          id
          projectId
          status
          customerId
          serviceId
          modelId
          requestHash
          messages
          prompt
          response
          tokenCountPrompt
          tokenCountResponse
          createdAt
          hash
          country
          region
          city
          quality
          qualityComment
          apiKeyType
          toxicity
          randomGroup
          agentId
          conversationId
          timings
          customer_user_id
          customer_user_name
          customer_user_email
          batch
          callbackUrl
          batchId
          batchCustomId
          batchRequest
          executionMode
          pricingMode
          vendorBatchId
          vendorResponseId
          vendorStatus
          resolvedModelId
          usageTapCallId
          usageTapStripeCustomerId
          error
          cacheReadTokens
          cacheWriteTokens
          cacheStatus
          compactionTriggered
          compactionTokensSaved
          curatedTokensSaved
          curatedItems
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      documents {
        items {
          id
          projectId
          agentId
          status
          fileName
          fileSize
          fileType
          uploadDate
          uploader
          lastModifiedDate
          ownershipAttestation
          location
          type
          ragSplitter
          ragChunkSize
          ragChunkOverlap
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      mcpServers {
        items {
          id
          projectId
          agentId
          status
          approvalMode
          executionMode
          url
          accessToken
          headers
          stdioCommand
          stdioArgs
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      ragQueryLimit
      ragRankLimit
      ragIncludeCitations
      ragDoRerank
      ragSkipChecksOnContext
      ragShadowRead
      visibility
      createConversationOnFirstChat
      customerEmailCaptureMode
      customerEmailCapturePlaceholder
      enableRAG
      enableMCP
      injectMemories
      injectKnowledgeGraph
      enableWebSearch
      linkedFileTypes
      thinkingDepth
      enablePromptCaching
      compactionPolicy
      compactionThreshold
      curateToolResults
      curateAfterTurns
      createdAt
      updatedAt
      __typename
    }
    customerId
    customer {
      id
      name
      status
      tokensRemaining
      lastCallMadeAt
      numberOfCallsMade
      projectId
      loadSheddingTier
      dataResidency
      createdAt
      enterpriseUser
      tokenReplenishmentAmount
      tokenReplenishmentPeriod
      lastReplenishedAt
      nextReplenishAt
      usageTierId
      usageTier {
        id
        projectId
        status
        name
        description
        version
        activeAt
        inactiveAt
        priorUsageTierId
        priorUsageTier {
          id
          projectId
          status
          name
          description
          version
          activeAt
          inactiveAt
          priorUsageTierId
          baseUsageTierId
          replenishmentPeriod
          replenishmentMethod
          usageLimitAction
          standardTokenReplenishmentAmount
          premiumTokenReplenishmentAmount
          superPremiumTokenReplenishmentAmount
          reasoningTokenReplenishmentAmount
          standardCallReplenishmentAmount
          premiumCallReplenishmentAmount
          superPremiumCallReplenishmentAmount
          reasoningCallReplenishmentAmount
          standardTokenUnlimited
          premiumTokenUnlimited
          superPremiumTokenUnlimited
          reasoningTokenUnlimited
          standardCallUnlimited
          premiumCallUnlimited
          superPremiumCallUnlimited
          reasoningCallUnlimited
          createdAt
          updatedAt
          __typename
        }
        baseUsageTierId
        baseUsageTier {
          id
          projectId
          status
          name
          description
          version
          activeAt
          inactiveAt
          priorUsageTierId
          baseUsageTierId
          replenishmentPeriod
          replenishmentMethod
          usageLimitAction
          standardTokenReplenishmentAmount
          premiumTokenReplenishmentAmount
          superPremiumTokenReplenishmentAmount
          reasoningTokenReplenishmentAmount
          standardCallReplenishmentAmount
          premiumCallReplenishmentAmount
          superPremiumCallReplenishmentAmount
          reasoningCallReplenishmentAmount
          standardTokenUnlimited
          premiumTokenUnlimited
          superPremiumTokenUnlimited
          reasoningTokenUnlimited
          standardCallUnlimited
          premiumCallUnlimited
          superPremiumCallUnlimited
          reasoningCallUnlimited
          createdAt
          updatedAt
          __typename
        }
        replenishmentPeriod
        replenishmentMethod
        usageLimitAction
        standardTokenReplenishmentAmount
        premiumTokenReplenishmentAmount
        superPremiumTokenReplenishmentAmount
        reasoningTokenReplenishmentAmount
        standardCallReplenishmentAmount
        premiumCallReplenishmentAmount
        superPremiumCallReplenishmentAmount
        reasoningCallReplenishmentAmount
        standardTokenUnlimited
        premiumTokenUnlimited
        superPremiumTokenUnlimited
        reasoningTokenUnlimited
        standardCallUnlimited
        premiumCallUnlimited
        superPremiumCallUnlimited
        reasoningCallUnlimited
        createdAt
        updatedAt
        __typename
      }
      nextUsageTierId
      nextUsageTier {
        id
        projectId
        status
        name
        description
        version
        activeAt
        inactiveAt
        priorUsageTierId
        priorUsageTier {
          id
          projectId
          status
          name
          description
          version
          activeAt
          inactiveAt
          priorUsageTierId
          baseUsageTierId
          replenishmentPeriod
          replenishmentMethod
          usageLimitAction
          standardTokenReplenishmentAmount
          premiumTokenReplenishmentAmount
          superPremiumTokenReplenishmentAmount
          reasoningTokenReplenishmentAmount
          standardCallReplenishmentAmount
          premiumCallReplenishmentAmount
          superPremiumCallReplenishmentAmount
          reasoningCallReplenishmentAmount
          standardTokenUnlimited
          premiumTokenUnlimited
          superPremiumTokenUnlimited
          reasoningTokenUnlimited
          standardCallUnlimited
          premiumCallUnlimited
          superPremiumCallUnlimited
          reasoningCallUnlimited
          createdAt
          updatedAt
          __typename
        }
        baseUsageTierId
        baseUsageTier {
          id
          projectId
          status
          name
          description
          version
          activeAt
          inactiveAt
          priorUsageTierId
          baseUsageTierId
          replenishmentPeriod
          replenishmentMethod
          usageLimitAction
          standardTokenReplenishmentAmount
          premiumTokenReplenishmentAmount
          superPremiumTokenReplenishmentAmount
          reasoningTokenReplenishmentAmount
          standardCallReplenishmentAmount
          premiumCallReplenishmentAmount
          superPremiumCallReplenishmentAmount
          reasoningCallReplenishmentAmount
          standardTokenUnlimited
          premiumTokenUnlimited
          superPremiumTokenUnlimited
          reasoningTokenUnlimited
          standardCallUnlimited
          premiumCallUnlimited
          superPremiumCallUnlimited
          reasoningCallUnlimited
          createdAt
          updatedAt
          __typename
        }
        replenishmentPeriod
        replenishmentMethod
        usageLimitAction
        standardTokenReplenishmentAmount
        premiumTokenReplenishmentAmount
        superPremiumTokenReplenishmentAmount
        reasoningTokenReplenishmentAmount
        standardCallReplenishmentAmount
        premiumCallReplenishmentAmount
        superPremiumCallReplenishmentAmount
        reasoningCallReplenishmentAmount
        standardTokenUnlimited
        premiumTokenUnlimited
        superPremiumTokenUnlimited
        reasoningTokenUnlimited
        standardCallUnlimited
        premiumCallUnlimited
        superPremiumCallUnlimited
        reasoningCallUnlimited
        createdAt
        updatedAt
        __typename
      }
      nextUsageTierAt
      usageLimitAction
      standardTokensRemaining
      premiumTokensRemaining
      superPremiumTokensRemaining
      reasoningTokensRemaining
      standardCallsRemaining
      premiumCallsRemaining
      superPremiumCallsRemaining
      reasoningCallsRemaining
      standardTokenUnlimited
      premiumTokenUnlimited
      superPremiumTokenUnlimited
      reasoningTokenUnlimited
      standardCallUnlimited
      premiumCallUnlimited
      superPremiumCallUnlimited
      reasoningCallUnlimited
      updatedAt
      __typename
    }
    createdAt
    status
    title
    summary
    timezone
    language
    country
    region
    city
    calls {
      items {
        id
        projectId
        status
        customerId
        customer {
          id
          name
          status
          tokensRemaining
          lastCallMadeAt
          numberOfCallsMade
          projectId
          loadSheddingTier
          dataResidency
          createdAt
          enterpriseUser
          tokenReplenishmentAmount
          tokenReplenishmentPeriod
          lastReplenishedAt
          nextReplenishAt
          usageTierId
          nextUsageTierId
          nextUsageTierAt
          usageLimitAction
          standardTokensRemaining
          premiumTokensRemaining
          superPremiumTokensRemaining
          reasoningTokensRemaining
          standardCallsRemaining
          premiumCallsRemaining
          superPremiumCallsRemaining
          reasoningCallsRemaining
          standardTokenUnlimited
          premiumTokenUnlimited
          superPremiumTokenUnlimited
          reasoningTokenUnlimited
          standardCallUnlimited
          premiumCallUnlimited
          superPremiumCallUnlimited
          reasoningCallUnlimited
          updatedAt
          __typename
        }
        serviceId
        service {
          id
          name
          status
          vendor
          region
          endpoint
          body
          header
          projectId
          loadProportion
          inputTokenPricePerMillion
          outputTokenPricePerMillion
          groupId
          createdAt
          updatedAt
          __typename
        }
        modelId
        model {
          id
          status
          vendor
          host
          supported
          name
          description
          modelKey
          modelKeyLatest
          inputTokenPrice
          cachedTokenPrice
          outputTokenPrice
          inputTokenBatchPrice
          outputTokenBatchPrice
          searchCost
          supportsSearch
          textInputSupport
          imageInputSupport
          audioInputSupport
          textOutputSupport
          imageOutputSupport
          audioOutputSupport
          thinkingSupport
          contextWindowTokens
          maxResponseTokens
          knowledgeCutoffDate
          lastCheckedDate
          supportedLanguages
          warningDate
          warningMessage
          deprecationDate
          deprecationMessage
          defaultServiceGroup
          defaultEnabled
          displayOrder
          recommendedUseCase
          performanceRating
          createdAt
          updatedAt
          __typename
        }
        requestHash
        messages
        prompt
        response
        tokenCountPrompt
        tokenCountResponse
        createdAt
        hash
        country
        region
        city
        quality
        qualityComment
        apiKeyType
        toxicity
        randomGroup
        agentId
        conversationId
        timings
        customer_user_id
        customer_user_name
        customer_user_email
        batch
        callbackUrl
        batchId
        batchCustomId
        batchRequest
        executionMode
        pricingMode
        vendorBatchId
        vendorResponseId
        vendorStatus
        resolvedModelId
        usageTapCallId
        usageTapStripeCustomerId
        error
        cacheReadTokens
        cacheWriteTokens
        cacheStatus
        compactionTriggered
        compactionTokensSaved
        curatedTokensSaved
        curatedItems
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
    emailAddress
    thumbsupClicked
    thumbsdownClicked
    copyClicked
    emailClicked
    saveClicked
    ctaClicked
    suggestionClicked
    actionClicked
    intelligence
    endedAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateLLMConversationMutationVariables,
  APITypes.UpdateLLMConversationMutation
>;
export const deleteLLMConversation = /* GraphQL */ `mutation DeleteLLMConversation(
  $input: DeleteLLMConversationInput!
  $condition: ModelLLMConversationConditionInput
) {
  deleteLLMConversation(input: $input, condition: $condition) {
    id
    projectId
    agentId
    agent {
      id
      status
      name
      description
      projectId
      systemInstructions
      systemInstructionsAction
      displayTheme
      cssUrl
      displayTitle
      displayStartMessageOrPrompt
      displayInitialMessageOrPrompt
      displayPromptTemplate
      displayFollowOnPrompts
      displayActions
      displayWidth
      displayHeight
      displayPlaceholder
      displayHideInitialPrompt
      displayShowSaveButton
      displayShowEmailButton
      displayShowCallToAction
      displayCallToActionButtonText
      displayCallToActionEmailAddress
      displayCallToActionEmailSubject
      displayCallToActionMustSendEmail
      displayScrollToEnd
      groupId
      data
      calls {
        items {
          id
          projectId
          status
          customerId
          serviceId
          modelId
          requestHash
          messages
          prompt
          response
          tokenCountPrompt
          tokenCountResponse
          createdAt
          hash
          country
          region
          city
          quality
          qualityComment
          apiKeyType
          toxicity
          randomGroup
          agentId
          conversationId
          timings
          customer_user_id
          customer_user_name
          customer_user_email
          batch
          callbackUrl
          batchId
          batchCustomId
          batchRequest
          executionMode
          pricingMode
          vendorBatchId
          vendorResponseId
          vendorStatus
          resolvedModelId
          usageTapCallId
          usageTapStripeCustomerId
          error
          cacheReadTokens
          cacheWriteTokens
          cacheStatus
          compactionTriggered
          compactionTokensSaved
          curatedTokensSaved
          curatedItems
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      documents {
        items {
          id
          projectId
          agentId
          status
          fileName
          fileSize
          fileType
          uploadDate
          uploader
          lastModifiedDate
          ownershipAttestation
          location
          type
          ragSplitter
          ragChunkSize
          ragChunkOverlap
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      mcpServers {
        items {
          id
          projectId
          agentId
          status
          approvalMode
          executionMode
          url
          accessToken
          headers
          stdioCommand
          stdioArgs
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      ragQueryLimit
      ragRankLimit
      ragIncludeCitations
      ragDoRerank
      ragSkipChecksOnContext
      ragShadowRead
      visibility
      createConversationOnFirstChat
      customerEmailCaptureMode
      customerEmailCapturePlaceholder
      enableRAG
      enableMCP
      injectMemories
      injectKnowledgeGraph
      enableWebSearch
      linkedFileTypes
      thinkingDepth
      enablePromptCaching
      compactionPolicy
      compactionThreshold
      curateToolResults
      curateAfterTurns
      createdAt
      updatedAt
      __typename
    }
    customerId
    customer {
      id
      name
      status
      tokensRemaining
      lastCallMadeAt
      numberOfCallsMade
      projectId
      loadSheddingTier
      dataResidency
      createdAt
      enterpriseUser
      tokenReplenishmentAmount
      tokenReplenishmentPeriod
      lastReplenishedAt
      nextReplenishAt
      usageTierId
      usageTier {
        id
        projectId
        status
        name
        description
        version
        activeAt
        inactiveAt
        priorUsageTierId
        priorUsageTier {
          id
          projectId
          status
          name
          description
          version
          activeAt
          inactiveAt
          priorUsageTierId
          baseUsageTierId
          replenishmentPeriod
          replenishmentMethod
          usageLimitAction
          standardTokenReplenishmentAmount
          premiumTokenReplenishmentAmount
          superPremiumTokenReplenishmentAmount
          reasoningTokenReplenishmentAmount
          standardCallReplenishmentAmount
          premiumCallReplenishmentAmount
          superPremiumCallReplenishmentAmount
          reasoningCallReplenishmentAmount
          standardTokenUnlimited
          premiumTokenUnlimited
          superPremiumTokenUnlimited
          reasoningTokenUnlimited
          standardCallUnlimited
          premiumCallUnlimited
          superPremiumCallUnlimited
          reasoningCallUnlimited
          createdAt
          updatedAt
          __typename
        }
        baseUsageTierId
        baseUsageTier {
          id
          projectId
          status
          name
          description
          version
          activeAt
          inactiveAt
          priorUsageTierId
          baseUsageTierId
          replenishmentPeriod
          replenishmentMethod
          usageLimitAction
          standardTokenReplenishmentAmount
          premiumTokenReplenishmentAmount
          superPremiumTokenReplenishmentAmount
          reasoningTokenReplenishmentAmount
          standardCallReplenishmentAmount
          premiumCallReplenishmentAmount
          superPremiumCallReplenishmentAmount
          reasoningCallReplenishmentAmount
          standardTokenUnlimited
          premiumTokenUnlimited
          superPremiumTokenUnlimited
          reasoningTokenUnlimited
          standardCallUnlimited
          premiumCallUnlimited
          superPremiumCallUnlimited
          reasoningCallUnlimited
          createdAt
          updatedAt
          __typename
        }
        replenishmentPeriod
        replenishmentMethod
        usageLimitAction
        standardTokenReplenishmentAmount
        premiumTokenReplenishmentAmount
        superPremiumTokenReplenishmentAmount
        reasoningTokenReplenishmentAmount
        standardCallReplenishmentAmount
        premiumCallReplenishmentAmount
        superPremiumCallReplenishmentAmount
        reasoningCallReplenishmentAmount
        standardTokenUnlimited
        premiumTokenUnlimited
        superPremiumTokenUnlimited
        reasoningTokenUnlimited
        standardCallUnlimited
        premiumCallUnlimited
        superPremiumCallUnlimited
        reasoningCallUnlimited
        createdAt
        updatedAt
        __typename
      }
      nextUsageTierId
      nextUsageTier {
        id
        projectId
        status
        name
        description
        version
        activeAt
        inactiveAt
        priorUsageTierId
        priorUsageTier {
          id
          projectId
          status
          name
          description
          version
          activeAt
          inactiveAt
          priorUsageTierId
          baseUsageTierId
          replenishmentPeriod
          replenishmentMethod
          usageLimitAction
          standardTokenReplenishmentAmount
          premiumTokenReplenishmentAmount
          superPremiumTokenReplenishmentAmount
          reasoningTokenReplenishmentAmount
          standardCallReplenishmentAmount
          premiumCallReplenishmentAmount
          superPremiumCallReplenishmentAmount
          reasoningCallReplenishmentAmount
          standardTokenUnlimited
          premiumTokenUnlimited
          superPremiumTokenUnlimited
          reasoningTokenUnlimited
          standardCallUnlimited
          premiumCallUnlimited
          superPremiumCallUnlimited
          reasoningCallUnlimited
          createdAt
          updatedAt
          __typename
        }
        baseUsageTierId
        baseUsageTier {
          id
          projectId
          status
          name
          description
          version
          activeAt
          inactiveAt
          priorUsageTierId
          baseUsageTierId
          replenishmentPeriod
          replenishmentMethod
          usageLimitAction
          standardTokenReplenishmentAmount
          premiumTokenReplenishmentAmount
          superPremiumTokenReplenishmentAmount
          reasoningTokenReplenishmentAmount
          standardCallReplenishmentAmount
          premiumCallReplenishmentAmount
          superPremiumCallReplenishmentAmount
          reasoningCallReplenishmentAmount
          standardTokenUnlimited
          premiumTokenUnlimited
          superPremiumTokenUnlimited
          reasoningTokenUnlimited
          standardCallUnlimited
          premiumCallUnlimited
          superPremiumCallUnlimited
          reasoningCallUnlimited
          createdAt
          updatedAt
          __typename
        }
        replenishmentPeriod
        replenishmentMethod
        usageLimitAction
        standardTokenReplenishmentAmount
        premiumTokenReplenishmentAmount
        superPremiumTokenReplenishmentAmount
        reasoningTokenReplenishmentAmount
        standardCallReplenishmentAmount
        premiumCallReplenishmentAmount
        superPremiumCallReplenishmentAmount
        reasoningCallReplenishmentAmount
        standardTokenUnlimited
        premiumTokenUnlimited
        superPremiumTokenUnlimited
        reasoningTokenUnlimited
        standardCallUnlimited
        premiumCallUnlimited
        superPremiumCallUnlimited
        reasoningCallUnlimited
        createdAt
        updatedAt
        __typename
      }
      nextUsageTierAt
      usageLimitAction
      standardTokensRemaining
      premiumTokensRemaining
      superPremiumTokensRemaining
      reasoningTokensRemaining
      standardCallsRemaining
      premiumCallsRemaining
      superPremiumCallsRemaining
      reasoningCallsRemaining
      standardTokenUnlimited
      premiumTokenUnlimited
      superPremiumTokenUnlimited
      reasoningTokenUnlimited
      standardCallUnlimited
      premiumCallUnlimited
      superPremiumCallUnlimited
      reasoningCallUnlimited
      updatedAt
      __typename
    }
    createdAt
    status
    title
    summary
    timezone
    language
    country
    region
    city
    calls {
      items {
        id
        projectId
        status
        customerId
        customer {
          id
          name
          status
          tokensRemaining
          lastCallMadeAt
          numberOfCallsMade
          projectId
          loadSheddingTier
          dataResidency
          createdAt
          enterpriseUser
          tokenReplenishmentAmount
          tokenReplenishmentPeriod
          lastReplenishedAt
          nextReplenishAt
          usageTierId
          nextUsageTierId
          nextUsageTierAt
          usageLimitAction
          standardTokensRemaining
          premiumTokensRemaining
          superPremiumTokensRemaining
          reasoningTokensRemaining
          standardCallsRemaining
          premiumCallsRemaining
          superPremiumCallsRemaining
          reasoningCallsRemaining
          standardTokenUnlimited
          premiumTokenUnlimited
          superPremiumTokenUnlimited
          reasoningTokenUnlimited
          standardCallUnlimited
          premiumCallUnlimited
          superPremiumCallUnlimited
          reasoningCallUnlimited
          updatedAt
          __typename
        }
        serviceId
        service {
          id
          name
          status
          vendor
          region
          endpoint
          body
          header
          projectId
          loadProportion
          inputTokenPricePerMillion
          outputTokenPricePerMillion
          groupId
          createdAt
          updatedAt
          __typename
        }
        modelId
        model {
          id
          status
          vendor
          host
          supported
          name
          description
          modelKey
          modelKeyLatest
          inputTokenPrice
          cachedTokenPrice
          outputTokenPrice
          inputTokenBatchPrice
          outputTokenBatchPrice
          searchCost
          supportsSearch
          textInputSupport
          imageInputSupport
          audioInputSupport
          textOutputSupport
          imageOutputSupport
          audioOutputSupport
          thinkingSupport
          contextWindowTokens
          maxResponseTokens
          knowledgeCutoffDate
          lastCheckedDate
          supportedLanguages
          warningDate
          warningMessage
          deprecationDate
          deprecationMessage
          defaultServiceGroup
          defaultEnabled
          displayOrder
          recommendedUseCase
          performanceRating
          createdAt
          updatedAt
          __typename
        }
        requestHash
        messages
        prompt
        response
        tokenCountPrompt
        tokenCountResponse
        createdAt
        hash
        country
        region
        city
        quality
        qualityComment
        apiKeyType
        toxicity
        randomGroup
        agentId
        conversationId
        timings
        customer_user_id
        customer_user_name
        customer_user_email
        batch
        callbackUrl
        batchId
        batchCustomId
        batchRequest
        executionMode
        pricingMode
        vendorBatchId
        vendorResponseId
        vendorStatus
        resolvedModelId
        usageTapCallId
        usageTapStripeCustomerId
        error
        cacheReadTokens
        cacheWriteTokens
        cacheStatus
        compactionTriggered
        compactionTokensSaved
        curatedTokensSaved
        curatedItems
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
    emailAddress
    thumbsupClicked
    thumbsdownClicked
    copyClicked
    emailClicked
    saveClicked
    ctaClicked
    suggestionClicked
    actionClicked
    intelligence
    endedAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteLLMConversationMutationVariables,
  APITypes.DeleteLLMConversationMutation
>;
export const createLLMModel = /* GraphQL */ `mutation CreateLLMModel(
  $input: CreateLLMModelInput!
  $condition: ModelLLMModelConditionInput
) {
  createLLMModel(input: $input, condition: $condition) {
    id
    status
    vendor
    host
    supported
    name
    description
    modelKey
    modelKeyLatest
    inputTokenPrice
    cachedTokenPrice
    outputTokenPrice
    inputTokenBatchPrice
    outputTokenBatchPrice
    searchCost
    supportsSearch
    textInputSupport
    imageInputSupport
    audioInputSupport
    textOutputSupport
    imageOutputSupport
    audioOutputSupport
    thinkingSupport
    contextWindowTokens
    maxResponseTokens
    knowledgeCutoffDate
    lastCheckedDate
    supportedLanguages
    warningDate
    warningMessage
    deprecationDate
    deprecationMessage
    defaultServiceGroup
    defaultEnabled
    displayOrder
    recommendedUseCase
    performanceRating
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateLLMModelMutationVariables,
  APITypes.CreateLLMModelMutation
>;
export const updateLLMModel = /* GraphQL */ `mutation UpdateLLMModel(
  $input: UpdateLLMModelInput!
  $condition: ModelLLMModelConditionInput
) {
  updateLLMModel(input: $input, condition: $condition) {
    id
    status
    vendor
    host
    supported
    name
    description
    modelKey
    modelKeyLatest
    inputTokenPrice
    cachedTokenPrice
    outputTokenPrice
    inputTokenBatchPrice
    outputTokenBatchPrice
    searchCost
    supportsSearch
    textInputSupport
    imageInputSupport
    audioInputSupport
    textOutputSupport
    imageOutputSupport
    audioOutputSupport
    thinkingSupport
    contextWindowTokens
    maxResponseTokens
    knowledgeCutoffDate
    lastCheckedDate
    supportedLanguages
    warningDate
    warningMessage
    deprecationDate
    deprecationMessage
    defaultServiceGroup
    defaultEnabled
    displayOrder
    recommendedUseCase
    performanceRating
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateLLMModelMutationVariables,
  APITypes.UpdateLLMModelMutation
>;
export const deleteLLMModel = /* GraphQL */ `mutation DeleteLLMModel(
  $input: DeleteLLMModelInput!
  $condition: ModelLLMModelConditionInput
) {
  deleteLLMModel(input: $input, condition: $condition) {
    id
    status
    vendor
    host
    supported
    name
    description
    modelKey
    modelKeyLatest
    inputTokenPrice
    cachedTokenPrice
    outputTokenPrice
    inputTokenBatchPrice
    outputTokenBatchPrice
    searchCost
    supportsSearch
    textInputSupport
    imageInputSupport
    audioInputSupport
    textOutputSupport
    imageOutputSupport
    audioOutputSupport
    thinkingSupport
    contextWindowTokens
    maxResponseTokens
    knowledgeCutoffDate
    lastCheckedDate
    supportedLanguages
    warningDate
    warningMessage
    deprecationDate
    deprecationMessage
    defaultServiceGroup
    defaultEnabled
    displayOrder
    recommendedUseCase
    performanceRating
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteLLMModelMutationVariables,
  APITypes.DeleteLLMModelMutation
>;
export const createLLMProvider = /* GraphQL */ `mutation CreateLLMProvider(
  $input: CreateLLMProviderInput!
  $condition: ModelLLMProviderConditionInput
) {
  createLLMProvider(input: $input, condition: $condition) {
    id
    displayName
    contactUrl
    description
    defaultIsModerated
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateLLMProviderMutationVariables,
  APITypes.CreateLLMProviderMutation
>;
export const updateLLMProvider = /* GraphQL */ `mutation UpdateLLMProvider(
  $input: UpdateLLMProviderInput!
  $condition: ModelLLMProviderConditionInput
) {
  updateLLMProvider(input: $input, condition: $condition) {
    id
    displayName
    contactUrl
    description
    defaultIsModerated
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateLLMProviderMutationVariables,
  APITypes.UpdateLLMProviderMutation
>;
export const deleteLLMProvider = /* GraphQL */ `mutation DeleteLLMProvider(
  $input: DeleteLLMProviderInput!
  $condition: ModelLLMProviderConditionInput
) {
  deleteLLMProvider(input: $input, condition: $condition) {
    id
    displayName
    contactUrl
    description
    defaultIsModerated
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteLLMProviderMutationVariables,
  APITypes.DeleteLLMProviderMutation
>;
export const createLLMOpenRouterModel = /* GraphQL */ `mutation CreateLLMOpenRouterModel(
  $input: CreateLLMOpenRouterModelInput!
  $condition: ModelLLMOpenRouterModelConditionInput
) {
  createLLMOpenRouterModel(input: $input, condition: $condition) {
    id
    providerId
    provider {
      id
      displayName
      contactUrl
      description
      defaultIsModerated
      createdAt
      updatedAt
      __typename
    }
    canonicalSlug
    name
    description
    tokenizer
    instructType
    contextLength
    maxCompletionTokens
    isModerated
    architectureModality
    architectureInputModalities
    architectureOutputModalities
    supportedParameters
    defaultParameters
    huggingFaceId
    latestPricingSnapshotId
    isDeprecated
    deprecatedAt
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateLLMOpenRouterModelMutationVariables,
  APITypes.CreateLLMOpenRouterModelMutation
>;
export const updateLLMOpenRouterModel = /* GraphQL */ `mutation UpdateLLMOpenRouterModel(
  $input: UpdateLLMOpenRouterModelInput!
  $condition: ModelLLMOpenRouterModelConditionInput
) {
  updateLLMOpenRouterModel(input: $input, condition: $condition) {
    id
    providerId
    provider {
      id
      displayName
      contactUrl
      description
      defaultIsModerated
      createdAt
      updatedAt
      __typename
    }
    canonicalSlug
    name
    description
    tokenizer
    instructType
    contextLength
    maxCompletionTokens
    isModerated
    architectureModality
    architectureInputModalities
    architectureOutputModalities
    supportedParameters
    defaultParameters
    huggingFaceId
    latestPricingSnapshotId
    isDeprecated
    deprecatedAt
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateLLMOpenRouterModelMutationVariables,
  APITypes.UpdateLLMOpenRouterModelMutation
>;
export const deleteLLMOpenRouterModel = /* GraphQL */ `mutation DeleteLLMOpenRouterModel(
  $input: DeleteLLMOpenRouterModelInput!
  $condition: ModelLLMOpenRouterModelConditionInput
) {
  deleteLLMOpenRouterModel(input: $input, condition: $condition) {
    id
    providerId
    provider {
      id
      displayName
      contactUrl
      description
      defaultIsModerated
      createdAt
      updatedAt
      __typename
    }
    canonicalSlug
    name
    description
    tokenizer
    instructType
    contextLength
    maxCompletionTokens
    isModerated
    architectureModality
    architectureInputModalities
    architectureOutputModalities
    supportedParameters
    defaultParameters
    huggingFaceId
    latestPricingSnapshotId
    isDeprecated
    deprecatedAt
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteLLMOpenRouterModelMutationVariables,
  APITypes.DeleteLLMOpenRouterModelMutation
>;
export const createLLMModelPricingSnapshot = /* GraphQL */ `mutation CreateLLMModelPricingSnapshot(
  $input: CreateLLMModelPricingSnapshotInput!
  $condition: ModelLLMModelPricingSnapshotConditionInput
) {
  createLLMModelPricingSnapshot(input: $input, condition: $condition) {
    id
    modelId
    model {
      id
      providerId
      provider {
        id
        displayName
        contactUrl
        description
        defaultIsModerated
        createdAt
        updatedAt
        __typename
      }
      canonicalSlug
      name
      description
      tokenizer
      instructType
      contextLength
      maxCompletionTokens
      isModerated
      architectureModality
      architectureInputModalities
      architectureOutputModalities
      supportedParameters
      defaultParameters
      huggingFaceId
      latestPricingSnapshotId
      isDeprecated
      deprecatedAt
      createdAt
      updatedAt
      __typename
    }
    source
    fetchedAt
    currency
    promptTokenUsdNano
    completionTokenUsdNano
    cacheReadTokenUsdNano
    cacheWriteTokenUsdNano
    reasoningTokenUsdNano
    webSearchUsdNano
    requestUsdNano
    imageUsdNano
    audioUsdNano
    internalNotes
    isCurrent
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateLLMModelPricingSnapshotMutationVariables,
  APITypes.CreateLLMModelPricingSnapshotMutation
>;
export const updateLLMModelPricingSnapshot = /* GraphQL */ `mutation UpdateLLMModelPricingSnapshot(
  $input: UpdateLLMModelPricingSnapshotInput!
  $condition: ModelLLMModelPricingSnapshotConditionInput
) {
  updateLLMModelPricingSnapshot(input: $input, condition: $condition) {
    id
    modelId
    model {
      id
      providerId
      provider {
        id
        displayName
        contactUrl
        description
        defaultIsModerated
        createdAt
        updatedAt
        __typename
      }
      canonicalSlug
      name
      description
      tokenizer
      instructType
      contextLength
      maxCompletionTokens
      isModerated
      architectureModality
      architectureInputModalities
      architectureOutputModalities
      supportedParameters
      defaultParameters
      huggingFaceId
      latestPricingSnapshotId
      isDeprecated
      deprecatedAt
      createdAt
      updatedAt
      __typename
    }
    source
    fetchedAt
    currency
    promptTokenUsdNano
    completionTokenUsdNano
    cacheReadTokenUsdNano
    cacheWriteTokenUsdNano
    reasoningTokenUsdNano
    webSearchUsdNano
    requestUsdNano
    imageUsdNano
    audioUsdNano
    internalNotes
    isCurrent
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateLLMModelPricingSnapshotMutationVariables,
  APITypes.UpdateLLMModelPricingSnapshotMutation
>;
export const deleteLLMModelPricingSnapshot = /* GraphQL */ `mutation DeleteLLMModelPricingSnapshot(
  $input: DeleteLLMModelPricingSnapshotInput!
  $condition: ModelLLMModelPricingSnapshotConditionInput
) {
  deleteLLMModelPricingSnapshot(input: $input, condition: $condition) {
    id
    modelId
    model {
      id
      providerId
      provider {
        id
        displayName
        contactUrl
        description
        defaultIsModerated
        createdAt
        updatedAt
        __typename
      }
      canonicalSlug
      name
      description
      tokenizer
      instructType
      contextLength
      maxCompletionTokens
      isModerated
      architectureModality
      architectureInputModalities
      architectureOutputModalities
      supportedParameters
      defaultParameters
      huggingFaceId
      latestPricingSnapshotId
      isDeprecated
      deprecatedAt
      createdAt
      updatedAt
      __typename
    }
    source
    fetchedAt
    currency
    promptTokenUsdNano
    completionTokenUsdNano
    cacheReadTokenUsdNano
    cacheWriteTokenUsdNano
    reasoningTokenUsdNano
    webSearchUsdNano
    requestUsdNano
    imageUsdNano
    audioUsdNano
    internalNotes
    isCurrent
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteLLMModelPricingSnapshotMutationVariables,
  APITypes.DeleteLLMModelPricingSnapshotMutation
>;
export const createLLMModelCapability = /* GraphQL */ `mutation CreateLLMModelCapability(
  $input: CreateLLMModelCapabilityInput!
  $condition: ModelLLMModelCapabilityConditionInput
) {
  createLLMModelCapability(input: $input, condition: $condition) {
    id
    modelId
    model {
      id
      providerId
      provider {
        id
        displayName
        contactUrl
        description
        defaultIsModerated
        createdAt
        updatedAt
        __typename
      }
      canonicalSlug
      name
      description
      tokenizer
      instructType
      contextLength
      maxCompletionTokens
      isModerated
      architectureModality
      architectureInputModalities
      architectureOutputModalities
      supportedParameters
      defaultParameters
      huggingFaceId
      latestPricingSnapshotId
      isDeprecated
      deprecatedAt
      createdAt
      updatedAt
      __typename
    }
    category
    value
    metadata
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateLLMModelCapabilityMutationVariables,
  APITypes.CreateLLMModelCapabilityMutation
>;
export const updateLLMModelCapability = /* GraphQL */ `mutation UpdateLLMModelCapability(
  $input: UpdateLLMModelCapabilityInput!
  $condition: ModelLLMModelCapabilityConditionInput
) {
  updateLLMModelCapability(input: $input, condition: $condition) {
    id
    modelId
    model {
      id
      providerId
      provider {
        id
        displayName
        contactUrl
        description
        defaultIsModerated
        createdAt
        updatedAt
        __typename
      }
      canonicalSlug
      name
      description
      tokenizer
      instructType
      contextLength
      maxCompletionTokens
      isModerated
      architectureModality
      architectureInputModalities
      architectureOutputModalities
      supportedParameters
      defaultParameters
      huggingFaceId
      latestPricingSnapshotId
      isDeprecated
      deprecatedAt
      createdAt
      updatedAt
      __typename
    }
    category
    value
    metadata
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateLLMModelCapabilityMutationVariables,
  APITypes.UpdateLLMModelCapabilityMutation
>;
export const deleteLLMModelCapability = /* GraphQL */ `mutation DeleteLLMModelCapability(
  $input: DeleteLLMModelCapabilityInput!
  $condition: ModelLLMModelCapabilityConditionInput
) {
  deleteLLMModelCapability(input: $input, condition: $condition) {
    id
    modelId
    model {
      id
      providerId
      provider {
        id
        displayName
        contactUrl
        description
        defaultIsModerated
        createdAt
        updatedAt
        __typename
      }
      canonicalSlug
      name
      description
      tokenizer
      instructType
      contextLength
      maxCompletionTokens
      isModerated
      architectureModality
      architectureInputModalities
      architectureOutputModalities
      supportedParameters
      defaultParameters
      huggingFaceId
      latestPricingSnapshotId
      isDeprecated
      deprecatedAt
      createdAt
      updatedAt
      __typename
    }
    category
    value
    metadata
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteLLMModelCapabilityMutationVariables,
  APITypes.DeleteLLMModelCapabilityMutation
>;
export const createLLMScheduledPrompt = /* GraphQL */ `mutation CreateLLMScheduledPrompt(
  $input: CreateLLMScheduledPromptInput!
  $condition: ModelLLMScheduledPromptConditionInput
) {
  createLLMScheduledPrompt(input: $input, condition: $condition) {
    id
    projectId
    status
    agentId
    agent {
      id
      status
      name
      description
      projectId
      systemInstructions
      systemInstructionsAction
      displayTheme
      cssUrl
      displayTitle
      displayStartMessageOrPrompt
      displayInitialMessageOrPrompt
      displayPromptTemplate
      displayFollowOnPrompts
      displayActions
      displayWidth
      displayHeight
      displayPlaceholder
      displayHideInitialPrompt
      displayShowSaveButton
      displayShowEmailButton
      displayShowCallToAction
      displayCallToActionButtonText
      displayCallToActionEmailAddress
      displayCallToActionEmailSubject
      displayCallToActionMustSendEmail
      displayScrollToEnd
      groupId
      data
      calls {
        items {
          id
          projectId
          status
          customerId
          serviceId
          modelId
          requestHash
          messages
          prompt
          response
          tokenCountPrompt
          tokenCountResponse
          createdAt
          hash
          country
          region
          city
          quality
          qualityComment
          apiKeyType
          toxicity
          randomGroup
          agentId
          conversationId
          timings
          customer_user_id
          customer_user_name
          customer_user_email
          batch
          callbackUrl
          batchId
          batchCustomId
          batchRequest
          executionMode
          pricingMode
          vendorBatchId
          vendorResponseId
          vendorStatus
          resolvedModelId
          usageTapCallId
          usageTapStripeCustomerId
          error
          cacheReadTokens
          cacheWriteTokens
          cacheStatus
          compactionTriggered
          compactionTokensSaved
          curatedTokensSaved
          curatedItems
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      documents {
        items {
          id
          projectId
          agentId
          status
          fileName
          fileSize
          fileType
          uploadDate
          uploader
          lastModifiedDate
          ownershipAttestation
          location
          type
          ragSplitter
          ragChunkSize
          ragChunkOverlap
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      mcpServers {
        items {
          id
          projectId
          agentId
          status
          approvalMode
          executionMode
          url
          accessToken
          headers
          stdioCommand
          stdioArgs
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      ragQueryLimit
      ragRankLimit
      ragIncludeCitations
      ragDoRerank
      ragSkipChecksOnContext
      ragShadowRead
      visibility
      createConversationOnFirstChat
      customerEmailCaptureMode
      customerEmailCapturePlaceholder
      enableRAG
      enableMCP
      injectMemories
      injectKnowledgeGraph
      enableWebSearch
      linkedFileTypes
      thinkingDepth
      enablePromptCaching
      compactionPolicy
      compactionThreshold
      curateToolResults
      curateAfterTurns
      createdAt
      updatedAt
      __typename
    }
    title
    data
    prompt
    scheduledAt
    priorScheduledPromptId
    nextScheduledPromptId
    processedAt
    response
    failedTimes
    errorMessage
    notificationEmailAddresses
    notificationEmailSubject
    repeatIntervalHours
    followOnAgentId
    followOnFollowOnAgentId
    followOnTitle
    followOnPrompt
    followOnScheduledAtHours
    followOnNotificationEmailAddresses
    followOnNotificationEmailSubject
    followOnRepeatIntervalHours
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateLLMScheduledPromptMutationVariables,
  APITypes.CreateLLMScheduledPromptMutation
>;
export const updateLLMScheduledPrompt = /* GraphQL */ `mutation UpdateLLMScheduledPrompt(
  $input: UpdateLLMScheduledPromptInput!
  $condition: ModelLLMScheduledPromptConditionInput
) {
  updateLLMScheduledPrompt(input: $input, condition: $condition) {
    id
    projectId
    status
    agentId
    agent {
      id
      status
      name
      description
      projectId
      systemInstructions
      systemInstructionsAction
      displayTheme
      cssUrl
      displayTitle
      displayStartMessageOrPrompt
      displayInitialMessageOrPrompt
      displayPromptTemplate
      displayFollowOnPrompts
      displayActions
      displayWidth
      displayHeight
      displayPlaceholder
      displayHideInitialPrompt
      displayShowSaveButton
      displayShowEmailButton
      displayShowCallToAction
      displayCallToActionButtonText
      displayCallToActionEmailAddress
      displayCallToActionEmailSubject
      displayCallToActionMustSendEmail
      displayScrollToEnd
      groupId
      data
      calls {
        items {
          id
          projectId
          status
          customerId
          serviceId
          modelId
          requestHash
          messages
          prompt
          response
          tokenCountPrompt
          tokenCountResponse
          createdAt
          hash
          country
          region
          city
          quality
          qualityComment
          apiKeyType
          toxicity
          randomGroup
          agentId
          conversationId
          timings
          customer_user_id
          customer_user_name
          customer_user_email
          batch
          callbackUrl
          batchId
          batchCustomId
          batchRequest
          executionMode
          pricingMode
          vendorBatchId
          vendorResponseId
          vendorStatus
          resolvedModelId
          usageTapCallId
          usageTapStripeCustomerId
          error
          cacheReadTokens
          cacheWriteTokens
          cacheStatus
          compactionTriggered
          compactionTokensSaved
          curatedTokensSaved
          curatedItems
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      documents {
        items {
          id
          projectId
          agentId
          status
          fileName
          fileSize
          fileType
          uploadDate
          uploader
          lastModifiedDate
          ownershipAttestation
          location
          type
          ragSplitter
          ragChunkSize
          ragChunkOverlap
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      mcpServers {
        items {
          id
          projectId
          agentId
          status
          approvalMode
          executionMode
          url
          accessToken
          headers
          stdioCommand
          stdioArgs
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      ragQueryLimit
      ragRankLimit
      ragIncludeCitations
      ragDoRerank
      ragSkipChecksOnContext
      ragShadowRead
      visibility
      createConversationOnFirstChat
      customerEmailCaptureMode
      customerEmailCapturePlaceholder
      enableRAG
      enableMCP
      injectMemories
      injectKnowledgeGraph
      enableWebSearch
      linkedFileTypes
      thinkingDepth
      enablePromptCaching
      compactionPolicy
      compactionThreshold
      curateToolResults
      curateAfterTurns
      createdAt
      updatedAt
      __typename
    }
    title
    data
    prompt
    scheduledAt
    priorScheduledPromptId
    nextScheduledPromptId
    processedAt
    response
    failedTimes
    errorMessage
    notificationEmailAddresses
    notificationEmailSubject
    repeatIntervalHours
    followOnAgentId
    followOnFollowOnAgentId
    followOnTitle
    followOnPrompt
    followOnScheduledAtHours
    followOnNotificationEmailAddresses
    followOnNotificationEmailSubject
    followOnRepeatIntervalHours
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateLLMScheduledPromptMutationVariables,
  APITypes.UpdateLLMScheduledPromptMutation
>;
export const deleteLLMScheduledPrompt = /* GraphQL */ `mutation DeleteLLMScheduledPrompt(
  $input: DeleteLLMScheduledPromptInput!
  $condition: ModelLLMScheduledPromptConditionInput
) {
  deleteLLMScheduledPrompt(input: $input, condition: $condition) {
    id
    projectId
    status
    agentId
    agent {
      id
      status
      name
      description
      projectId
      systemInstructions
      systemInstructionsAction
      displayTheme
      cssUrl
      displayTitle
      displayStartMessageOrPrompt
      displayInitialMessageOrPrompt
      displayPromptTemplate
      displayFollowOnPrompts
      displayActions
      displayWidth
      displayHeight
      displayPlaceholder
      displayHideInitialPrompt
      displayShowSaveButton
      displayShowEmailButton
      displayShowCallToAction
      displayCallToActionButtonText
      displayCallToActionEmailAddress
      displayCallToActionEmailSubject
      displayCallToActionMustSendEmail
      displayScrollToEnd
      groupId
      data
      calls {
        items {
          id
          projectId
          status
          customerId
          serviceId
          modelId
          requestHash
          messages
          prompt
          response
          tokenCountPrompt
          tokenCountResponse
          createdAt
          hash
          country
          region
          city
          quality
          qualityComment
          apiKeyType
          toxicity
          randomGroup
          agentId
          conversationId
          timings
          customer_user_id
          customer_user_name
          customer_user_email
          batch
          callbackUrl
          batchId
          batchCustomId
          batchRequest
          executionMode
          pricingMode
          vendorBatchId
          vendorResponseId
          vendorStatus
          resolvedModelId
          usageTapCallId
          usageTapStripeCustomerId
          error
          cacheReadTokens
          cacheWriteTokens
          cacheStatus
          compactionTriggered
          compactionTokensSaved
          curatedTokensSaved
          curatedItems
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      documents {
        items {
          id
          projectId
          agentId
          status
          fileName
          fileSize
          fileType
          uploadDate
          uploader
          lastModifiedDate
          ownershipAttestation
          location
          type
          ragSplitter
          ragChunkSize
          ragChunkOverlap
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      mcpServers {
        items {
          id
          projectId
          agentId
          status
          approvalMode
          executionMode
          url
          accessToken
          headers
          stdioCommand
          stdioArgs
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      ragQueryLimit
      ragRankLimit
      ragIncludeCitations
      ragDoRerank
      ragSkipChecksOnContext
      ragShadowRead
      visibility
      createConversationOnFirstChat
      customerEmailCaptureMode
      customerEmailCapturePlaceholder
      enableRAG
      enableMCP
      injectMemories
      injectKnowledgeGraph
      enableWebSearch
      linkedFileTypes
      thinkingDepth
      enablePromptCaching
      compactionPolicy
      compactionThreshold
      curateToolResults
      curateAfterTurns
      createdAt
      updatedAt
      __typename
    }
    title
    data
    prompt
    scheduledAt
    priorScheduledPromptId
    nextScheduledPromptId
    processedAt
    response
    failedTimes
    errorMessage
    notificationEmailAddresses
    notificationEmailSubject
    repeatIntervalHours
    followOnAgentId
    followOnFollowOnAgentId
    followOnTitle
    followOnPrompt
    followOnScheduledAtHours
    followOnNotificationEmailAddresses
    followOnNotificationEmailSubject
    followOnRepeatIntervalHours
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteLLMScheduledPromptMutationVariables,
  APITypes.DeleteLLMScheduledPromptMutation
>;
export const createLLMTrigger = /* GraphQL */ `mutation CreateLLMTrigger(
  $input: CreateLLMTriggerInput!
  $condition: ModelLLMTriggerConditionInput
) {
  createLLMTrigger(input: $input, condition: $condition) {
    id
    projectId
    status
    triggerType
    scheduledPromptId
    scheduledPrompt {
      id
      projectId
      status
      agentId
      agent {
        id
        status
        name
        description
        projectId
        systemInstructions
        systemInstructionsAction
        displayTheme
        cssUrl
        displayTitle
        displayStartMessageOrPrompt
        displayInitialMessageOrPrompt
        displayPromptTemplate
        displayFollowOnPrompts
        displayActions
        displayWidth
        displayHeight
        displayPlaceholder
        displayHideInitialPrompt
        displayShowSaveButton
        displayShowEmailButton
        displayShowCallToAction
        displayCallToActionButtonText
        displayCallToActionEmailAddress
        displayCallToActionEmailSubject
        displayCallToActionMustSendEmail
        displayScrollToEnd
        groupId
        data
        calls {
          nextToken
          __typename
        }
        documents {
          nextToken
          __typename
        }
        mcpServers {
          nextToken
          __typename
        }
        ragQueryLimit
        ragRankLimit
        ragIncludeCitations
        ragDoRerank
        ragSkipChecksOnContext
        ragShadowRead
        visibility
        createConversationOnFirstChat
        customerEmailCaptureMode
        customerEmailCapturePlaceholder
        enableRAG
        enableMCP
        injectMemories
        injectKnowledgeGraph
        enableWebSearch
        linkedFileTypes
        thinkingDepth
        enablePromptCaching
        compactionPolicy
        compactionThreshold
        curateToolResults
        curateAfterTurns
        createdAt
        updatedAt
        __typename
      }
      title
      data
      prompt
      scheduledAt
      priorScheduledPromptId
      nextScheduledPromptId
      processedAt
      response
      failedTimes
      errorMessage
      notificationEmailAddresses
      notificationEmailSubject
      repeatIntervalHours
      followOnAgentId
      followOnFollowOnAgentId
      followOnTitle
      followOnPrompt
      followOnScheduledAtHours
      followOnNotificationEmailAddresses
      followOnNotificationEmailSubject
      followOnRepeatIntervalHours
      createdAt
      updatedAt
      __typename
    }
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateLLMTriggerMutationVariables,
  APITypes.CreateLLMTriggerMutation
>;
export const updateLLMTrigger = /* GraphQL */ `mutation UpdateLLMTrigger(
  $input: UpdateLLMTriggerInput!
  $condition: ModelLLMTriggerConditionInput
) {
  updateLLMTrigger(input: $input, condition: $condition) {
    id
    projectId
    status
    triggerType
    scheduledPromptId
    scheduledPrompt {
      id
      projectId
      status
      agentId
      agent {
        id
        status
        name
        description
        projectId
        systemInstructions
        systemInstructionsAction
        displayTheme
        cssUrl
        displayTitle
        displayStartMessageOrPrompt
        displayInitialMessageOrPrompt
        displayPromptTemplate
        displayFollowOnPrompts
        displayActions
        displayWidth
        displayHeight
        displayPlaceholder
        displayHideInitialPrompt
        displayShowSaveButton
        displayShowEmailButton
        displayShowCallToAction
        displayCallToActionButtonText
        displayCallToActionEmailAddress
        displayCallToActionEmailSubject
        displayCallToActionMustSendEmail
        displayScrollToEnd
        groupId
        data
        calls {
          nextToken
          __typename
        }
        documents {
          nextToken
          __typename
        }
        mcpServers {
          nextToken
          __typename
        }
        ragQueryLimit
        ragRankLimit
        ragIncludeCitations
        ragDoRerank
        ragSkipChecksOnContext
        ragShadowRead
        visibility
        createConversationOnFirstChat
        customerEmailCaptureMode
        customerEmailCapturePlaceholder
        enableRAG
        enableMCP
        injectMemories
        injectKnowledgeGraph
        enableWebSearch
        linkedFileTypes
        thinkingDepth
        enablePromptCaching
        compactionPolicy
        compactionThreshold
        curateToolResults
        curateAfterTurns
        createdAt
        updatedAt
        __typename
      }
      title
      data
      prompt
      scheduledAt
      priorScheduledPromptId
      nextScheduledPromptId
      processedAt
      response
      failedTimes
      errorMessage
      notificationEmailAddresses
      notificationEmailSubject
      repeatIntervalHours
      followOnAgentId
      followOnFollowOnAgentId
      followOnTitle
      followOnPrompt
      followOnScheduledAtHours
      followOnNotificationEmailAddresses
      followOnNotificationEmailSubject
      followOnRepeatIntervalHours
      createdAt
      updatedAt
      __typename
    }
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateLLMTriggerMutationVariables,
  APITypes.UpdateLLMTriggerMutation
>;
export const deleteLLMTrigger = /* GraphQL */ `mutation DeleteLLMTrigger(
  $input: DeleteLLMTriggerInput!
  $condition: ModelLLMTriggerConditionInput
) {
  deleteLLMTrigger(input: $input, condition: $condition) {
    id
    projectId
    status
    triggerType
    scheduledPromptId
    scheduledPrompt {
      id
      projectId
      status
      agentId
      agent {
        id
        status
        name
        description
        projectId
        systemInstructions
        systemInstructionsAction
        displayTheme
        cssUrl
        displayTitle
        displayStartMessageOrPrompt
        displayInitialMessageOrPrompt
        displayPromptTemplate
        displayFollowOnPrompts
        displayActions
        displayWidth
        displayHeight
        displayPlaceholder
        displayHideInitialPrompt
        displayShowSaveButton
        displayShowEmailButton
        displayShowCallToAction
        displayCallToActionButtonText
        displayCallToActionEmailAddress
        displayCallToActionEmailSubject
        displayCallToActionMustSendEmail
        displayScrollToEnd
        groupId
        data
        calls {
          nextToken
          __typename
        }
        documents {
          nextToken
          __typename
        }
        mcpServers {
          nextToken
          __typename
        }
        ragQueryLimit
        ragRankLimit
        ragIncludeCitations
        ragDoRerank
        ragSkipChecksOnContext
        ragShadowRead
        visibility
        createConversationOnFirstChat
        customerEmailCaptureMode
        customerEmailCapturePlaceholder
        enableRAG
        enableMCP
        injectMemories
        injectKnowledgeGraph
        enableWebSearch
        linkedFileTypes
        thinkingDepth
        enablePromptCaching
        compactionPolicy
        compactionThreshold
        curateToolResults
        curateAfterTurns
        createdAt
        updatedAt
        __typename
      }
      title
      data
      prompt
      scheduledAt
      priorScheduledPromptId
      nextScheduledPromptId
      processedAt
      response
      failedTimes
      errorMessage
      notificationEmailAddresses
      notificationEmailSubject
      repeatIntervalHours
      followOnAgentId
      followOnFollowOnAgentId
      followOnTitle
      followOnPrompt
      followOnScheduledAtHours
      followOnNotificationEmailAddresses
      followOnNotificationEmailSubject
      followOnRepeatIntervalHours
      createdAt
      updatedAt
      __typename
    }
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteLLMTriggerMutationVariables,
  APITypes.DeleteLLMTriggerMutation
>;
export const createLLMMemory = /* GraphQL */ `mutation CreateLLMMemory(
  $input: CreateLLMMemoryInput!
  $condition: ModelLLMMemoryConditionInput
) {
  createLLMMemory(input: $input, condition: $condition) {
    id
    projectId
    status
    entityType
    customerId
    agentId
    customer {
      id
      name
      status
      tokensRemaining
      lastCallMadeAt
      numberOfCallsMade
      projectId
      loadSheddingTier
      dataResidency
      createdAt
      enterpriseUser
      tokenReplenishmentAmount
      tokenReplenishmentPeriod
      lastReplenishedAt
      nextReplenishAt
      usageTierId
      usageTier {
        id
        projectId
        status
        name
        description
        version
        activeAt
        inactiveAt
        priorUsageTierId
        priorUsageTier {
          id
          projectId
          status
          name
          description
          version
          activeAt
          inactiveAt
          priorUsageTierId
          baseUsageTierId
          replenishmentPeriod
          replenishmentMethod
          usageLimitAction
          standardTokenReplenishmentAmount
          premiumTokenReplenishmentAmount
          superPremiumTokenReplenishmentAmount
          reasoningTokenReplenishmentAmount
          standardCallReplenishmentAmount
          premiumCallReplenishmentAmount
          superPremiumCallReplenishmentAmount
          reasoningCallReplenishmentAmount
          standardTokenUnlimited
          premiumTokenUnlimited
          superPremiumTokenUnlimited
          reasoningTokenUnlimited
          standardCallUnlimited
          premiumCallUnlimited
          superPremiumCallUnlimited
          reasoningCallUnlimited
          createdAt
          updatedAt
          __typename
        }
        baseUsageTierId
        baseUsageTier {
          id
          projectId
          status
          name
          description
          version
          activeAt
          inactiveAt
          priorUsageTierId
          baseUsageTierId
          replenishmentPeriod
          replenishmentMethod
          usageLimitAction
          standardTokenReplenishmentAmount
          premiumTokenReplenishmentAmount
          superPremiumTokenReplenishmentAmount
          reasoningTokenReplenishmentAmount
          standardCallReplenishmentAmount
          premiumCallReplenishmentAmount
          superPremiumCallReplenishmentAmount
          reasoningCallReplenishmentAmount
          standardTokenUnlimited
          premiumTokenUnlimited
          superPremiumTokenUnlimited
          reasoningTokenUnlimited
          standardCallUnlimited
          premiumCallUnlimited
          superPremiumCallUnlimited
          reasoningCallUnlimited
          createdAt
          updatedAt
          __typename
        }
        replenishmentPeriod
        replenishmentMethod
        usageLimitAction
        standardTokenReplenishmentAmount
        premiumTokenReplenishmentAmount
        superPremiumTokenReplenishmentAmount
        reasoningTokenReplenishmentAmount
        standardCallReplenishmentAmount
        premiumCallReplenishmentAmount
        superPremiumCallReplenishmentAmount
        reasoningCallReplenishmentAmount
        standardTokenUnlimited
        premiumTokenUnlimited
        superPremiumTokenUnlimited
        reasoningTokenUnlimited
        standardCallUnlimited
        premiumCallUnlimited
        superPremiumCallUnlimited
        reasoningCallUnlimited
        createdAt
        updatedAt
        __typename
      }
      nextUsageTierId
      nextUsageTier {
        id
        projectId
        status
        name
        description
        version
        activeAt
        inactiveAt
        priorUsageTierId
        priorUsageTier {
          id
          projectId
          status
          name
          description
          version
          activeAt
          inactiveAt
          priorUsageTierId
          baseUsageTierId
          replenishmentPeriod
          replenishmentMethod
          usageLimitAction
          standardTokenReplenishmentAmount
          premiumTokenReplenishmentAmount
          superPremiumTokenReplenishmentAmount
          reasoningTokenReplenishmentAmount
          standardCallReplenishmentAmount
          premiumCallReplenishmentAmount
          superPremiumCallReplenishmentAmount
          reasoningCallReplenishmentAmount
          standardTokenUnlimited
          premiumTokenUnlimited
          superPremiumTokenUnlimited
          reasoningTokenUnlimited
          standardCallUnlimited
          premiumCallUnlimited
          superPremiumCallUnlimited
          reasoningCallUnlimited
          createdAt
          updatedAt
          __typename
        }
        baseUsageTierId
        baseUsageTier {
          id
          projectId
          status
          name
          description
          version
          activeAt
          inactiveAt
          priorUsageTierId
          baseUsageTierId
          replenishmentPeriod
          replenishmentMethod
          usageLimitAction
          standardTokenReplenishmentAmount
          premiumTokenReplenishmentAmount
          superPremiumTokenReplenishmentAmount
          reasoningTokenReplenishmentAmount
          standardCallReplenishmentAmount
          premiumCallReplenishmentAmount
          superPremiumCallReplenishmentAmount
          reasoningCallReplenishmentAmount
          standardTokenUnlimited
          premiumTokenUnlimited
          superPremiumTokenUnlimited
          reasoningTokenUnlimited
          standardCallUnlimited
          premiumCallUnlimited
          superPremiumCallUnlimited
          reasoningCallUnlimited
          createdAt
          updatedAt
          __typename
        }
        replenishmentPeriod
        replenishmentMethod
        usageLimitAction
        standardTokenReplenishmentAmount
        premiumTokenReplenishmentAmount
        superPremiumTokenReplenishmentAmount
        reasoningTokenReplenishmentAmount
        standardCallReplenishmentAmount
        premiumCallReplenishmentAmount
        superPremiumCallReplenishmentAmount
        reasoningCallReplenishmentAmount
        standardTokenUnlimited
        premiumTokenUnlimited
        superPremiumTokenUnlimited
        reasoningTokenUnlimited
        standardCallUnlimited
        premiumCallUnlimited
        superPremiumCallUnlimited
        reasoningCallUnlimited
        createdAt
        updatedAt
        __typename
      }
      nextUsageTierAt
      usageLimitAction
      standardTokensRemaining
      premiumTokensRemaining
      superPremiumTokensRemaining
      reasoningTokensRemaining
      standardCallsRemaining
      premiumCallsRemaining
      superPremiumCallsRemaining
      reasoningCallsRemaining
      standardTokenUnlimited
      premiumTokenUnlimited
      superPremiumTokenUnlimited
      reasoningTokenUnlimited
      standardCallUnlimited
      premiumCallUnlimited
      superPremiumCallUnlimited
      reasoningCallUnlimited
      updatedAt
      __typename
    }
    key
    data
    tags
    memoryType
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateLLMMemoryMutationVariables,
  APITypes.CreateLLMMemoryMutation
>;
export const updateLLMMemory = /* GraphQL */ `mutation UpdateLLMMemory(
  $input: UpdateLLMMemoryInput!
  $condition: ModelLLMMemoryConditionInput
) {
  updateLLMMemory(input: $input, condition: $condition) {
    id
    projectId
    status
    entityType
    customerId
    agentId
    customer {
      id
      name
      status
      tokensRemaining
      lastCallMadeAt
      numberOfCallsMade
      projectId
      loadSheddingTier
      dataResidency
      createdAt
      enterpriseUser
      tokenReplenishmentAmount
      tokenReplenishmentPeriod
      lastReplenishedAt
      nextReplenishAt
      usageTierId
      usageTier {
        id
        projectId
        status
        name
        description
        version
        activeAt
        inactiveAt
        priorUsageTierId
        priorUsageTier {
          id
          projectId
          status
          name
          description
          version
          activeAt
          inactiveAt
          priorUsageTierId
          baseUsageTierId
          replenishmentPeriod
          replenishmentMethod
          usageLimitAction
          standardTokenReplenishmentAmount
          premiumTokenReplenishmentAmount
          superPremiumTokenReplenishmentAmount
          reasoningTokenReplenishmentAmount
          standardCallReplenishmentAmount
          premiumCallReplenishmentAmount
          superPremiumCallReplenishmentAmount
          reasoningCallReplenishmentAmount
          standardTokenUnlimited
          premiumTokenUnlimited
          superPremiumTokenUnlimited
          reasoningTokenUnlimited
          standardCallUnlimited
          premiumCallUnlimited
          superPremiumCallUnlimited
          reasoningCallUnlimited
          createdAt
          updatedAt
          __typename
        }
        baseUsageTierId
        baseUsageTier {
          id
          projectId
          status
          name
          description
          version
          activeAt
          inactiveAt
          priorUsageTierId
          baseUsageTierId
          replenishmentPeriod
          replenishmentMethod
          usageLimitAction
          standardTokenReplenishmentAmount
          premiumTokenReplenishmentAmount
          superPremiumTokenReplenishmentAmount
          reasoningTokenReplenishmentAmount
          standardCallReplenishmentAmount
          premiumCallReplenishmentAmount
          superPremiumCallReplenishmentAmount
          reasoningCallReplenishmentAmount
          standardTokenUnlimited
          premiumTokenUnlimited
          superPremiumTokenUnlimited
          reasoningTokenUnlimited
          standardCallUnlimited
          premiumCallUnlimited
          superPremiumCallUnlimited
          reasoningCallUnlimited
          createdAt
          updatedAt
          __typename
        }
        replenishmentPeriod
        replenishmentMethod
        usageLimitAction
        standardTokenReplenishmentAmount
        premiumTokenReplenishmentAmount
        superPremiumTokenReplenishmentAmount
        reasoningTokenReplenishmentAmount
        standardCallReplenishmentAmount
        premiumCallReplenishmentAmount
        superPremiumCallReplenishmentAmount
        reasoningCallReplenishmentAmount
        standardTokenUnlimited
        premiumTokenUnlimited
        superPremiumTokenUnlimited
        reasoningTokenUnlimited
        standardCallUnlimited
        premiumCallUnlimited
        superPremiumCallUnlimited
        reasoningCallUnlimited
        createdAt
        updatedAt
        __typename
      }
      nextUsageTierId
      nextUsageTier {
        id
        projectId
        status
        name
        description
        version
        activeAt
        inactiveAt
        priorUsageTierId
        priorUsageTier {
          id
          projectId
          status
          name
          description
          version
          activeAt
          inactiveAt
          priorUsageTierId
          baseUsageTierId
          replenishmentPeriod
          replenishmentMethod
          usageLimitAction
          standardTokenReplenishmentAmount
          premiumTokenReplenishmentAmount
          superPremiumTokenReplenishmentAmount
          reasoningTokenReplenishmentAmount
          standardCallReplenishmentAmount
          premiumCallReplenishmentAmount
          superPremiumCallReplenishmentAmount
          reasoningCallReplenishmentAmount
          standardTokenUnlimited
          premiumTokenUnlimited
          superPremiumTokenUnlimited
          reasoningTokenUnlimited
          standardCallUnlimited
          premiumCallUnlimited
          superPremiumCallUnlimited
          reasoningCallUnlimited
          createdAt
          updatedAt
          __typename
        }
        baseUsageTierId
        baseUsageTier {
          id
          projectId
          status
          name
          description
          version
          activeAt
          inactiveAt
          priorUsageTierId
          baseUsageTierId
          replenishmentPeriod
          replenishmentMethod
          usageLimitAction
          standardTokenReplenishmentAmount
          premiumTokenReplenishmentAmount
          superPremiumTokenReplenishmentAmount
          reasoningTokenReplenishmentAmount
          standardCallReplenishmentAmount
          premiumCallReplenishmentAmount
          superPremiumCallReplenishmentAmount
          reasoningCallReplenishmentAmount
          standardTokenUnlimited
          premiumTokenUnlimited
          superPremiumTokenUnlimited
          reasoningTokenUnlimited
          standardCallUnlimited
          premiumCallUnlimited
          superPremiumCallUnlimited
          reasoningCallUnlimited
          createdAt
          updatedAt
          __typename
        }
        replenishmentPeriod
        replenishmentMethod
        usageLimitAction
        standardTokenReplenishmentAmount
        premiumTokenReplenishmentAmount
        superPremiumTokenReplenishmentAmount
        reasoningTokenReplenishmentAmount
        standardCallReplenishmentAmount
        premiumCallReplenishmentAmount
        superPremiumCallReplenishmentAmount
        reasoningCallReplenishmentAmount
        standardTokenUnlimited
        premiumTokenUnlimited
        superPremiumTokenUnlimited
        reasoningTokenUnlimited
        standardCallUnlimited
        premiumCallUnlimited
        superPremiumCallUnlimited
        reasoningCallUnlimited
        createdAt
        updatedAt
        __typename
      }
      nextUsageTierAt
      usageLimitAction
      standardTokensRemaining
      premiumTokensRemaining
      superPremiumTokensRemaining
      reasoningTokensRemaining
      standardCallsRemaining
      premiumCallsRemaining
      superPremiumCallsRemaining
      reasoningCallsRemaining
      standardTokenUnlimited
      premiumTokenUnlimited
      superPremiumTokenUnlimited
      reasoningTokenUnlimited
      standardCallUnlimited
      premiumCallUnlimited
      superPremiumCallUnlimited
      reasoningCallUnlimited
      updatedAt
      __typename
    }
    key
    data
    tags
    memoryType
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateLLMMemoryMutationVariables,
  APITypes.UpdateLLMMemoryMutation
>;
export const deleteLLMMemory = /* GraphQL */ `mutation DeleteLLMMemory(
  $input: DeleteLLMMemoryInput!
  $condition: ModelLLMMemoryConditionInput
) {
  deleteLLMMemory(input: $input, condition: $condition) {
    id
    projectId
    status
    entityType
    customerId
    agentId
    customer {
      id
      name
      status
      tokensRemaining
      lastCallMadeAt
      numberOfCallsMade
      projectId
      loadSheddingTier
      dataResidency
      createdAt
      enterpriseUser
      tokenReplenishmentAmount
      tokenReplenishmentPeriod
      lastReplenishedAt
      nextReplenishAt
      usageTierId
      usageTier {
        id
        projectId
        status
        name
        description
        version
        activeAt
        inactiveAt
        priorUsageTierId
        priorUsageTier {
          id
          projectId
          status
          name
          description
          version
          activeAt
          inactiveAt
          priorUsageTierId
          baseUsageTierId
          replenishmentPeriod
          replenishmentMethod
          usageLimitAction
          standardTokenReplenishmentAmount
          premiumTokenReplenishmentAmount
          superPremiumTokenReplenishmentAmount
          reasoningTokenReplenishmentAmount
          standardCallReplenishmentAmount
          premiumCallReplenishmentAmount
          superPremiumCallReplenishmentAmount
          reasoningCallReplenishmentAmount
          standardTokenUnlimited
          premiumTokenUnlimited
          superPremiumTokenUnlimited
          reasoningTokenUnlimited
          standardCallUnlimited
          premiumCallUnlimited
          superPremiumCallUnlimited
          reasoningCallUnlimited
          createdAt
          updatedAt
          __typename
        }
        baseUsageTierId
        baseUsageTier {
          id
          projectId
          status
          name
          description
          version
          activeAt
          inactiveAt
          priorUsageTierId
          baseUsageTierId
          replenishmentPeriod
          replenishmentMethod
          usageLimitAction
          standardTokenReplenishmentAmount
          premiumTokenReplenishmentAmount
          superPremiumTokenReplenishmentAmount
          reasoningTokenReplenishmentAmount
          standardCallReplenishmentAmount
          premiumCallReplenishmentAmount
          superPremiumCallReplenishmentAmount
          reasoningCallReplenishmentAmount
          standardTokenUnlimited
          premiumTokenUnlimited
          superPremiumTokenUnlimited
          reasoningTokenUnlimited
          standardCallUnlimited
          premiumCallUnlimited
          superPremiumCallUnlimited
          reasoningCallUnlimited
          createdAt
          updatedAt
          __typename
        }
        replenishmentPeriod
        replenishmentMethod
        usageLimitAction
        standardTokenReplenishmentAmount
        premiumTokenReplenishmentAmount
        superPremiumTokenReplenishmentAmount
        reasoningTokenReplenishmentAmount
        standardCallReplenishmentAmount
        premiumCallReplenishmentAmount
        superPremiumCallReplenishmentAmount
        reasoningCallReplenishmentAmount
        standardTokenUnlimited
        premiumTokenUnlimited
        superPremiumTokenUnlimited
        reasoningTokenUnlimited
        standardCallUnlimited
        premiumCallUnlimited
        superPremiumCallUnlimited
        reasoningCallUnlimited
        createdAt
        updatedAt
        __typename
      }
      nextUsageTierId
      nextUsageTier {
        id
        projectId
        status
        name
        description
        version
        activeAt
        inactiveAt
        priorUsageTierId
        priorUsageTier {
          id
          projectId
          status
          name
          description
          version
          activeAt
          inactiveAt
          priorUsageTierId
          baseUsageTierId
          replenishmentPeriod
          replenishmentMethod
          usageLimitAction
          standardTokenReplenishmentAmount
          premiumTokenReplenishmentAmount
          superPremiumTokenReplenishmentAmount
          reasoningTokenReplenishmentAmount
          standardCallReplenishmentAmount
          premiumCallReplenishmentAmount
          superPremiumCallReplenishmentAmount
          reasoningCallReplenishmentAmount
          standardTokenUnlimited
          premiumTokenUnlimited
          superPremiumTokenUnlimited
          reasoningTokenUnlimited
          standardCallUnlimited
          premiumCallUnlimited
          superPremiumCallUnlimited
          reasoningCallUnlimited
          createdAt
          updatedAt
          __typename
        }
        baseUsageTierId
        baseUsageTier {
          id
          projectId
          status
          name
          description
          version
          activeAt
          inactiveAt
          priorUsageTierId
          baseUsageTierId
          replenishmentPeriod
          replenishmentMethod
          usageLimitAction
          standardTokenReplenishmentAmount
          premiumTokenReplenishmentAmount
          superPremiumTokenReplenishmentAmount
          reasoningTokenReplenishmentAmount
          standardCallReplenishmentAmount
          premiumCallReplenishmentAmount
          superPremiumCallReplenishmentAmount
          reasoningCallReplenishmentAmount
          standardTokenUnlimited
          premiumTokenUnlimited
          superPremiumTokenUnlimited
          reasoningTokenUnlimited
          standardCallUnlimited
          premiumCallUnlimited
          superPremiumCallUnlimited
          reasoningCallUnlimited
          createdAt
          updatedAt
          __typename
        }
        replenishmentPeriod
        replenishmentMethod
        usageLimitAction
        standardTokenReplenishmentAmount
        premiumTokenReplenishmentAmount
        superPremiumTokenReplenishmentAmount
        reasoningTokenReplenishmentAmount
        standardCallReplenishmentAmount
        premiumCallReplenishmentAmount
        superPremiumCallReplenishmentAmount
        reasoningCallReplenishmentAmount
        standardTokenUnlimited
        premiumTokenUnlimited
        superPremiumTokenUnlimited
        reasoningTokenUnlimited
        standardCallUnlimited
        premiumCallUnlimited
        superPremiumCallUnlimited
        reasoningCallUnlimited
        createdAt
        updatedAt
        __typename
      }
      nextUsageTierAt
      usageLimitAction
      standardTokensRemaining
      premiumTokensRemaining
      superPremiumTokensRemaining
      reasoningTokensRemaining
      standardCallsRemaining
      premiumCallsRemaining
      superPremiumCallsRemaining
      reasoningCallsRemaining
      standardTokenUnlimited
      premiumTokenUnlimited
      superPremiumTokenUnlimited
      reasoningTokenUnlimited
      standardCallUnlimited
      premiumCallUnlimited
      superPremiumCallUnlimited
      reasoningCallUnlimited
      updatedAt
      __typename
    }
    key
    data
    tags
    memoryType
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteLLMMemoryMutationVariables,
  APITypes.DeleteLLMMemoryMutation
>;
export const createLLMKnowledgeGraph = /* GraphQL */ `mutation CreateLLMKnowledgeGraph(
  $input: CreateLLMKnowledgeGraphInput!
  $condition: ModelLLMKnowledgeGraphConditionInput
) {
  createLLMKnowledgeGraph(input: $input, condition: $condition) {
    id
    projectId
    customerId
    customer {
      id
      name
      status
      tokensRemaining
      lastCallMadeAt
      numberOfCallsMade
      projectId
      loadSheddingTier
      dataResidency
      createdAt
      enterpriseUser
      tokenReplenishmentAmount
      tokenReplenishmentPeriod
      lastReplenishedAt
      nextReplenishAt
      usageTierId
      usageTier {
        id
        projectId
        status
        name
        description
        version
        activeAt
        inactiveAt
        priorUsageTierId
        priorUsageTier {
          id
          projectId
          status
          name
          description
          version
          activeAt
          inactiveAt
          priorUsageTierId
          baseUsageTierId
          replenishmentPeriod
          replenishmentMethod
          usageLimitAction
          standardTokenReplenishmentAmount
          premiumTokenReplenishmentAmount
          superPremiumTokenReplenishmentAmount
          reasoningTokenReplenishmentAmount
          standardCallReplenishmentAmount
          premiumCallReplenishmentAmount
          superPremiumCallReplenishmentAmount
          reasoningCallReplenishmentAmount
          standardTokenUnlimited
          premiumTokenUnlimited
          superPremiumTokenUnlimited
          reasoningTokenUnlimited
          standardCallUnlimited
          premiumCallUnlimited
          superPremiumCallUnlimited
          reasoningCallUnlimited
          createdAt
          updatedAt
          __typename
        }
        baseUsageTierId
        baseUsageTier {
          id
          projectId
          status
          name
          description
          version
          activeAt
          inactiveAt
          priorUsageTierId
          baseUsageTierId
          replenishmentPeriod
          replenishmentMethod
          usageLimitAction
          standardTokenReplenishmentAmount
          premiumTokenReplenishmentAmount
          superPremiumTokenReplenishmentAmount
          reasoningTokenReplenishmentAmount
          standardCallReplenishmentAmount
          premiumCallReplenishmentAmount
          superPremiumCallReplenishmentAmount
          reasoningCallReplenishmentAmount
          standardTokenUnlimited
          premiumTokenUnlimited
          superPremiumTokenUnlimited
          reasoningTokenUnlimited
          standardCallUnlimited
          premiumCallUnlimited
          superPremiumCallUnlimited
          reasoningCallUnlimited
          createdAt
          updatedAt
          __typename
        }
        replenishmentPeriod
        replenishmentMethod
        usageLimitAction
        standardTokenReplenishmentAmount
        premiumTokenReplenishmentAmount
        superPremiumTokenReplenishmentAmount
        reasoningTokenReplenishmentAmount
        standardCallReplenishmentAmount
        premiumCallReplenishmentAmount
        superPremiumCallReplenishmentAmount
        reasoningCallReplenishmentAmount
        standardTokenUnlimited
        premiumTokenUnlimited
        superPremiumTokenUnlimited
        reasoningTokenUnlimited
        standardCallUnlimited
        premiumCallUnlimited
        superPremiumCallUnlimited
        reasoningCallUnlimited
        createdAt
        updatedAt
        __typename
      }
      nextUsageTierId
      nextUsageTier {
        id
        projectId
        status
        name
        description
        version
        activeAt
        inactiveAt
        priorUsageTierId
        priorUsageTier {
          id
          projectId
          status
          name
          description
          version
          activeAt
          inactiveAt
          priorUsageTierId
          baseUsageTierId
          replenishmentPeriod
          replenishmentMethod
          usageLimitAction
          standardTokenReplenishmentAmount
          premiumTokenReplenishmentAmount
          superPremiumTokenReplenishmentAmount
          reasoningTokenReplenishmentAmount
          standardCallReplenishmentAmount
          premiumCallReplenishmentAmount
          superPremiumCallReplenishmentAmount
          reasoningCallReplenishmentAmount
          standardTokenUnlimited
          premiumTokenUnlimited
          superPremiumTokenUnlimited
          reasoningTokenUnlimited
          standardCallUnlimited
          premiumCallUnlimited
          superPremiumCallUnlimited
          reasoningCallUnlimited
          createdAt
          updatedAt
          __typename
        }
        baseUsageTierId
        baseUsageTier {
          id
          projectId
          status
          name
          description
          version
          activeAt
          inactiveAt
          priorUsageTierId
          baseUsageTierId
          replenishmentPeriod
          replenishmentMethod
          usageLimitAction
          standardTokenReplenishmentAmount
          premiumTokenReplenishmentAmount
          superPremiumTokenReplenishmentAmount
          reasoningTokenReplenishmentAmount
          standardCallReplenishmentAmount
          premiumCallReplenishmentAmount
          superPremiumCallReplenishmentAmount
          reasoningCallReplenishmentAmount
          standardTokenUnlimited
          premiumTokenUnlimited
          superPremiumTokenUnlimited
          reasoningTokenUnlimited
          standardCallUnlimited
          premiumCallUnlimited
          superPremiumCallUnlimited
          reasoningCallUnlimited
          createdAt
          updatedAt
          __typename
        }
        replenishmentPeriod
        replenishmentMethod
        usageLimitAction
        standardTokenReplenishmentAmount
        premiumTokenReplenishmentAmount
        superPremiumTokenReplenishmentAmount
        reasoningTokenReplenishmentAmount
        standardCallReplenishmentAmount
        premiumCallReplenishmentAmount
        superPremiumCallReplenishmentAmount
        reasoningCallReplenishmentAmount
        standardTokenUnlimited
        premiumTokenUnlimited
        superPremiumTokenUnlimited
        reasoningTokenUnlimited
        standardCallUnlimited
        premiumCallUnlimited
        superPremiumCallUnlimited
        reasoningCallUnlimited
        createdAt
        updatedAt
        __typename
      }
      nextUsageTierAt
      usageLimitAction
      standardTokensRemaining
      premiumTokensRemaining
      superPremiumTokensRemaining
      reasoningTokensRemaining
      standardCallsRemaining
      premiumCallsRemaining
      superPremiumCallsRemaining
      reasoningCallsRemaining
      standardTokenUnlimited
      premiumTokenUnlimited
      superPremiumTokenUnlimited
      reasoningTokenUnlimited
      standardCallUnlimited
      premiumCallUnlimited
      superPremiumCallUnlimited
      reasoningCallUnlimited
      updatedAt
      __typename
    }
    status
    version
    title
    description
    graphData
    memoryCount
    generatedFromMemoryIds
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateLLMKnowledgeGraphMutationVariables,
  APITypes.CreateLLMKnowledgeGraphMutation
>;
export const updateLLMKnowledgeGraph = /* GraphQL */ `mutation UpdateLLMKnowledgeGraph(
  $input: UpdateLLMKnowledgeGraphInput!
  $condition: ModelLLMKnowledgeGraphConditionInput
) {
  updateLLMKnowledgeGraph(input: $input, condition: $condition) {
    id
    projectId
    customerId
    customer {
      id
      name
      status
      tokensRemaining
      lastCallMadeAt
      numberOfCallsMade
      projectId
      loadSheddingTier
      dataResidency
      createdAt
      enterpriseUser
      tokenReplenishmentAmount
      tokenReplenishmentPeriod
      lastReplenishedAt
      nextReplenishAt
      usageTierId
      usageTier {
        id
        projectId
        status
        name
        description
        version
        activeAt
        inactiveAt
        priorUsageTierId
        priorUsageTier {
          id
          projectId
          status
          name
          description
          version
          activeAt
          inactiveAt
          priorUsageTierId
          baseUsageTierId
          replenishmentPeriod
          replenishmentMethod
          usageLimitAction
          standardTokenReplenishmentAmount
          premiumTokenReplenishmentAmount
          superPremiumTokenReplenishmentAmount
          reasoningTokenReplenishmentAmount
          standardCallReplenishmentAmount
          premiumCallReplenishmentAmount
          superPremiumCallReplenishmentAmount
          reasoningCallReplenishmentAmount
          standardTokenUnlimited
          premiumTokenUnlimited
          superPremiumTokenUnlimited
          reasoningTokenUnlimited
          standardCallUnlimited
          premiumCallUnlimited
          superPremiumCallUnlimited
          reasoningCallUnlimited
          createdAt
          updatedAt
          __typename
        }
        baseUsageTierId
        baseUsageTier {
          id
          projectId
          status
          name
          description
          version
          activeAt
          inactiveAt
          priorUsageTierId
          baseUsageTierId
          replenishmentPeriod
          replenishmentMethod
          usageLimitAction
          standardTokenReplenishmentAmount
          premiumTokenReplenishmentAmount
          superPremiumTokenReplenishmentAmount
          reasoningTokenReplenishmentAmount
          standardCallReplenishmentAmount
          premiumCallReplenishmentAmount
          superPremiumCallReplenishmentAmount
          reasoningCallReplenishmentAmount
          standardTokenUnlimited
          premiumTokenUnlimited
          superPremiumTokenUnlimited
          reasoningTokenUnlimited
          standardCallUnlimited
          premiumCallUnlimited
          superPremiumCallUnlimited
          reasoningCallUnlimited
          createdAt
          updatedAt
          __typename
        }
        replenishmentPeriod
        replenishmentMethod
        usageLimitAction
        standardTokenReplenishmentAmount
        premiumTokenReplenishmentAmount
        superPremiumTokenReplenishmentAmount
        reasoningTokenReplenishmentAmount
        standardCallReplenishmentAmount
        premiumCallReplenishmentAmount
        superPremiumCallReplenishmentAmount
        reasoningCallReplenishmentAmount
        standardTokenUnlimited
        premiumTokenUnlimited
        superPremiumTokenUnlimited
        reasoningTokenUnlimited
        standardCallUnlimited
        premiumCallUnlimited
        superPremiumCallUnlimited
        reasoningCallUnlimited
        createdAt
        updatedAt
        __typename
      }
      nextUsageTierId
      nextUsageTier {
        id
        projectId
        status
        name
        description
        version
        activeAt
        inactiveAt
        priorUsageTierId
        priorUsageTier {
          id
          projectId
          status
          name
          description
          version
          activeAt
          inactiveAt
          priorUsageTierId
          baseUsageTierId
          replenishmentPeriod
          replenishmentMethod
          usageLimitAction
          standardTokenReplenishmentAmount
          premiumTokenReplenishmentAmount
          superPremiumTokenReplenishmentAmount
          reasoningTokenReplenishmentAmount
          standardCallReplenishmentAmount
          premiumCallReplenishmentAmount
          superPremiumCallReplenishmentAmount
          reasoningCallReplenishmentAmount
          standardTokenUnlimited
          premiumTokenUnlimited
          superPremiumTokenUnlimited
          reasoningTokenUnlimited
          standardCallUnlimited
          premiumCallUnlimited
          superPremiumCallUnlimited
          reasoningCallUnlimited
          createdAt
          updatedAt
          __typename
        }
        baseUsageTierId
        baseUsageTier {
          id
          projectId
          status
          name
          description
          version
          activeAt
          inactiveAt
          priorUsageTierId
          baseUsageTierId
          replenishmentPeriod
          replenishmentMethod
          usageLimitAction
          standardTokenReplenishmentAmount
          premiumTokenReplenishmentAmount
          superPremiumTokenReplenishmentAmount
          reasoningTokenReplenishmentAmount
          standardCallReplenishmentAmount
          premiumCallReplenishmentAmount
          superPremiumCallReplenishmentAmount
          reasoningCallReplenishmentAmount
          standardTokenUnlimited
          premiumTokenUnlimited
          superPremiumTokenUnlimited
          reasoningTokenUnlimited
          standardCallUnlimited
          premiumCallUnlimited
          superPremiumCallUnlimited
          reasoningCallUnlimited
          createdAt
          updatedAt
          __typename
        }
        replenishmentPeriod
        replenishmentMethod
        usageLimitAction
        standardTokenReplenishmentAmount
        premiumTokenReplenishmentAmount
        superPremiumTokenReplenishmentAmount
        reasoningTokenReplenishmentAmount
        standardCallReplenishmentAmount
        premiumCallReplenishmentAmount
        superPremiumCallReplenishmentAmount
        reasoningCallReplenishmentAmount
        standardTokenUnlimited
        premiumTokenUnlimited
        superPremiumTokenUnlimited
        reasoningTokenUnlimited
        standardCallUnlimited
        premiumCallUnlimited
        superPremiumCallUnlimited
        reasoningCallUnlimited
        createdAt
        updatedAt
        __typename
      }
      nextUsageTierAt
      usageLimitAction
      standardTokensRemaining
      premiumTokensRemaining
      superPremiumTokensRemaining
      reasoningTokensRemaining
      standardCallsRemaining
      premiumCallsRemaining
      superPremiumCallsRemaining
      reasoningCallsRemaining
      standardTokenUnlimited
      premiumTokenUnlimited
      superPremiumTokenUnlimited
      reasoningTokenUnlimited
      standardCallUnlimited
      premiumCallUnlimited
      superPremiumCallUnlimited
      reasoningCallUnlimited
      updatedAt
      __typename
    }
    status
    version
    title
    description
    graphData
    memoryCount
    generatedFromMemoryIds
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateLLMKnowledgeGraphMutationVariables,
  APITypes.UpdateLLMKnowledgeGraphMutation
>;
export const deleteLLMKnowledgeGraph = /* GraphQL */ `mutation DeleteLLMKnowledgeGraph(
  $input: DeleteLLMKnowledgeGraphInput!
  $condition: ModelLLMKnowledgeGraphConditionInput
) {
  deleteLLMKnowledgeGraph(input: $input, condition: $condition) {
    id
    projectId
    customerId
    customer {
      id
      name
      status
      tokensRemaining
      lastCallMadeAt
      numberOfCallsMade
      projectId
      loadSheddingTier
      dataResidency
      createdAt
      enterpriseUser
      tokenReplenishmentAmount
      tokenReplenishmentPeriod
      lastReplenishedAt
      nextReplenishAt
      usageTierId
      usageTier {
        id
        projectId
        status
        name
        description
        version
        activeAt
        inactiveAt
        priorUsageTierId
        priorUsageTier {
          id
          projectId
          status
          name
          description
          version
          activeAt
          inactiveAt
          priorUsageTierId
          baseUsageTierId
          replenishmentPeriod
          replenishmentMethod
          usageLimitAction
          standardTokenReplenishmentAmount
          premiumTokenReplenishmentAmount
          superPremiumTokenReplenishmentAmount
          reasoningTokenReplenishmentAmount
          standardCallReplenishmentAmount
          premiumCallReplenishmentAmount
          superPremiumCallReplenishmentAmount
          reasoningCallReplenishmentAmount
          standardTokenUnlimited
          premiumTokenUnlimited
          superPremiumTokenUnlimited
          reasoningTokenUnlimited
          standardCallUnlimited
          premiumCallUnlimited
          superPremiumCallUnlimited
          reasoningCallUnlimited
          createdAt
          updatedAt
          __typename
        }
        baseUsageTierId
        baseUsageTier {
          id
          projectId
          status
          name
          description
          version
          activeAt
          inactiveAt
          priorUsageTierId
          baseUsageTierId
          replenishmentPeriod
          replenishmentMethod
          usageLimitAction
          standardTokenReplenishmentAmount
          premiumTokenReplenishmentAmount
          superPremiumTokenReplenishmentAmount
          reasoningTokenReplenishmentAmount
          standardCallReplenishmentAmount
          premiumCallReplenishmentAmount
          superPremiumCallReplenishmentAmount
          reasoningCallReplenishmentAmount
          standardTokenUnlimited
          premiumTokenUnlimited
          superPremiumTokenUnlimited
          reasoningTokenUnlimited
          standardCallUnlimited
          premiumCallUnlimited
          superPremiumCallUnlimited
          reasoningCallUnlimited
          createdAt
          updatedAt
          __typename
        }
        replenishmentPeriod
        replenishmentMethod
        usageLimitAction
        standardTokenReplenishmentAmount
        premiumTokenReplenishmentAmount
        superPremiumTokenReplenishmentAmount
        reasoningTokenReplenishmentAmount
        standardCallReplenishmentAmount
        premiumCallReplenishmentAmount
        superPremiumCallReplenishmentAmount
        reasoningCallReplenishmentAmount
        standardTokenUnlimited
        premiumTokenUnlimited
        superPremiumTokenUnlimited
        reasoningTokenUnlimited
        standardCallUnlimited
        premiumCallUnlimited
        superPremiumCallUnlimited
        reasoningCallUnlimited
        createdAt
        updatedAt
        __typename
      }
      nextUsageTierId
      nextUsageTier {
        id
        projectId
        status
        name
        description
        version
        activeAt
        inactiveAt
        priorUsageTierId
        priorUsageTier {
          id
          projectId
          status
          name
          description
          version
          activeAt
          inactiveAt
          priorUsageTierId
          baseUsageTierId
          replenishmentPeriod
          replenishmentMethod
          usageLimitAction
          standardTokenReplenishmentAmount
          premiumTokenReplenishmentAmount
          superPremiumTokenReplenishmentAmount
          reasoningTokenReplenishmentAmount
          standardCallReplenishmentAmount
          premiumCallReplenishmentAmount
          superPremiumCallReplenishmentAmount
          reasoningCallReplenishmentAmount
          standardTokenUnlimited
          premiumTokenUnlimited
          superPremiumTokenUnlimited
          reasoningTokenUnlimited
          standardCallUnlimited
          premiumCallUnlimited
          superPremiumCallUnlimited
          reasoningCallUnlimited
          createdAt
          updatedAt
          __typename
        }
        baseUsageTierId
        baseUsageTier {
          id
          projectId
          status
          name
          description
          version
          activeAt
          inactiveAt
          priorUsageTierId
          baseUsageTierId
          replenishmentPeriod
          replenishmentMethod
          usageLimitAction
          standardTokenReplenishmentAmount
          premiumTokenReplenishmentAmount
          superPremiumTokenReplenishmentAmount
          reasoningTokenReplenishmentAmount
          standardCallReplenishmentAmount
          premiumCallReplenishmentAmount
          superPremiumCallReplenishmentAmount
          reasoningCallReplenishmentAmount
          standardTokenUnlimited
          premiumTokenUnlimited
          superPremiumTokenUnlimited
          reasoningTokenUnlimited
          standardCallUnlimited
          premiumCallUnlimited
          superPremiumCallUnlimited
          reasoningCallUnlimited
          createdAt
          updatedAt
          __typename
        }
        replenishmentPeriod
        replenishmentMethod
        usageLimitAction
        standardTokenReplenishmentAmount
        premiumTokenReplenishmentAmount
        superPremiumTokenReplenishmentAmount
        reasoningTokenReplenishmentAmount
        standardCallReplenishmentAmount
        premiumCallReplenishmentAmount
        superPremiumCallReplenishmentAmount
        reasoningCallReplenishmentAmount
        standardTokenUnlimited
        premiumTokenUnlimited
        superPremiumTokenUnlimited
        reasoningTokenUnlimited
        standardCallUnlimited
        premiumCallUnlimited
        superPremiumCallUnlimited
        reasoningCallUnlimited
        createdAt
        updatedAt
        __typename
      }
      nextUsageTierAt
      usageLimitAction
      standardTokensRemaining
      premiumTokensRemaining
      superPremiumTokensRemaining
      reasoningTokensRemaining
      standardCallsRemaining
      premiumCallsRemaining
      superPremiumCallsRemaining
      reasoningCallsRemaining
      standardTokenUnlimited
      premiumTokenUnlimited
      superPremiumTokenUnlimited
      reasoningTokenUnlimited
      standardCallUnlimited
      premiumCallUnlimited
      superPremiumCallUnlimited
      reasoningCallUnlimited
      updatedAt
      __typename
    }
    status
    version
    title
    description
    graphData
    memoryCount
    generatedFromMemoryIds
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteLLMKnowledgeGraphMutationVariables,
  APITypes.DeleteLLMKnowledgeGraphMutation
>;
export const createLLMAgentValidation = /* GraphQL */ `mutation CreateLLMAgentValidation(
  $input: CreateLLMAgentValidationInput!
  $condition: ModelLLMAgentValidationConditionInput
) {
  createLLMAgentValidation(input: $input, condition: $condition) {
    id
    projectId
    agentId
    name
    description
    operator
    expectedValue
    customPromptTemplate
    status
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateLLMAgentValidationMutationVariables,
  APITypes.CreateLLMAgentValidationMutation
>;
export const updateLLMAgentValidation = /* GraphQL */ `mutation UpdateLLMAgentValidation(
  $input: UpdateLLMAgentValidationInput!
  $condition: ModelLLMAgentValidationConditionInput
) {
  updateLLMAgentValidation(input: $input, condition: $condition) {
    id
    projectId
    agentId
    name
    description
    operator
    expectedValue
    customPromptTemplate
    status
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateLLMAgentValidationMutationVariables,
  APITypes.UpdateLLMAgentValidationMutation
>;
export const deleteLLMAgentValidation = /* GraphQL */ `mutation DeleteLLMAgentValidation(
  $input: DeleteLLMAgentValidationInput!
  $condition: ModelLLMAgentValidationConditionInput
) {
  deleteLLMAgentValidation(input: $input, condition: $condition) {
    id
    projectId
    agentId
    name
    description
    operator
    expectedValue
    customPromptTemplate
    status
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteLLMAgentValidationMutationVariables,
  APITypes.DeleteLLMAgentValidationMutation
>;
